import { TranslationKey } from './fr';

const translationIt: Record<TranslationKey, string> = {
    // metadata
    'metadata.description': 'Il back-office Innovorder',

    // Cookies
    'cookies.banner.message':
        "Il nostro sito web utilizza i cookie per migliorare la tua esperienza. Continuando a navigare, accetti l'utilizzo di questi cookie. Per saperne di più sulla nostra politica sulla privacy e per gestire le tue preferenze sui cookie, consulta la nostra pagina dedicata.",
    'cookies.banner.accept': 'Accetta',
    'cookies.banner.decline': 'Rifiuta',

    // legends
    'legend.DELIVERY': 'Consegna',
    'legend.DRIVE': 'Drive',
    'legend.SIT_IN': 'Sul posto',
    'legend.TAKE_AWAY': 'Da asporto',
    'legend.KIOSK': 'Totem',
    'legend.WEB': 'Ordine online',
    'legend.RECEPTION': 'Reception',
    'legend.POS': 'Cassa',
    'legend.LOYALTY': 'Fedeltà',
    'legend.EWALLET_KIOSK': 'Totem ewallet',
    'legend.VENDING_MACHINE': 'Distributori automatici',

    // analytics page
    'analyticsPage.needBrandSelection': 'Come amministratore, devi selezionare almeno un marchio.',
    'analyticsPage.notAuthorizedToSeeBrand': 'Non sei autorizzato a vedere questo marchio.',
    'analyticsPage.cannotMixEducationAndNonEducationBrands':
        'Non puoi selezionare contemporaneamente marchi di ristorazione collettiva e commerciale.',
    'analyticsPage.reload': 'Aggiorna i dati',
    'beta_banner.message': '👋 Questa è una versione <b>beta</b>, molti miglioramenti/correzioni arriveranno.',
    'analytics.metabaseError': 'Si è verificato un errore, riprova più tardi...',
    'analytics.noAdmin':
        'Purtroppo, IO Analytics non è ancora disponibile in modalità admin... Non preoccuparti, arriverà presto!',
    'analytics.realTime': 'Tempo reale',
    'analytics.ranking': 'Classifica',
    'analytics.products': 'Prodotti',
    'analytics.sales': 'Vendite',
    'analytics.salesSummary': 'Riepilogo finanziario',
    'analytics.demoStaging': 'Demo (Staging)',
    'analytics.attendance': 'Affluenza',
    'analytics.billing': 'Fatturazione',
    'analytics.dashboard': 'Dashboard Metabase',
    'analytics.filter.restaurant': 'Filtra per ristorante',
    'analytics.filter.group': 'Filtra per gruppo',
    'analytics.filter.consumption': 'Modalità di consumo',
    'analytics.filter.channel': 'Canali',
    'analytics.filter.HT': 'Netto',
    'analytics.filter.TTC': 'Lordo',
    'analytics.filter.takeAway': 'Da asporto',
    'analytics.filter.sitIn': 'Sul posto',
    'analytics.filter.delivery': 'Consegna',
    'analytics.filter.drive': 'Drive',
    'analytics.filter.kiosk': 'Totem',
    'analytics.filter.web': 'Ordine online',
    'analytics.filter.pos': 'Cassa',
    'analytics.filter.ubereats': 'Ubereats',
    'analytics.filter.deliveroo': 'Deliveroo',
    'analytics.filter.justeat': 'Justeat',
    'analytics.filter.vendingmachine': 'Distributore automatico',

    // Leaderboard
    'leaderboard.title': 'Classifica dei ristoranti',
    'leaderboard.ranking': 'Posizione',
    'leaderboard.restaurantName': 'Ristoranti',
    'leaderboard.revenue': 'Fatturato',
    'leaderboard.averageBasket': 'Scontrino medio',
    'leaderboard.ordersCount': 'Ordini',
    'leaderboard.RestaurantSearchPlaceholder': 'Cerca un ristorante',

    // Tiles
    'tile.genericErrorMessage': 'Si è verificato un errore!',
    'tile.errorHint': 'Aggiorna i dati',

    // Random
    'random.or': 'o',

    // Tooltip
    'tooltip.example.label': 'Esempio:',

    // Paiement IO Pay Config
    'iopay.configuration.title': 'Parametri Adyen',
    'iopay.commissions.online.title': 'Commissioni online',
    'iopay.commissions.proximity.title': 'Commissioni in prossimità',
    'iopay.form.name': 'Etichetta',
    'iopay.form.placeholder.name': 'Etichetta',
    'iopay.form.accountHolder': 'Identificativo del titolare del conto',
    'iopay.form.placeholder.accountHolder': 'AH111222AAABBB',
    'iopay.form.balanceAccount': 'Identificativo del conto finanziario',
    'iopay.form.placeholder.balanceAccount': 'BA111222AAABBB',
    'iopay.form.storeId': 'Identificativo del venditore',
    'iopay.form.placeholder.storeId': 'Identificativo del venditore',
    'iopay.form.transferInstrumentId': 'Identificativo dello strumento di trasferimento',
    'iopay.form.placeholder.transferInstrumentId': 'SE111222AAABBB',
    'iopay.form.fixOnlineCommissionAmount': 'Importo delle commissioni fisse (in centesimi di euro)',
    'iopay.form.fixProximityCommissionAmount': 'Importo delle commissioni fisse (in centesimi di euro)',
    'iopay.form.placeholder.fixOnlineCommissionAmount': 'Importo delle commissioni fisse (in centesimi di euro)',
    'iopay.form.placeholder.fixProximityCommissionAmount': 'Importo delle commissioni fisse (in centesimi di euro)',
    'iopay.form.variableOnlineCommissionPercent': 'Percentuale delle commissioni variabili',
    'iopay.form.variableProximityCommissionPercent': 'Percentuale delle commissioni variabili',
    'iopay.form.placeholder.variableOnlineCommissionPercent': 'Percentuale delle commissioni variabili',
    'iopay.form.placeholder.variableProximityCommissionPercent': 'Percentuale delle commissioni variabili',

    // Edenred Config
    'edenred.configuration.title': 'Configurazione del modulo Edenred',
    'edenred.form.description':
        "Configura l'integrazione Edenred inserendo le informazioni necessarie. Una volta salvate, il Merchant ID del ristorante verrà recuperato automaticamente.",
    'edenred.form.warning.toSend': "Informazioni salvate e ancora modificabili prima dell'invio a Edenred.",
    'edenred.form.warning.sent': 'In elaborazione da Edenred.',
    'edenred.form.mid': 'Merchant ID',
    'edenred.form.name': 'Nome del ristorante',
    'edenred.form.placeholder.name': 'Il nome del mio ristorante',
    'edenred.form.siret': 'Codice fiscale',
    'edenred.form.placeholder.siret': '12345678900012',
    'edenred.form.address': 'Indirizzo',
    'edenred.form.placeholder.address': 'Via Roma 5',
    'edenred.form.zipCode': 'CAP',
    'edenred.form.placeholder.zipCode': '20100',
    'edenred.form.city': 'Città',
    'edenred.form.placeholder.city': 'Milano',

    // Paygreen Config
    'paygreen.configuration.title': 'Configurazione del modulo per Buoni Pasto',
    'paygreen.form.description':
        'Una volta creato il tuo account tramite il modulo sopra, le chiavi pubbliche e private ti saranno trasmesse per la configurazione del modulo.',
    'paygreen.form.ongoing_v3_migration':
        'Una migrazione della versione di Paygreen è in preparazione, nessuna azione sul backoffice è necessaria da parte tua',
    'paygreen.form.enablePaygreenV3': 'Attiva Paygreen V3',
    'paygreen.form.label': "Nome dell'integrazione",
    'paygreen.form.publicKey': 'V2 Chiave pubblica (shopId)',
    'paygreen.form.privateKey': 'V2 Chiave privata (token)',
    'paygreen.form.secretKey': 'V3 Chiave Segreta',
    'paygreen.form.shopId': 'V3 Shop ID',
    'paygreen.form.subShopId': 'V3 Sotto shop ID (da compilare solo se in modalità marketplace)',
    'paygreen.form.supportsLuncheon': 'Pagamenti con Pass Restaurant (Sodexo) o Chèque Déjeuner (Up)',
    'paygreen.form.supportsSwile': 'Pagamenti con Swile (ex Lunchr)',
    'paygreen.form.supportsRestoflash': 'Pagamenti con Resto Flash',
    'paygreen.form.placeholder.enablePaygreenV3': 'Attiva Paygreen V3',
    'paygreen.form.placeholder.label': "Nome dell'integrazione",
    'paygreen.form.placeholder.publicKey': 'V2 Chiave pubblica (shopId)',
    'paygreen.form.placeholder.privateKey': 'V2 Chiave privata (token)',
    'paygreen.form.placeholder.secretKey': 'V3 Chiave Segreta',
    'paygreen.form.placeholder.shopId': 'V3 Shop ID',
    'paygreen.form.placeholder.subShopId': 'V3 Sotto shop ID (da compilare solo se in modalità marketplace)',
    'paygreen.form.placeholder.supportsLuncheon': 'Pagamenti con Pass Restaurant (Sodexo) o Chèque Déjeuner (Up)',
    'paygreen.form.placeholder.supportsSwile': 'Pagamenti con Swile (ex Lunchr)',
    'paygreen.form.placeholder.supportsRestoflash': 'Pagamenti con Resto Flash',

    // Marketplace Ubereats Config
    'ubereats.title': 'Parametri UberEats',
    'ubereats.description.firstpart':
        "Configura la tua integrazione Ubereats definendo il tuo riferimento UUID disponibile dall'interfaccia Ubereats del tuo ristorante. Se non sai dove trovare questa informazione:",
    'ubereats.description.secondpart': 'Come trovare lo Store ID del mio ristorante?',
    'ubereats.description.thirdpart':
        'Una volta configurata, la tua cassa riceverà automaticamente gli ordini Ubereats nella sezione consegna.',
    'ubereats.storid': 'ID del negozio',
    'ubereats.activestorids': 'Store ID attivo/i',

    // Marketplace Deliverect Config
    'deliverect.title': 'Configurazione del modulo Deliverect',
    'deliverect.subtitle': 'Come configurare la mia integrazione con Deliverect?',
    'deliverect.description.firstpart':
        "Devi prima contattare un account manager per creare un account nell'ambiente Deliverect.",
    'deliverect.description.secondpart':
        "Una volta attivato questo account, la possibilità di attivare l'invio degli ordini sui canali di tua scelta sarà possibile direttamente da questa interfaccia.",
    'deliverect.description.thirdpart':
        "Potrai anche procedere alla sincronizzazione dei tuoi prodotti nell'interfaccia.",
    'deliverect.contact': 'Contatta un account manager',

    // Marketplace Deliveroo config
    'deliveroo.title': 'Configurazione del modulo Deliveroo',
    'deliveroo.subtitle': 'Come configurare la mia integrazione con Deliveroo?',
    'deliveroo.description.firstpart':
        "Devi prima contattare un account manager per creare un account nell'ambiente Deliveroo.",
    'deliveroo.description.secondpart':
        'Una volta configurato questo account, la tua cassa riceverà automaticamente gli ordini Deliveroo nella sezione consegna.',
    'deliveroo.description.thirdpart':
        "Potrai anche procedere alla sincronizzazione dei tuoi prodotti dall'interfaccia Deliveroo.",
    'deliveroo.contact': 'Contatta un account manager',

    // Module Crous Configuration
    'crous.title': 'Configurazione del modulo di sincronizzazione catalogo CROUS',
    'crous.description':
        'Scegli il ristorante di cui vuoi importare il catalogo e inserisci il numero di cassa del CROUS comunicato dal cliente (pos_id)',
    'crous.listcrousrestaurants.label': 'Ristoranti Crous',
    'crous.listcrousrestaurants.placeholder': 'Seleziona un ristorante',
    'crous.numerocaisse.label': 'Numero di cassa del Crous',
    'crous.numerocaisse.placeholder': 'Inserisci il numero di cassa del Crous',
    'crous.apikey.label': 'Chiave API del Crous',
    'crous.apikey.placeholder': 'Inserisci la chiave API del Crous',

    // Marketplace Common config
    'marketplace.vatdefault.placeholder': 'IVA predefinita (%)',
    'marketplace.vatdefault.message': 'IVA predefinita',
    'marketplace.storid.label': 'ID delle tue location:',
    'marketplace.storid.placeholder': 'Indica una / delle location ID',
    'marketplace.storid.unknown': 'ID del negozio sconosciuto',
    'marketplace.storid.alreadyused': 'Questo UUID è già presente ({name})',
    'marketplace.activestorids.label': 'Marchi virtuali attivi:',
    'marketplace.activestorids.emptystate': 'Non hai nessun marchio virtuale attivo',
    'marketplace.location.title': 'Marchio {counter}',
    'marketplace.location.delete': 'Elimina',

    // Status
    'status.status': 'Stato',
    'status.active': 'Attivo',
    'status.inactive': 'Inattivo',
    'status.disabled': 'Non disponibile',
    'status.loading': 'Caricamento',
    'status.unknown': 'Sconosciuto',
    'status.new': 'Nuovo',
    'status.file_uploaded': 'File caricato',
    'status.processing': 'Elaborazione in corso',
    'status.done': 'Completato',
    'status.error': 'Errore',

    // Date
    'date.created': 'Data di creazione',
    'date.updated': 'Data di aggiornamento',

    // External Pos Config
    'external_pos.pos_ref.label': 'ID del POS Deliverect:',
    'external_pos.pos_ref.placeholder': "Indica l'ID del tuo POS Deliverect",
    'external_pos.title': 'Configurazione del POS esterno Deliverect',
    'external_pos.subtitle': 'Come configurare il mio POS esterno Deliverect?',
    'external_pos.description.firstpart':
        "Devi prima contattare un account manager per creare un account nell'ambiente Deliverect.",
    'external_pos.description.secondpart':
        'Una volta configurato il tuo POS esterno Deliverect, riceverà gli ordini effettuati sui canali Innovorder attivati.',
    'external_pos.description.thirdpart':
        'Con questa integrazione, ti consigliamo di gestire e sincronizzare i tuoi menu da Deliverect.',
    'external_pos.contact': 'Contatta un account manager',
    'external_pos.channels.title': 'Integrazione POS esterno Deliverect:',
    'external_pos.channels.subtitle': 'Canali attivi:',

    // Webhook Config
    'webhook_url.label': 'URL del Webhook',
    'webhook_url.placeholder': 'URL del Webhook',
    'webhook_secret.label': 'Chiave segreta del Webhook',
    'webhook_secret.placeholder': 'Indica la chiave segreta del webhook',
    'webhook.headers.label': 'Header HTTP aggiuntivi',
    'webhook.headers.name.placeholder': 'Nome header',
    'webhook.headers.value.placeholder': 'Valore header',
    'webhook.channels.title': 'Canali di attivazione Webhook',
    'webhook.channels.subtitle': 'Canali disponibili:',
    'webhook.title': 'Configurazione del webhook',
    'webhook.firstpart.subtitle': 'Ruolo di questo webhook',
    'webhook.firstpart.description':
        'Il ruolo di questo webhook è notificare che un ordine è stato effettuato da uno dei tuoi clienti su Innovorder.\n' +
        'Se una vendita avviene per un cliente identificato da un badge, viene effettuata una chiamata a questo webhook per inviargli le informazioni necessarie riguardo a questo ordine.',
    'webhook.secondpart.subtitle': 'Come configurare il webhook?',
    'webhook.secondpart.description':
        "È necessario inserire l'URL del webhook.\n" +
        'La chiave segreta del webhook viene generata automaticamente.\n' +
        'Basta cliccare sui canali da attivare per questo webhook.\n' +
        "Una volta configurato, il servizio deve restituire un codice di risposta HTTP 200 con un corpo di risposta vuoto per confermare la ricezione dell'evento webhook.",
    'webhook.documentationLink': 'Consulta la documentazione di questo webhook',
    'webhook.modal.warning': 'Attenzione',
    'webhook.modal.confirmDelete': 'Sei sicuro di voler eliminare?',
    'webhook.channels.kiosk': 'Totem',
    'webhook.channels.web': 'CEL',
    'webhook.channels.pos': 'POS',
    'webhook.channels.trayScan': 'Scansione vassoio',
    'webhook.channels.vendingMachine': 'Distribuzione\nautomatica',
    'webhook.eventTypes.title': 'Tipi di eventi',
    'webhook.eventTypes.subtitle': 'Tipi di eventi disponibili:',
    'webhook.brand.title': 'Configurazione dei webhook',
    'webhook.brand.firstpart.subtitle': 'Ruolo di questo webhook',
    'webhook.brand.firstpart.description':
        'I webhook ti permettono di ricevere notifiche in tempo reale quando si verificano eventi specifici nel tuo sistema Innovorder. Puoi configurare i webhook per essere attivati da diversi eventi come gli aggiornamenti dei dati clienti, gli eventi di transazione o le notifiche degli ordini. Quando si verifica un evento, Innovorder invierà una richiesta HTTP POST al tuo endpoint specificato con i dati pertinenti',
    'webhook.brand.secondpart.subtitle': 'Come configurare il webhook?',
    'webhook.brand.secondpart.description':
        "1. Fornisci l'URL del webhook dove desideri ricevere le notifiche.\n2. Seleziona i tipi di eventi che vuoi monitorare tra le opzioni disponibili.\n3. Scegli i canali dove questi eventi devono attivare il webhook.\n4. Aggiungi header HTTP aggiuntivi se richiesti dal tuo endpoint.\n5. La chiave segreta del webhook viene generata automaticamente per la sicurezza.\n\nIl tuo endpoint deve restituire un codice di stato HTTP 200 per confermare la ricezione dell'evento webhook.",
    'webhook.system.badge': 'Sistema',
    'webhook.system.readonly': 'Questo webhook è gestito dal sistema e non può essere modificato.',

    // Login
    'login.panelTitle': 'Benvenuto nel tuo Backoffice',
    'login.login': 'Accedi',
    'login.password': 'Password',
    'login.ssoChecking': 'Verifica SSO...',
    'login.ssoEnabled': 'SSO abilitato per questa email.',
    'login.ssoLogin': 'Accedi con SSO',
    'login.ssoFailed': 'Accesso SSO fallito. Riprova.',
    'login.ssoLoginRequired': "Questo account richiede l'accesso SSO. Reindirizzamento in corso…",
    'login.noBrandsConfigured': 'Nessun marchio configurato per questo utente.',
    'login.guestBrandLoginFailed': 'Accesso fallito. Riprova.',
    'login.rememberMe': 'Ricordami',
    'login.forgotPassword': 'Password dimenticata?',
    'login.accountLocked': 'Account temporaneamente bloccato. Riprova tra {minutes} minuti.',
    'login.captchaRequired': 'Verifica di sicurezza richiesta.',
    'login.ipNotAllowed': 'Accesso non consentito da questo indirizzo IP.',
    'login.accountDisabled': 'Questo account è stato disattivato per inattività.',

    // Extend account
    'extendAccount.title': 'Estensione del tuo account',
    'extendAccount.loadingBody': 'Verifica del link in corso…',
    'extendAccount.successTitle': 'Account esteso',
    'extendAccount.successBody': 'Il tuo account è stato esteso. Ora puoi accedere di nuovo.',
    'extendAccount.invalidTitle': 'Link non valido',
    'extendAccount.invalidBody': 'Questo link di estensione non è valido o è scaduto.',
    'extendAccount.expiredHint': 'Per recuperare l’accesso al tuo account, contatta il tuo amministratore.',
    'extendAccount.missingTokenBody': 'Il link è incompleto. Apri di nuovo il link dalla tua email.',
    'extendAccount.backToLogin': 'Torna all’accesso',

    // Forgot Password
    'forgotPassword.title': 'Password dimenticata',
    'forgotPassword.subtitle': 'Inserisci la tua email per ricevere un link di reset.',
    'forgotPassword.submit': 'Invia il link',
    'forgotPassword.backToLogin': "Torna all'accesso",
    'forgotPassword.successTitle': 'Email inviata',
    'forgotPassword.successMessage':
        'Se esiste un account per questa email, un link di reset è stato inviato. Controlla la tua casella di posta.',
    'forgotPassword.recaptchaLoading': 'Caricamento reCAPTCHA…',
    'forgotPassword.recaptchaFailed': 'Verifica reCAPTCHA fallita. Riprova.',
    'forgotPassword.recaptchaUnavailable': 'reCAPTCHA non disponibile. Ricarica la pagina e riprova.',
    'forgotPassword.recaptchaNotConfigured':
        "Configurazione mancante (REACT_APP_RECAPTCHA_SITE_KEY). Contatta l'amministratore.",

    // Reset Password
    'resetPassword.title': 'Nuova password',
    'resetPassword.subtitle': 'Scegli una nuova password per il tuo account.',
    'resetPassword.submit': 'Reimposta',
    'resetPassword.backToLogin': "Torna all'accesso",
    'resetPassword.successTitle': 'Password aggiornata',
    'resetPassword.successMessage': 'La tua password è stata aggiornata. Ora puoi accedere.',
    'resetPassword.invalidLinkTitle': 'Link non valido',
    'resetPassword.invalidLink':
        'Questo link di reset non è valido o è scaduto. Richiedine uno nuovo dalla pagina di accesso.',
    'resetPassword.passwordTooShort': 'La password deve contenere almeno {min} caratteri.',
    'resetPassword.passwordsMismatch': 'Le due password non corrispondono.',

    // MFA
    'mfa.verify.title': 'Verifica in due passaggi',
    'mfa.verify.subtitle': 'Inserisci il codice a 6 cifre generato dalla tua app di autenticazione.',
    'mfa.verify.backupTitle': 'Codice di backup',
    'mfa.verify.backupSubtitle': 'Inserisci uno dei tuoi codici di backup monouso.',
    'mfa.verify.submit': 'Verifica',
    'mfa.verify.useBackupInstead': 'Usa un codice di backup',
    'mfa.verify.useTotpInstead': "Usa l'app di autenticazione",
    'mfa.verify.useDifferentMethod': 'Usa un altro metodo',
    'mfa.verify.chooser.title': 'Scegli un metodo',
    'mfa.verify.chooser.subtitle': 'Quale metodo vuoi usare per verificare la tua identità?',
    'mfa.verify.chooser.webauthnHint': 'Usa la tua chiave di sicurezza o la biometria.',
    'mfa.verify.chooser.totpHint': 'Inserisci il codice della tua app di autenticazione.',
    'mfa.verify.failed': 'Codice non valido. Riprova.',
    'mfa.verify.tokenExpired': 'La sessione MFA è scaduta. Effettua di nuovo il login.',
    'mfa.verify.tabs.totp': 'App di autenticazione',
    'mfa.verify.tabs.webauthn': 'Chiave di sicurezza / biometria',
    'mfa.verify.webauthn.title': 'Verifica con la tua chiave di sicurezza',
    'mfa.verify.webauthn.subtitle':
        'Tocca la tua chiave di sicurezza, usa Touch ID o un altro autenticatore della piattaforma.',
    'mfa.verify.webauthn.authenticate': 'Autentica',
    'mfa.verify.webauthn.failed': 'Autenticazione fallita. Prova un altro metodo.',
    'mfa.verify.webauthn.noCredentials': 'Nessuna chiave di sicurezza registrata per questo account.',
    'mfa.verify.webauthn.ceremonyFailed': "L'autenticazione è stata annullata o il browser l'ha rifiutata. Riprova.",
    'mfa.setup.title': "Configura l'autenticazione a due fattori",
    'mfa.setup.subtitle':
        'Scansiona questo codice QR con la tua app di autenticazione (Google Authenticator, 1Password, ecc.) e poi inserisci il codice generato.',
    'mfa.setup.loadingQr': 'Caricamento QR code...',
    'mfa.setup.copySecret': 'Copia la chiave segreta',
    'mfa.setup.copied': 'Copiato!',
    'mfa.setup.confirm': 'Conferma',
    'mfa.setup.invalidCode': "Codice non valido. Verifica la sincronizzazione dell'orologio.",
    'mfa.setup.backupTitle': 'Salva i tuoi codici di backup',
    'mfa.setup.backupSubtitle':
        "Conserva questi codici in un luogo sicuro. Ti permetteranno di accedere se perdi l'accesso alla tua app di autenticazione. Ogni codice può essere usato una sola volta.",
    'mfa.setup.backupAcknowledge': 'Ho salvato i miei codici, continua',
    'mfa.setup.tabs.totp': 'App di autenticazione',
    'mfa.setup.tabs.webauthn': 'Chiave di sicurezza / biometria',
    'mfa.setup.webauthn.title': 'Registra una chiave di sicurezza',
    'mfa.setup.webauthn.subtitle':
        'Usa una chiave hardware (YubiKey), Touch ID, Windows Hello o un altro autenticatore. Puoi nominare questo dispositivo per identificarlo in seguito.',
    'mfa.setup.webauthn.deviceNamePlaceholder': "Nome del dispositivo (es. 'Il mio portatile')",
    'mfa.setup.webauthn.register': 'Registra',
    'mfa.setup.webauthn.ceremonyFailed': "La registrazione è stata annullata o il browser l'ha rifiutata. Riprova.",
    'mfa.setup.webauthn.finalizing': 'Finalizzazione della chiave di sicurezza…',

    // Activate Account
    'activateAccount.title': 'Attivazione account',
    'activateAccount.submit': 'Attiva il mio account',
    'activateAccount.submitting': 'Attivazione in corso...',
    'activateAccount.loading': 'Verifica del token...',
    'activateAccount.resend': 'Reinvia email di attivazione',
    'activateAccount.resending': 'Reinvio in corso...',
    'activateAccount.renewSuccess':
        'Una nuova email di attivazione è stata inviata. Controlla la tua casella di posta.',
    'activateAccount.error.missingToken': 'Token mancante',
    'activateAccount.error.invalidToken': 'Token scaduto',
    'activateAccount.error.password.minLength': 'La password deve contenere almeno {min} caratteri',
    'activateAccount.error.password.maxLength': 'La password non deve superare {max} caratteri',
    'activateAccount.error.password.requireUppercase': 'La password deve contenere almeno una maiuscola',
    'activateAccount.error.password.requireLowercase': 'La password deve contenere almeno una minuscola',
    'activateAccount.error.password.requireNumbers': 'La password deve contenere almeno un numero',
    'activateAccount.error.password.requireSpecialCharacters':
        'La password deve contenere almeno un carattere speciale',
    'activateAccount.password.placeholder': 'Password',
    'activateAccount.confirmPassword.placeholder': 'Conferma password',

    // SideBar
    'sidebar.overview': 'Panoramica',
    'sidebar.orders': 'Ordini',
    'sidebar.customers': 'Clienti',
    'sidebar.brand': 'Marchio',
    'sidebar.brands': 'Marchi',
    'sidebar.restaurants': 'Ristoranti',
    'sidebar.loyalty': 'Fedeltà',
    'sidebar.coupons': 'Codici promo',
    'sidebar.paymentMeans': 'Metodi di pagamento',
    'sidebar.integrations': 'Integrazioni',
    'sidebar.reports': 'Report',
    'sidebar.reportsSales': 'Vendite',
    'sidebar.reportsEwallets': 'Saldi Badge',
    'sidebar.monthly_sales_report': 'Report vendite mensili',
    'sidebar.exports': 'Esportazioni',
    'sidebar.exportsAccounting': 'Contabile',
    'sidebar.exportsEwallets': 'E-wallet',
    'sidebar.exportsSales': 'Riepilogo finanziario',
    'sidebar.salesSummary': 'Riepilogo finanziario',
    'sidebar.exportsPreInvoicing': 'Pre-fatturazione',
    'sidebar.exportsBadge': 'Movimenti dei badge',
    'sidebar.reportGenerationsHistory': 'Cronologia delle generazioni',
    'sidebar.help': 'Hai bisogno di aiuto?',
    'sidebar.languages': 'Lingue',
    'sidebar.account': 'Il mio account',
    'sidebar.media': 'Media',
    'sidebar.marketplaces': 'Marketplace',
    'sidebar.urssaf': 'Minimo Urssaf',
    'sidebar.vatRatesMatrix': 'Riferimento IVA',
    'sidebar.autoBilling': 'Fatturazione automatica',
    'sidebar.logout': 'Disconnetti',
    'sidebar.password': 'La mia password',
    'sidebar.security': 'Sicurezza',
    'security.title': 'Sicurezza',
    'security.loading': 'Caricamento…',
    'security.actions.remove': 'Rimuovi',
    'security.actions.cancel': 'Annulla',
    'security.totp.title': 'App di autenticazione',
    'security.totp.subtitle': 'Codici monouso temporizzati da app come Google Authenticator o 1Password.',
    'security.totp.label': 'App di autenticazione',
    'security.totp.added': 'Aggiunta il {date}',
    'security.totp.empty': 'Nessuna app di autenticazione configurata.',
    'security.totp.add': "Aggiungi un'app di autenticazione",
    'security.totp.modalTitle': "Configura un'app di autenticazione",
    'security.totp.confirmRemove': 'Sei sicuro di voler rimuovere la tua app di autenticazione?',
    'security.passkeys.title': 'Chiavi di sicurezza e passkey',
    'security.passkeys.subtitle':
        'Chiavi hardware, Touch ID, Windows Hello e altri autenticatori registrati per questo account.',
    'security.passkeys.empty': 'Nessuna chiave di sicurezza registrata.',
    'security.passkeys.unnamedDevice': 'Dispositivo senza nome',
    'security.passkeys.lastUsed': 'Ultimo utilizzo: {date}',
    'security.passkeys.added': 'Aggiunta il {date}',
    'security.passkeys.add': 'Aggiungi una passkey',
    'security.passkeys.confirmRemove':
        'Sei sicuro di voler rimuovere questa passkey? Non potrai più usare questo dispositivo per accedere.',
    'security.passkeys.ceremonyFailed': "La registrazione è stata annullata o il browser l'ha rifiutata. Riprova.",
    'security.passkeys.requestFailed': 'Qualcosa è andato storto. Riprova.',
    'security.allowedIps.title': 'Indirizzi IP autorizzati',
    'security.allowedIps.subtitle':
        'Limita il tuo accesso a un elenco di IP o intervalli CIDR. Gli IP autorizzati ignorano anche CAPTCHA e contatori di blocco.',
    'security.allowedIps.empty': 'Nessuna restrizione. Puoi accedere da qualsiasi indirizzo IP.',
    'security.allowedIps.add': 'Aggiungi',
    'security.allowedIps.placeholder': '192.168.1.1 o 10.0.0.0/24',
    'security.allowedIps.invalid': 'Indirizzo IP o intervallo CIDR non valido.',
    'security.allowedIps.confirmRemoveTitle': 'Rimuovere questo indirizzo IP?',
    'security.allowedIps.confirmRemove': 'Questo indirizzo non sarà più autorizzato ad accedere al tuo account.',
    'security.allowedIps.cancel': 'Annulla',
    'security.allowedIps.warning':
        'Attenzione: finché l’elenco contiene almeno una voce, non potrai accedere da un altro IP.',
    'sidebar.billing': 'Il mio spazio fatturazione',
    'sidebar.ioPay': 'Pagamenti',
    'sidebar.news': 'Novità',
    'sidebar.analytics': 'Analytics',

    // Messages
    'message.message': 'Messaggio',

    // Names
    'name.name': 'Nome',
    'name.firstName': 'Nome',
    'name.lastName': 'Cognome',

    // Not found
    'notFound.message': 'Spiacente, pagina non trovata.',
    'notFound.backToHome': 'Torna alla home',
    'permissionDenied.title': 'Accesso negato',
    'permissionDenied.message': 'Siamo spiacenti, ma non hai il permesso di accedere a questa pagina.',
    'permissionDenied.backToHome': 'Torna alla home',

    // Error page
    'errorPage.message':
        'Siamo spiacenti, stiamo riscontrando una difficoltà tecnica. Stiamo facendo tutto il possibile per risolvere questo problema!',
    'errorPage.support': 'Contatta il nostro supporto',

    // Files
    'file.noFile': 'Nessun file',
    'file.cannotProcessJson': 'Il file JSON non può essere elaborato. Verifica il suo formato.',
    'file.fileNotAllowed': 'Questo tipo di file non è consentito. Estensioni consentite: {allowedExtensionsString}',
    'file.fileTemplate': 'modello di file',
    'file.metabaseLink': 'link metabase',

    // File input
    'fileInput.placeholder.title': 'Inserisci i tuoi file!',
    'fileInput.placeholder.drop': 'Rilascia i tuoi file qui!',
    'fileInput.placeholder': 'Trascina e rilascia uno o più file nella finestra',
    'fileInput.browse': 'Importa dal tuo computer',

    // Image input
    'imageInput.section.modal.title': "Aggiungi un'immagine",
    'imageInput.section.modal.resize.label': 'Modalità immagine di sfondo',
    'imageInput.section.modal.resize.details':
        'Usa questa opzione quando invii immagini che verranno utilizzate come sfondo per totem o ordini online.',
    'imageInput.section.library.title': 'Dalla galleria',
    'imageInput.section.upload.title': 'Dal mio computer',

    // Languages
    'languages.fr_FR': 'Francese',
    'languages.en_EN': 'Inglese',
    'languages.it_IT': 'Italiano',
    'languages.sodexo_SODEXO': 'Sodexo',
    'languages.es_ES': 'Spagnolo',
    'languages.zh-CN_ZH-CN': 'Cinese (Semplificato)',
    'languages.zh-TW_ZH-TW': 'Cinese (Tradizionale)',
    'languages.ar_AR': 'Arabo',
    'languages.de_DE': 'Tedesco',

    // UI
    'button.add': 'Aggiungi',
    'button.delete': 'Elimina',
    'button.edit': 'Modifica',
    'button.configure': 'Configura',
    'button.cancel': 'Annulla',
    'button.close': 'Chiudi',
    'button.generate': 'Genera',
    'button.save': 'Salva',
    'button.publish': 'Pubblica',
    'button.saveAndPublish': 'Salva e pubblica',
    'button.uploadFile': 'Carica un file',
    'button.previous': 'Precedente',
    'button.next': 'Successivo',
    'button.ok': 'OK',
    'button.validate': 'Convalida',
    'button.refresh': 'Aggiorna',
    'button.confirm': 'Conferma',
    'button.yes': 'Sì',
    'button.understand': 'Ho capito',
    'button.convertToCrossSell': 'Converti in vendita aggiuntiva',
    'button.convertToCustomization': 'Converti in personalizzazione',
    'button.skipStep': 'Salta questo passaggio',
    'button.block': 'Blocca',
    'button.unblock': 'Sblocca',
    'button.import': 'Importa',
    'select.selectAll': 'Seleziona tutto',
    'switch.activate': 'Attiva',
    'form.preventLeave': 'Hai modifiche non salvate, sei sicuro di voler lasciare questa pagina?',
    'field.required': 'Questo campo è obbligatorio',
    'field.optional': '(opzionale)',
    'field.greaterThanZero': 'Questo campo deve essere maggiore di 0',
    'field.invalidEmail': 'Questa email non è valida',
    'field.invalidURL': 'Questo URL non è valido',
    'field.atLeastOneEventType': 'Deve essere selezionato almeno un tipo di evento',
    'field.unmatchedPassword': 'Le due password devono essere identiche',
    'field.invalidPassword': 'La tua password deve contenere almeno 8 caratteri',
    'field.invalidPhoneNumber': 'Numero di telefono non valido',
    'field.duplicate_email': 'Questa email esiste già',
    'field.duplicate_student_number': 'Questo N° Cliente esiste già',
    'field.duplicate_badge_number': 'Questo N° di badge esiste già',
    'field.minTwo': 'Questo campo deve contenere almeno 2 caratteri',
    'field.ewallet_is_not_null_to_postpayment':
        'Per convertire il cliente in tipo di account post-pagamento, il suo saldo deve obbligatoriamente essere a 0€',
    'select.enabled': 'Abilitato',
    'select.customised': 'Personalizzato',
    'select.disabled': 'Disabilitato',
    'table.search': 'Cerca',
    'table.searchColumn': 'Cerca {name}',
    'table.searchColumn.placeholder': 'Cerca un valore',
    'table.searchColumn.placeholder.from': 'Min',
    'table.searchColumn.placeholder.to': 'Max',
    'table.searchColumn.clearFilter': 'Rimuovi filtri',
    'table.clearAllFilters': 'Rimuovi tutti i filtri',
    'table.rowsPerPage': 'Righe per pagina',
    'table.firstPage': 'Prima',
    'table.lastPage': 'Ultima',
    'table.noRowsAfterFilter': 'Nessun risultato corrisponde alla tua ricerca',
    'table.noRowsAfterFilter.dateRangeHint': "Hai provato a cambiare l'intervallo di date?",
    'table.noRowsAfterFilter.dateRangePresetHint': 'Nessun risultato negli ultimi {days} giorni.',
    'table.noRowsAfterFilter.dateRangeCustomHint': 'Nessun risultato per il periodo selezionato.',
    'table.noRowsAfterFilter.dateRangeAction': "Modifica l'intervallo di date per visualizzare gli ordini.",
    'table.sort': 'Ordina per {name}',
    'table.columnSelection.button': 'Gestione colonne',
    'table.columnSelection.buttonFiltered': 'Gestione colonne ({count})',
    'table.columnSelection.header': 'Filtra le colonne',
    'table.columnSelection.placeholder': 'Cerca una colonna',
    'table.columnSelection.allEntries': 'Tutte le colonne',
    'table.selection.count':
        '{count} riga{count, plural, =1 {} other {he}} selezionata{count, plural, =1 {} other {e}}',
    'table.empty': 'Nessun dato disponibile',
    'pagination.previous': 'Precedente',
    'pagination.next': 'Successivo',
    'navigation.back': 'Indietro',
    'navigation.next': 'Avanti',
    'navigation.disabled': 'Indietro',
    'navigation.backToV1': 'Torna alla vecchia versione',
    'savingBar.changesDone': '{changesCount, plural, =0 {} one {# modifica effettuata} other {# modifiche effettuate}}',
    'ticketLabel.name.mismatch.confirmation':
        "Attenzione, il nome del prodotto è stato modificato, ma l'etichetta di produzione è rimasta la stessa. Confermi questa modifica?",

    // Form
    'form.validation.integer': 'Questo campo deve essere un numero intero',
    'form.validation.positive': 'Questo campo deve essere positivo',
    'form.validation.positiveOrZero': 'Questo campo deve essere positivo o uguale a zero',
    'form.validation.length': 'Questo campo deve contenere {length} caratteri',
    'form.validation.maxLength': 'Questo campo supera la dimensione consentita',
    'form.validation.email': "Questo campo deve essere un'email valida",
    'form.validation.mustMatchValue': 'Questo campo deve essere {value1} o {value2}',
    'form.validation.siret.length': 'Il numero SIRET deve avere una lunghezza di 14 caratteri (senza spazi)',
    'form.validation.siret.invalid': 'Il numero SIRET non è valido',

    // Integrations
    'integrations.section.title': 'Soluzioni di pagamento',
    'integrations.section.subtitle':
        'Le soluzioni di pagamento ti permettono di offrire funzionalità come il pagamento online con carta di credito o su POS nel punto vendita.',
    'integrations.stripe': 'Stripe',
    'integrations.stripeDescription':
        "Integra Stripe nel tuo sito e permetti ai tuoi clienti di collegare facilmente il loro account per un'esperienza di ordine online ottimale.",
    'integrations.configured': 'Configurato',
    'integrations.notConfigured': 'Non configurato',
    'integrations.webhooks.title': 'Webhook',
    'integrations.webhooks.description':
        'Le diverse integrazioni Webhook sono elencate qui. È possibile creare un nuovo Webhook cliccando sul pulsante "+" o modificare un Webhook esistente cliccandoci sopra. Uno stato permette di visualizzare lo stato di configurazione.',

    // Pricing Rule - Placeholder translations (keeping structure)
    'pricingRule.emptyMessage': 'Nessun regime tariffario affiliato a questo marchio.',
    'pricingRule.tableCard.title': 'Regimi tariffari',
    'pricingRule.tableCard.subtitle':
        'I regimi tariffari sono insiemi di una o più ammissioni, sovvenzioni e componenti fuori fatturato.',
    'pricingRule.tableCard.description': `Se il regime tariffario contiene una sovvenzione in % e una sovvenzione in €, posiziona la sovvenzione che deve essere dedotta sull'intero importo dell'ordine in prima posizione. Le sovvenzioni successive porteranno sull'importo restante da pagare, dopo la deduzione delle sovvenzioni posizionate prima.`,
    'pricingRule.tableCard.action': '+ Crea un nuovo regime',
    'pricingRule.code': 'Codice',
    'pricingRule.applyScope': 'Strategia',
    'pricingRule.strategy': 'Strategia',
    'pricingRule.labelTicket': 'Etichetta del ticket',
    'pricingRule.grants_fees.amount': 'Importo',
    'pricingRule.grants_fees.dailyLimit': 'Limite giornaliero',
    'pricingRule.grants': 'Sovvenzioni',
    'pricingRule.entranceFees': 'Ammissioni',
    'pricingRule.excludedTurnover': 'Fuori fatturato',
    'pricingRule.associatedPricingRules': 'Regimi tariffari associati',
    'pricingRule.action': 'Azione',
    'pricingRule.product': 'Parte alimentare',
    'pricingRule.fee': 'Spese incluso diritto di ingresso',
    'pricingRule.modal.warning': 'Attenzione',
    'pricingRule.modal.required': 'Il campo `Regime tariffario` è obbligatorio',
    'pricingRule.modal.confirmDelete': 'Sei sicuro di voler eliminare?',
    'pricingRule.modal.delete.error.detail': 'Questo regime tariffario è collegato a uno o più clienti',
    'pricingRule.modal.unassociatedUser': 'cliente non avrà più un regime tariffario',
    'pricingRule.modal.unassociatedUsers': 'clienti non avranno più un regime tariffario',
    'pricingRule.form.title': 'Regime tariffario',
    'pricingRule.form.description':
        'Configura il regime tariffario raggruppando le sovvenzioni esistenti di tua scelta.',
    'pricingRule.form.creation': 'Creazione di un regime tariffario',
    'pricingRule.form.update': 'Modifica di un regime tariffario',
    'pricingRule.form.pricingRuleCode': 'Codice regime tariffario',
    'pricingRule.form.applyScope': 'Strategia',
    'pricingRule.form.authorizedChannels': 'Canali autorizzati',
    'pricingRule.form.isUrssafEnabled': 'Applicare il minimo URSSAF a questo regime tariffario?',
    'pricingRule.form.composition': 'Definisci la composizione di questo regime tariffario',
    'pricingRule.form.compositionDescription':
        'I regimi tariffari sono insiemi di una o più ammissioni, sovvenzioni e componenti fuori fatturato.',
    'pricingRule.emptyGrant': 'Nessuna sovvenzione associata a questo regime tariffario.',
    'pricingRule.emptyEntranceFee': 'Nessuna ammissione associata a questo regime tariffario.',
    'pricingRule.emptyTurnoverExcluded': 'Nessun componente fuori fatturato associato a questo regime tariffario.',
    'pricingRule.emptyAssociatedPricingRule': 'Nessun regime tariffario associato a questo regime tariffario.',
    'pricingRule.noResult': 'Nessun risultato',
    'pricingRule.addGrant': 'Aggiungi una sovvenzione',
    'pricingRule.addEntranceFee': "Aggiungi un'ammissione",
    'pricingRule.addComponentWithoutTurnover': 'Aggiungi un componente fuori fatturato',
    'pricingRule.addAssociatedPricingRule': 'Aggiungi un regime tariffario associato',
    'pricingRule.search': 'Cerca un regime tariffario',
    'pricingRule.channels.kiosk': 'Totem',
    'pricingRule.channels.pos': 'Cassa',
    'pricingRule.channels.web': 'Ordine online',
    'pricingRule.channels.ewalletKiosk': 'Totem di ricarica',
    'pricingRule.channels.vendingMachine': 'Distribuzione automatica',
    'pricingRule.action.import': 'Importa',
    'pricingRule.action.export': 'Esporta',
    'pricingRule.modal.import.title': 'Importa ammissioni, sovvenzioni e regimi tariffari',
    'pricingRule.modal.import.firstPart': 'Scarica il {fileTemplate} sul tuo computer',
    'pricingRule.modal.import.secondPart':
        'Compila il file modello con le informazioni delle tue ammissioni, sovvenzioni e regimi tariffari da aggiungere o modificare',
    'pricingRule.modal.import.thirdPart': 'Importa il tuo nuovo file cliccando sul pulsante qui sotto',
    'pricingRule.modal.import.warning':
        "L'eliminazione di un'ammissione, sovvenzione o regime tariffario si fa solo dal backoffice Innovorder",
    'pricingRule.modal.import.secondWarning':
        "⚠️\nL'importazione di ammissione o sovvenzione elimina DEFINITIVAMENTE i valori personalizzati.\n(i valori personalizzati per ristorante o per servizio)\n",
    'pricingRule.modal.import.report.title': "Rapporto dell'importazione",
    'pricingRule.modal.import.report.result': "Risultato dell'importazione",
    'pricingRule.modal.import.report.success': 'Successo',
    'pricingRule.modal.import.report.error': 'Fallimento',
    'pricingRule.modal.import.report.warning': 'Avviso',
    'pricingRule.modal.import.report.entranceFees': 'Ammissioni',
    'pricingRule.modal.import.report.grants': 'Sovvenzioni',
    'pricingRule.modal.import.report.pricingRules': 'Regimi tariffari',
    'pricingRule.modal.import.report.successMessage': '• creazione: {created}\n • modifica: {updated}',
    'pricingRule.modal.import.report.errorMessage': '• Riga {line} - {field}: {message}',

    'pricingRule.export.report.entranceFee.entranceFeeId': "Identificativo dell'ammissione",
    'pricingRule.export.report.entranceFee.code': 'Codice ammissione',
    'pricingRule.export.report.entranceFee.labelTicket': 'Etichetta del ticket',
    'pricingRule.export.report.entranceFee.amount': 'Importo (in €)',
    'pricingRule.export.report.entranceFee.dailyLimit': 'Limite giornaliero',
    'pricingRule.export.report.entranceFee.strategy':
        'Strategia (1 per sempre / 2 per limite giornaliero + prodotto interessato)',
    'pricingRule.export.report.entranceFee.vat': 'IVA',
    'pricingRule.export.report.entranceFee.type': 'Fatturato (incluso/escluso)',
    'pricingRule.export.report.entranceFee.type.admissionfee': 'incluso',
    'pricingRule.export.report.entranceFee.type.royaltyfee': 'escluso',
    'pricingRule.export.report.entranceFee.active':
        'Attivo su tutti i ristoranti per impostazione predefinita (sì / no) (non funziona attualmente)',

    'pricingRule.export.report.grant.grantId': 'Identificativo della sovvenzione',
    'pricingRule.export.report.grant.code': 'Codice sovvenzione',
    'pricingRule.export.report.grant.labelTicket': 'Etichetta del ticket',
    'pricingRule.export.report.grant.threshold': 'Soglia di attivazione in € (vuoto se nessuna)',
    'pricingRule.export.report.grant.type': 'Tipo di importo (Assoluto / Percentuale)',
    'pricingRule.export.report.grant.type.absolute': 'Assoluto',
    'pricingRule.export.report.grant.type.rate': 'Percentuale',
    'pricingRule.export.report.grant.ceiling': 'Tetto della sovvenzione in € (obbligatorio se tipo = Percentuale)',
    'pricingRule.export.report.grant.amount': 'Importo (in €)',
    'pricingRule.export.report.grant.dailyLimit': 'Limite giornaliero',
    'pricingRule.export.report.grant.strategy':
        'Strategia (1 per limite giornaliero + importo / 2 per limite giornaliero + importo + prodotti interessati)',
    'pricingRule.export.report.grant.tag': 'Tag (vuoto se nessuna applicazione su tag)',
    'pricingRule.export.report.grant.active': 'Attivo su tutti i ristoranti per impostazione predefinita (sì / no)',

    'pricingRule.export.report.pricingRule.pricingRuleId': 'Identificativo del regime tariffario',
    'pricingRule.export.report.pricingRule.code': 'Codice regime tariffario',
    'pricingRule.export.report.pricingRule.canals':
        'Canali (cassa, totem di ricarica, distribuzione automatica, totem e/o ordine online)',
    'pricingRule.export.report.pricingRule.isUrssafEnabled':
        "Applicare il minimo URSSAF (solo per l'API carrello)? (sì/no)",
    'pricingRule.export.report.pricingRule.entranceFees':
        'Ammissione/i inclusa/e (indicare il codice e se più di una, separare con virgola + spazio)',
    'pricingRule.export.report.pricingRule.grants':
        'Sovvenzione/i inclusa/e (indicare il codice e se più di una, separare con virgola + spazio)',
    'pricingRule.export.report.pricingRule.includeCA': 'Fuori fatturato inclusi',
    'pricingRule.export.report.pricingRule.applyScope':
        'Strategia (spese incluso diritto di ingresso e/o parte alimentare)',
    'pricingRule.export.report.pricingRule.applyScope.product': 'parte alimentare',
    'pricingRule.export.report.pricingRule.applyScope.fee': 'spese incluso diritto di ingresso',

    // EntranceFee
    'entranceFee.create': "Creazione di un'ammissione",
    'entranceFee.title': 'Ammissione',
    'entranceFee.description': "Indica il nome, l'importo e le regole dell'ammissione per tutti i tuoi stabilimenti.",
    'entranceFee.customUse': "Applicazioni particolari dell'ammissione",
    'entranceFee.descCustomUse': "Attivazione e personalizzazione per ristorante dell'ammissione",
    'entranceFee.warningForm': `Compila bene tutti i campi della tua ammissione prima di attivarla sui tuoi ristoranti.`,
    'entranceFee.default': 'Predefinito',
    'entranceFee.code': 'Codice ammissione',
    'entranceFee.codeAlreadyUsed': 'Codice ammissione già utilizzato',
    'entranceFee.labelTicket': 'Etichetta del ticket',
    'entranceFee.amount': 'Importo',
    'entranceFee.vat': 'IVA',
    'entranceFee.strategy': 'Strategia',
    'entranceFee.dailyLimit': 'Limite giornaliero',
    'entranceFee.type': 'Fatturato',
    'entranceFee.select.always': 'Limite giornaliero',
    'entranceFee.select.daily': 'Limite giornaliero + prodotto interessato',
    'entranceFee.select.salesExcluded': 'Escluso',
    'entranceFee.select.salesIncluded': 'Incluso',
    'entranceFee.emptyMessage': 'Nessuna spesa di ammissione affiliata a questo marchio.',
    'entranceFee.table.state': 'Stato di attivazione',
    'entranceFee.table.services': 'Servizi attivati',
    'entranceFee.table.state.enabled': 'Attivato',
    'entranceFee.table.state.customised': 'Attivato con valori personalizzati',
    'entranceFee.table.state.disabled': 'Disattivato',
    'entranceFee.tableCard.title': 'Ammissioni',
    'entranceFee.tableCard.subtitle': 'Crea e gestisci le diverse spese di ammissione utilizzate nei tuoi ristoranti',
    'entranceFee.tableCard.action': '+ Crea una nuova ammissione',
    'entranceFee.restaurants': 'Ristoranti',
    'entranceFee.restaurant': 'Ristorante',
    'entranceFee.action': 'Azione',
    'entranceFee.modal.warning': 'Attenzione',
    'entranceFee.modal.confirmDelete': 'Sei sicuro di voler eliminare?',
    'entranceFee.search': "Cerca un'ammissione",

    'entranceFee.configuration.title': `Applicazione particolare di ammissione - {name}`,
    'entranceFee.configuration.header.title': 'Gestisci i servizi di questo ristorante',
    'entranceFee.configuration.search': 'Cerca un servizio',
    'entranceFee.configuration.table.activation': 'Attivazione',
    'entranceFee.configuration.table.name': 'Nome del servizio',
    'entranceFee.configuration.table.time': 'Orari',
    'entranceFee.configuration.table.days': 'Periodo',
    'entranceFee.configuration.table.amount': 'Importo',
    'entranceFee.configuration.table.vat': 'IVA',
    'entranceFee.configuration.table.defaultShift': 'Servizio predefinito',

    'entranceFee.warningShifts.title': 'Conferma della modifica',
    'entranceFee.warningShifts.shift': 'Servizio: {time} - Importo: {amount} - Differenza: {variation}',
    'entranceFee.warningShifts.shift.amount': "\nImporto dell'ammissione: {amount}",
    'entranceFee.warningShifts.confirm': 'Sei sicuro di voler continuare?',

    // Grant
    'grant.create': 'Creazione di una sovvenzione',
    'grant.title': 'Sovvenzione',
    'grant.description':
        "Indica l'importo e le regole di applicazione della sovvenzione per tutti i tuoi stabilimenti.",
    'grant.description.title1': 'Strategia 1: Limite giornaliero + importo',
    'grant.customUse': 'Applicazioni particolari della sovvenzione',
    'grant.descCustomUse': 'Attivazione e personalizzazione per ristorante della sovvenzione',
    'grant.warningLimit':
        '⚠️ Il limite giornaliero personalizzato non può essere superiore a quello definito per impostazione predefinita.',
    'grant.warningForm': `Compila bene tutti i campi della tua sovvenzione prima di attivarla sui tuoi ristoranti.`,
    'grant.desc1': `La sovvenzione si applica su tutti i prodotti del carrello rispettando le seguenti regole:
        Se viene definita una soglia, solo l'importo del carrello superiore alla soglia viene interessato.
        Se viene definito un tetto, l'importo della sovvenzione non potrà superare questo importo.
        Se viene definito un tag, solo i prodotti con questo tag saranno interessati dalla sovvenzione.
        `,
    'grant.description.title2': 'Strategia 2: Limite giornaliero + importo + prodotti interessati',
    'grant.desc2': `La sovvenzione si applica seguendo le stesse regole sopra, ma in più:
    Se la sovvenzione è in %, solo i prodotti indicati come sovvenzionabili saranno interessati.
    Se la sovvenzione è in €, si attiva solo se il carrello contiene almeno 1 prodotto indicato come sovvenzionabile.`,
    'grant.amount': 'Importo',
    'grant.default': 'Predefinito',
    'grant.code': 'Codice sovvenzione',
    'grant.codeAlreadyUsed': 'Codice sovvenzione già utilizzato',
    'grant.strategy': 'Strategia',
    'grant.dailyLimit': 'Limite giornaliero',
    'grant.type': 'Tipo di importo',
    'grant.tags': 'Applica solo ai prodotti con il seguente tag:',
    'grant.tags.placeholder': 'SUB1, SUB2',
    'grant.labelTicket': 'Etichetta del ticket',
    'grant.select.rate': 'Percentuale',
    'grant.select.absolute': 'Assoluto',
    'grant.select.minimum': 'Limite giornaliero + importo',
    'grant.select.minimumAndProduct': 'Limite giornaliero + importo minimo + prodotti interessati',
    'grant.threshold': 'Soglia di attivazione',
    'grant.ceiling': 'Tetto della sovvenzione',
    'grant.restaurants': 'Ristoranti',
    'grant.action': 'Azione',
    'grant.emptyMessage': 'Nessuna sovvenzione affiliata a questo marchio.',
    'grant.tableCard.title': 'Sovvenzioni',
    'grant.tableCard.subtitle': 'Crea e gestisci le diverse sovvenzioni utilizzate nei tuoi ristoranti',
    'grant.tableCard.action': '+ Aggiungi una nuova sovvenzione',
    'grant.settings.button': 'Impostazioni',
    'grant.settings.modal.title': 'Impostazioni delle sovvenzioni',
    'grant.settings.modal.subtitle': 'Configura le regole applicabili alle sovvenzioni del tuo brand.',
    'grant.settings.modal.toggle.label': 'Blocca il pagamento con buoni pasto quando è applicata una sovvenzione',
    'grant.settings.modal.toggle.description':
        'Se attivata, i metodi di pagamento con buoni pasto (Edenred, Paygreen) saranno indisponibili per gli utenti con una sovvenzione nel carrello, sull’ordinazione online (CELV2).',
    'grant.settings.modal.cancel': 'Annulla',
    'grant.settings.modal.save': 'Salva',
    'grant.table.enabled': 'Attiva',
    'grant.table.state': 'Stato di attivazione',
    'grant.table.services': 'Servizi attivati',
    'grant.table.state.enabled': 'Attivato',
    'grant.table.state.customised': 'Attivato con valori personalizzati',
    'grant.table.state.disabled': 'Disattivato',
    'grant.table.restaurant': 'Ristorante',
    'grant.table.threshold': 'Attivazione',
    'grant.table.ceiling': 'Tetto',
    'grant.table.dailyLimit': 'Limite giornaliero',
    'grant.table.strategy': 'Strategia',
    'grant.table.action': 'Azione',
    'grant.modal.warning': 'Attenzione',
    'grant.modal.confirmDelete': 'Sei sicuro di voler eliminare?',
    'grant.search': 'Cerca una sovvenzione',

    'grant.configuration.title': 'Applicazione particolare di sovvenzione - {name}',
    'grant.configuration.header.title': 'Gestisci i servizi di questo ristorante',
    'grant.configuration.search': 'Cerca un servizio',
    'grant.configuration.table.activation': 'Attivazione',
    'grant.configuration.table.name': 'Nome del servizio',
    'grant.configuration.table.time': 'Orari',
    'grant.configuration.table.days': 'Periodo',
    'grant.configuration.table.amount': 'Importo',
    'grant.configuration.table.threshold': 'Attivazione',
    'grant.configuration.table.ceiling': 'Tetto',
    'grant.configuration.table.defaultShift': 'Servizio predefinito',

    'grant.warningShifts.title': 'Conferma della modifica',
    'grant.warningShifts.shift': '{time} - Importo: {amount} - Differenza: {variation}',
    'grant.warningShifts.shift.amount': '\nImporto della sovvenzione: {amount}',
    'grant.warningShifts.confirm': 'Sei sicuro di voler continuare?',

    // Groups
    'group.tableCard.title': 'Gruppi',
    'group.tableCard.action': '+ Crea un nuovo gruppo',
    'group.tableCard.subtitle':
        'Definisci le possibilità di raggruppamento dei tuoi clienti per gruppo e associa i diversi regimi tariffari.',
    'group.tableCard.subtitle2': 'Definisci qui le diverse possibilità di organizzazione dei tuoi clienti.',
    'group.emptyMessage': 'Nessun gruppo affiliato a questo marchio.',
    'group.name': 'Gruppo',
    'group.action': 'Azione',
    'group.pricingRules': 'Regimi tariffari',
    'group.guestsCount': 'Numero di cliente/i',
    'group.guestsCountLabel': 'cliente/i',
    'group.modal.warning': 'Attenzione',
    'group.modal.confirmDelete': 'Sei sicuro di voler eliminare?',
    'group.modal.deleteError': 'Non puoi eliminare questo gruppo.',
    'group.modal.deleteErrorReason': 'Disassocia il/i cliente/i associato/i per finalizzare questa eliminazione.',
    'group.warning.group_name_already_exist.message': 'Il nome del gruppo esiste già.',
    'group.warning.group_name_already_exist.description':
        'Proponi un nuovo nome di gruppo o associa il/i regime/i tariffario/i selezionato/i al gruppo già esistente.',
    'group.warning.pricing_rule_is_always_assigned_to_a_guest_in_this_group.message':
        'Uno o più regimi tariffari che desideri disassociare dal gruppo corrente sono assegnati a clienti esistenti.',
    'group.warning.pricing_rule_is_always_assigned_to_a_guest_in_this_group.description':
        'Disassocia questo o questi regimi tariffari dai clienti esistenti prima di poterli rimuovere dalla lista dei regimi tariffari disponibili per il gruppo',
    'group.modal.import.title': 'Importa Gruppi, Sezioni, Sottosezioni e Regimi Tariffari',
    'group.modal.import.firstPart': 'Scarica il {fileTemplate} sul tuo computer',
    'group.modal.import.secondPart':
        'Compila il file modello con le informazioni dei tuoi gruppi, sezioni, sottosezioni e regimi tariffari da aggiungere o modificare',
    'group.modal.import.thirdPart': 'Importa il tuo nuovo file cliccando sul pulsante qui sotto',
    'group.modal.import.warning':
        "L'eliminazione di gruppi, sezioni, sottosezioni e regimi tariffari si fa solo dal backoffice Innovorder",
    'group.modal.import.report.title': "Rapporto dell'importazione",
    'group.export.group': 'Gruppo',
    'group.export.section': 'Sezione',
    'group.export.subsection': 'Sottosezione',
    'group.export.pricingRule': 'Regime/i tariffario/i associato/i',
    'group.modal.conflict.error.message': 'Non puoi modificare questo gruppo',
    'group.modal.conflict.error.description': 'Riassegna il/i cliente/i prima di modificare questo gruppo',
    'group.modal.conflict.export.button': 'Esporta i clienti',
    'group.modal.import.report.groups': 'Gruppi',
    'group.modal.import.report.sections': 'Sezioni',
    'group.modal.import.report.subsections': 'Sottosezioni',
    'group.modal.import.report.successMessage': '• creazione: {created}\n • modifica: {updated}',
    'group.modal.import.report.errorMessage': '• Riga {line} - colonna {field}: {message}',
    'group.delete.modal.conflict.error.message': 'Non puoi eliminare questo gruppo',
    'group.delete.modal.conflict.error.description': 'Riassegna il/i cliente/i prima di eliminare questo gruppo',
    'group.delete.modal.conflict.export.button': 'Esporta i clienti',

    'groups.export.student.customerId': 'Identificativo Cliente',
    'groups.export.student.email': 'Email',
    'groups.export.student.password': 'Password',
    'groups.export.student.firstName': 'Nome',
    'groups.export.student.lastName': 'Cognome',
    'groups.export.student.phone': 'Telefono',
    'groups.export.student.piCode': 'Codice PIN',
    'groups.export.student.badgeNumber': 'N° badge',
    'groups.export.student.studentNumber': 'N° cliente',
    'groups.export.student.group': 'Gruppo',
    'groups.export.student.section': 'Sezione',
    'groups.export.student.subSection': 'Sottosezione',
    'groups.export.student.accountType': 'Tipo di account',
    'groups.export.student.tariffCode': 'Codice tariffa',
    'groups.export.student.grantCode': 'Codice sovvenzione',
    'groups.export.student.entranceFeeCode': 'Codice ammissione',
    'groups.export.student.pricingRuleCode': 'Regime tariffario',
    'groups.export.student.ewalletOverdraftAmount': 'Importo scoperto personalizzato',
    'groups.export.student.exitDate': 'Data di archiviazione',
    'groups.export.student.accessFrom': 'Data di arrivo',
    'groups.export.student.accessUntil': 'Data di partenza',
    'groups.export.student.inactive': 'Inattivo',
    'groups.export.student.active': 'Attivo',
    'groups.export.student.yes': 'Sì',
    'groups.export.student.no': 'No',

    // Sections
    'section.tableCard.title': 'Sezioni',
    'section.tableCard.subtitle':
        'Definisci le possibilità di raggruppamento dei tuoi clienti per sezione e associa i diversi regimi tariffari.',
    'section.tableCard.action': '+ Crea una nuova sezione',
    'section.name': 'Sezione',
    'group.warning.section_name_already_exist.message': 'Il nome della sezione esiste già.',
    'group.warning.section_name_already_exist.description':
        'Proponi un nuovo nome di sezione o associa il/i regime/i tariffario/i selezionato/i alla sezione già esistente.',
    'section.modal.conflict.error.message': 'Non puoi modificare questa sezione',
    'section.modal.conflict.error.description': 'Riassegna il/i cliente/i prima di modificare questa sezione',
    'section.delete.modal.conflict.error.message': 'Non puoi eliminare questa sezione',
    'section.delete.modal.conflict.error.description': 'Riassegna il/i cliente/i prima di eliminare questa sezione',

    // SubSections
    'subsection.tableCard.title': 'Sottosezioni',
    'subsection.tableCard.subtitle':
        'Definisci le possibilità di raggruppamento dei tuoi clienti per sottosezione e associa i diversi regimi tariffari.',
    'subsection.tableCard.action': '+ Crea una nuova sottosezione',
    'subsection.name': 'Sottosezione',
    'group.warning.sub_section_name_already_exist.message': 'Il nome della sottosezione esiste già.',
    'group.warning.sub_section_name_already_exist.description':
        'Proponi un nuovo nome di sottosezione o associa il/i regime/i tariffario/i selezionato/i alla sottosezione già esistente.',
    'subsection.modal.conflict.error.message': 'Non puoi modificare questa sottosezione',
    'subsection.modal.conflict.error.description': 'Riassegna il/i cliente/i prima di modificare questa sottosezione',
    'subsection.delete.modal.conflict.error.message': 'Non puoi eliminare questa sottosezione',
    'subsection.delete.modal.conflict.error.description':
        'Riassegna il/i cliente/i prima di eliminare questa sottosezione',

    // options
    'options.main': 'Generale',
    'options.educationMode': 'Ristorazione collettiva',
    'options.birthdate': 'Data di compleanno',
    'options.tripAdvisorUsername': 'Nome utente TripAdvisor',
    'options.advancedSecurityRules': 'Attiva password 12 caratteri',
    'options.optIn': 'Opt-in',
    'options.productionDeclaration': 'Dichiarazione di produzione',
    'options.grantsAndEntranceFee': 'Sovvenzioni e ammissioni',
    'options.pinCodeDoubleAuth': "Usa un codice PIN per proteggere l'autenticazione sul totem",
    'options.charlemagneExport': 'Esporta dati per Charlemagne',
    'options.handleBadgeForChar': 'Gestisci solo gli ultimi 4 caratteri nelle ricerche badge',
    'options.autoBilling': 'Attiva il modulo di "fatturazione automatica"',
    'options.linkProductImageBySku':
        "Collega automaticamente le immagini i cui nomi contengono gli SKU dei prodotti (durante l'importazione)",
    'options.externalIdsMapping': 'Attiva la traduzione degli ID',
    'options.ewalletAutoReload': 'Attiva E-wallet autoreloader (via Stripe)',
    'options.foodCourt': 'CEL v2 - Food Court',
    'options.foodCourtMode': 'Attiva la modalità food court',
    'options.shuffleRestaurants': `Rendi casuale l'ordine di visualizzazione dei ristoranti`,
    'options.enableSodexoDictionary': 'Attiva il dizionario Sodexo',
    'options.enableOrderDetailV2': 'Attiva order detail V2',
    'options.usePickupPoints': 'Attiva i punti di ritiro',
    'options.linkProductSkuToExternalMapping': 'Collega automaticamente gli SKU dei prodotti alla traduzione degli ID',
    'options.linkStudentNumberToExternalMapping': 'Collega automaticamente il numero cliente alla traduzione degli ID',
    'options.multiRestaurant': 'Totem - Multi Ristorante',
    'options.multiRestaurantMode': 'Attiva la modalità multi-ristorante',
    'options.multiRestaurantModeMainRestaurant': 'Ristorante Principale',
    'options.multiRestaurantModeMainUser': 'Utente Totem',
    'options.multiRestaurantModeAssignedRestaurants': 'Ristoranti assegnati',
    'options.enableLinkingMenuToPosAndWeb': "Permetti l'associazione del menu con una cassa e il Web",
    'options.configureSodexoConsumerTransaction': 'Attiva i webhook Sodexo consumerTransactions',
    'options.families': 'Famiglie',
    'options.families.empty': 'Nessuna famiglia',
    'options.families.new': 'Nuova famiglia',
    'options.families.namePlaceholder': 'Nome',
    'options.families.add': 'Aggiungi',
    'options.families.delete': 'Elimina',
    'options.families.deleteTitle': 'Conferma eliminazione della famiglia {name}',
    'options.families.deleteConfirmation': 'Sei sicuro di voler eliminare la famiglia "{name}"?',

    // Brand Info
    'brandInfo.title': 'Informazioni',
    'brandInfo.ewalletOverdraft.title': 'Scoperto E-wallet',
    'brandInfo.ewalletOverdraft.description':
        "Permetti ai clienti di avere un saldo negativo sul loro e-wallet fino all'importo specificato.",
    'brandInfo.ewalletOverdraft.enable': 'Attiva lo scoperto e-wallet',
    'brandInfo.ewalletOverdraft.amount': 'Importo massimo dello scoperto',
    'brandInfo.ewalletOverdraft.amountPlaceholder': '0,00',
    'brandInfo.ewalletOverdraft.cannotDisable':
        'Impossibile disattivare lo scoperto: {count} cliente/i hanno attualmente il post-pagamento attivato.',

    // Restaurant
    'restaurant.search': 'Cerca un ristorante',
    'restaurant.name': 'Nome del ristorante',
    'restaurant.options.main': 'Generale',
    'restaurant.options.includeDepositsInTurnover': 'Contabilizza i depositi nel fatturato',

    // admin banner
    'adminBanner.message': 'Sei connesso come',
    'adminBanner.backToAdmin': 'Torna ad amministratore',

    // auto billing - placeholder (file too large, continuing with remaining keys)
    'auto.billing.buttons.referential': 'Riferimento',
    'auto.billing.buttons.billing': 'Richiesta di fatturazione',
    'auto.billing.request.card.title': 'Richiesta di fatturazione',
    'auto.billing.request.card.subtitle':
        'Il modulo di fatturazione automatica permette di raggruppare tutti i consumi dei clienti assegnati a un terzo per calcolare (secondo le regole configurate) il fatturato e il percepito di ogni terzo.',
    'auto.billing.request.wizard.validate': 'Termina',
    'auto.billing.request.wizard.title': 'Effettua una richiesta di fatturazione',
    'auto.billing.request.card.action': 'Effettua una richiesta di fatturazione',
    'auto.billing.request.popup.confirm.title': 'Stai per richiedere una fatturazione automatica',
    'auto.billing.request.popup.confirm.text': 'Puoi confermare questa azione?',
    'auto.billing.request.popup.success.title': 'La tua richiesta di fatturazione è stata convalidata',
    'auto.billing.request.popup.fail.title': 'Errore',
    'auto.billing.request.popup.pending.title': 'Elaborazione in corso...',
    'auto.billing.request.popup.success.cancel': 'Chiudi',
    'auto.billing.request.popup.success.text': 'Hai effettuato con successo la tua richiesta di fatturazione',
    'auto.billing.request.popup.fail.text': 'Si è verificato un errore, riprova più tardi',
    'auto.billing.request.preview.emptyMessage': 'Nessuna vendita durante il periodo selezionato',
    'auto.billing.request.preview.errorUndefinedReferential': 'Nessun riferimento definito per il marchio',
    'auto.billing.request.preview.error': 'Si è verificato un errore, riprova più tardi',
    'auto.billing.request.preview.code': 'Codice',
    'auto.billing.request.preview.label': 'Designazione',
    'auto.billing.request.preview.quantity': 'QTÀ',
    'auto.billing.request.preview.unitPriceWithTaxExcluded': 'Prezzo Unitario Netto',
    'auto.billing.request.preview.totalPriceWithTaxExcluded': 'Importo Netto',
    'auto.billing.request.preview.totalTax': 'Importo IVA',
    'auto.billing.request.preview.totalPriceWithTaxIncluded': 'Importo Lordo',
    'auto.billing.request.preview.cdpf': 'CDPF emittente',
    'auto.billing.request.preview.clientCode': 'Codice cliente',
    'auto.billing.request.preview.clientLabel': 'Etichetta cliente',
    'auto.billing.request.preview.billingPeriod': 'Periodo di fatturazione',
    'auto.billing.request.preview.billingPeriod.from': 'Dal',
    'auto.billing.request.preview.billingPeriod.to': 'al',
    'auto.billing.request.preview.invoiceSelector.GROUP': 'Gruppo',
    'auto.billing.request.preview.invoiceSelector.ACCOUNT_PAYMENT_TYPE': 'Tipo di account',
    'auto.billing.request.preview.invoiceSelector.PRICING_RULE': 'Regime tariffario',
    'auto.billing.request.preview.total.amountWithTaxIncluded': 'Totale Lordo',
    'auto.billing.request.preview.total.amountWithTaxExcluded': 'Totale importo Netto',
    'auto.billing.request.preview.total.tax': 'Totale IVA',
    'auto.billing.request.filter.title': 'Filtri',
    'auto.billing.request.filter.entities.title': 'SCELTA DELLE ENTITÀ DI FATTURAZIONE',
    'auto.billing.request.filter.entities.all': 'Tutte le entità',
    'auto.billing.request.filter.restaurants.title': 'SCELTA DEI RISTORANTI',
    'auto.billing.request.filter.dropDown.errorMessage': "Devi scegliere almeno un'opzione",
    'auto.billing.request.filter.restaurants.all': 'Tutti i ristoranti',
    'auto.billing.request.filter.pricingRules.title': 'PROFILO TARIFFARIO',
    'auto.billing.request.filter.pricingRules.all': 'Tutti i regimi tariffari',
    'auto.billing.request.filter.pricingRules.noPricingRules': 'Nessun regime tariffario',
    'auto.billing.request.accountPaymentTypes.title': 'MODALITÀ DI GESTIONE',
    'auto.billing.request.filter.accountPaymentTypes.all': 'Tutte le modalità di gestione',
    'auto.billing.request.accountPaymentTypes.CASH': 'Contanti',
    'auto.billing.request.accountPaymentTypes.PREPAYMENT': 'Pre-pagamento',
    'auto.billing.request.accountPaymentTypes.POSTPAYMENT': 'Post-pagamento',
    'auto.billing.request.history.table.emptyMessage': 'Nessuna richiesta di fatturazione effettuata',
    'auto.billing.request.history.table.date': 'Data di generazione',
    'auto.billing.request.history.table.period': 'Periodo',
    'auto.billing.request.history.table.user': 'Utente',
    'auto.billing.request.history.table.previewButton': 'Anteprima',
    'auto.billing.request.history.table.downloadButton': 'Scarica',
    'auto.billing.referential.serviceCodes.card.title': 'Codici prestazione',
    'auto.billing.referential.serviceCodes.card.subtitle': ' ',
    'auto.billing.referential.billingEntities.card.title': 'Entità di fatturazione',
    'auto.billing.referential.billingEntities.card.subtitle': ' ',
    'auto.billing.referential.billingEntities.add': "+ Aggiungi un'entità",
    'auto.billing.referential.billingEntities.form.create.title': "Creazione dell'entità di fatturazione",
    'auto.billing.referential.billingEntities.form.create.subtitle': ' ',
    'auto.billing.referential.billingEntities.costCompute.title': 'Modalità di calcolo',
    'auto.billing.referential.billingEntities.costCompute.subtitle': ' ',
    'auto.billing.referential.billingEntities.table.label': 'Etichetta',
    'auto.billing.referential.billingEntities.table.code': 'Codice',
    'auto.billing.referential.billingEntities.table.groups': 'Gruppi associati',
    'auto.billing.referential.billingEntities.table.groupingBy': 'Ripartizione',
    'auto.billing.referential.billingEntities.table.emptyMessage':
        'Nessuna entità di fatturazione definita per questo marchio',
    'auto.billing.referential.billingEntities.form.label.title': 'ETICHETTA',
    'auto.billing.referential.billingEntities.form.code.title': 'CODICE',
    'auto.billing.referential.billingEntities.form.code.text': 'CODICE',
    'auto.billing.referential.billingEntities.form.groups.text': 'TARGET',
    'auto.billing.referential.billingEntities.form.groupingBy.title': 'TIPO DI RIPARTIZIONE',
    'auto.billing.referential.billingEntities.form.label.subtitle': "Creazione dell'entità di fatturazione",
    'auto.billing.referential.billingEntities.form.groupingBy.options.PRICING_RULE': 'Regime tariffario',
    'auto.billing.referential.billingEntities.form.groupingBy.options.BILLING_ENTITY': 'Senza ripartizione',
    'auto.billing.referential.billingEntities.form.groupingBy.options.GROUP': 'Gruppo',
    'auto.billing.referential.billingEntities.form.groupingBy.options.ACCOUNT_PAYMENT_TYPE': 'Modalità di Gestione',
    'auto.billing.referential.billingEntities.errors.duplicate.code':
        "Il codice {code} è già associato all'entità di fatturazione {entity}",
    'auto.billing.referential.billingEntities.errors.duplicate.group':
        "l'entità di fatturazione {entity} ha già come gruppo/i: {groups}",
    'auto.billing.referential.serviceCodes.perceivedAmountCode.label': 'PERCEPITO PER CONTO',
    'auto.billing.referential.serviceCodes.admissionLevelCostCode.label': 'FATTURAZIONE PER FASCIA DI AMMISSIONE',
    'auto.billing.referential.serviceCodes.fixedCostCode.label': 'FATTURAZIONE IN MASSA DI COSTI FISSI',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.card.title': 'Percepito per conto',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.code.label': 'Codice',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.vat.label': 'IVA',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.add': '+ Aggiungi un codice',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.emptyMessage': 'Nessun codice inserito',
    'auto.billing.referential.accountingCostCompute.constantCost': 'Fatturazione per massa di costi fissi',
    'auto.billing.referential.accountingCostCompute.partitionedConstantCost': 'Fatturazione per fascia',
    'auto.billing.referential.accountingCostCompute.summedUpByAdmissionFeesAmount': 'Fatturazione a coperto',
    'auto.billing.referential.accountingCostCompute.costSlicesMode.constantCost': 'Massa di costi fissi',
    'auto.billing.referential.accountingCostCompute.costSlicesMode.summedUpByAdmissionFeesAmount': 'Per coperto',
    'auto.billing.referential.accountingCostCompute.modal.sliceFrom': 'FASCIA DA',
    'auto.billing.referential.accountingCostCompute.modal.to': 'A',
    'auto.billing.referential.accountingCostCompute.modal.constantCost': 'MASSA DI COSTI FISSI',
    'auto.billing.referential.accountingCostCompute.modal.summedUpByAdmissionFeesAmount': 'PER COPERTO',
    'auto.billing.referential.accountingCostCompute.modal.billingMode': 'MODALITÀ DI FATTURAZIONE',
    'auto.billing.referential.accountingCostCompute.modal.title': 'Aggiungi una nuova fascia',
    'auto.billing.referential.accountingCostCompute.modal.input.maxLowerThanOrEqualToMin':
        'La fascia max deve essere superiore alla min',
    'auto.billing.referential.accountingCostCompute.modal.input.intersection':
        'Questa fascia si sovrappone con [{from} - {to}]',
    'auto.billing.referential.accountingCostCompute.modal.input.negative': 'Il valore deve essere positivo',
    'auto.billing.referential.accountingCostCompute.partitionedCostByGuest': 'XXXX',
    'auto.billing.referential.accountingCostCompute.addSlice': '+ Aggiungi una fascia',
    'auto.billing.referential.accountingCostCompute.amount': 'Importo Lordo',
    'auto.billing.filters.entity': 'Entità di fatturazione',
    'auto.billing.referential.accountingGroups.code.text': 'XXXX CODICE DEL GRUPPO',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.range': 'Numero di coperti',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.mode': 'Modalità di calcolo',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.value': 'Valori',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.emptyMessage':
        'Nessuna fascia definita per questa modalità di fatturazione',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.to': 'a',

    // Routes
    'route.brands': 'Marchi',
    'route.brandInfo': 'Informazioni',
    'route.brandInfoV2': 'Informazioni',
    'route.brandMedias': 'Media',
    'route.configIOPay': 'Configurazione Adyen',
    'route.configEdenred': 'Configurazione Edenred',
    'route.configPaygreen': 'Configurazione Paygreen',
    'route.integrations': 'Integrazioni',
    'route.stripeIntegration': 'Stripe',
    'route.grantsAndEntranceFees': 'Sovvenzioni e ammissioni',
    'route.services': 'Servizi',
    'route.createShift': 'Nuovo servizio',
    'route.editShift': 'Modifica servizio',
    'route.options': 'Opzioni',
    'route.brandHistory': 'Cronologia',
    'route.groups': 'Gerarchia',
    'route.brandChannels': 'Canali',
    'route.brandMenus': 'Menu',
    'route.brandMenu': 'Informazioni',
    'route.brandRestaurants': 'Ristoranti',
    'route.brandUsers': 'Utenti',
    'route.billing': 'Il mio spazio fatturazione',
    'route.home': 'Home',
    'route.pricingRule': 'Regime tariffario',
    'route.logout': 'Disconnessione',
    'route.configUbereats': 'Integrazione Uber Eats',
    'route.configDeliveroo': 'Integrazione Deliveroo',
    'route.configDeliverect': 'Integrazione Deliverect',
    'route.configCrous': 'Integrazione Crous',
    'route.createGrant': 'Nuova Sovvenzione',
    'route.grant': 'Sovvenzioni',
    'route.createEntranceFee': 'Nuova ammissione',
    'route.entranceFee': 'Ammissione',
    'route.createPricingRule': 'Nuova regola tariffaria',
    'route.analytics': 'Panoramica',
    'route.restaurantIntegration': 'Integrazione',
    'route.autoBilling': 'Fatturazione automatica',
    'route.autoBilling.referential': 'Riferimento',
    'route.autoBilling.request': 'Richiesta di fatturazione',
    'route.autoBilling.referential.createEntity': "Creazione di un'entità di fatturazione",
    'route.autoBilling.referential.editEntity': "Modifica di un'entità di fatturazione",
    'route.orders': 'Ordini',
    'route.orderDetails': 'Dettaglio ordine',
    'route.restaurantInfo': 'Informazioni',
    'route.restaurantChannels': 'Canali',
    'route.restaurantUsers': 'Utenti',
    'route.restaurantMenus': 'Menu',
    'route.restaurantMenu': 'Informazioni',
    'route.restaurantTickets': 'Ticket',
    'route.restaurantMedias': 'Media',
    'route.restaurantIntegrations': 'Integrazioni',
    'route.restaurantPayments': 'Metodi di pagamento',
    'route.restaurantOptions': 'Opzioni',
    'route.restaurantPricingRevaluation': 'Rivalutazione dei prezzi',
    'route.createGroup': 'Nuovo gruppo',
    'route.createSection': 'Nuova sezione',
    'route.createSubSection': 'Nuova sottosezione',
    'route.editGroup': 'Modifica di un gruppo',
    'route.editSection': 'Modifica di una sezione',
    'route.editSubSection': 'Modifica di una sottosezione',
    'route.adminTools': 'Strumenti admin',
    'route.menus': 'Menu',
    'route.menuOperations': 'Operazioni sui menu',
    'route.posLayout': 'Layout POS',
    'route.categories': 'Categorie',
    'route.products': 'Prodotti',
    'route.steps': 'Passaggi',
    'route.tags': 'Tag',
    'route.functions': 'Funzioni',
    'route.brandCustomer': 'Clienti',
    'route.brandOrders': 'Ordini',
    'route.crossSelling': 'Cross-selling',
    'route.tableLayout': 'Piani tavoli',
    'route.tableLayout.room': 'Sale',
    'route.salesSummary': 'Riepilogo Finanziario',
    'route.tickets': 'Ticket',
    'route.reportStatus': 'Stato report',
    'route.pos': 'POS',
    'route.posConfiguration': 'Configurazione',
    'route.posDevices': 'Casse',
    'route.posAccess': 'Ruoli e permessi',
    'route.posAccess.users': 'Utenti cassa',
    'route.posAccess.roles': 'Ruoli cassa',
    'route.posAccess.groups': 'Gruppi cassa',
    'route.accessFlags': 'Autorizzazioni',
    'route.userRestaurants': 'Ristoranti associati',
    'route.updateUserPassword': 'Modifica la tua password',
    'route.userInfo': 'Info',
    'route.badgeReader': 'Lettori di badge',
    'route.posDeviceInformation': 'Informazioni',
    'route.posDeviceConfiguration': 'Configurazione',
    'route.posDeviceAdditionalDevices': 'Periferiche',
    'route.posDeviceArchives': 'Archivi fiscali',
    'route.posDeviceFeatures': 'Opzioni',
    'route.posDevicePreferences': 'Preferenze',
    'route.posDeviceCatalogHistory': 'Cronologia dei cataloghi',
    'route.listCustomers': 'Clienti',
    'route.customerSettings': 'Impostazioni',
    'route.customerPricingRules': 'Regimi tariffari',
    'route.splioLoyaltyIntegration': 'Splio',
    'route.pickupPoints': 'Punti di ritiro',
    'route.comoLoyaltyIntegration': 'Como',
    'route.zerosixLoyaltyIntegration': 'Zerosix',
    'route.operationZones': 'Zona operativa',
    'route.createBrandWebhook': 'Crea un webhook',
    'route.editBrandWebhook': 'Modifica un webhook',

    // Operation Zones
    'operationZones.page.title': 'Zona operativa',
    'operationZones.page.description':
        "Definisci i territori in cui il tuo marchio opera. Una zona principale deve essere designata per l'entità legale di riferimento.",
    'operationZones.emptyState': 'Nessuna zona selezionata',
    'operationZones.emptyState.description':
        "Seleziona uno o più territori dall'elenco sottostante per definire le tue zone operative.",
    'operationZones.availableTerritories': 'Territori disponibili',
    'operationZones.selectedCount': '{count} selezionato/i',
    'operationZones.solution': 'Soluzione',
    'operationZones.warning.title': 'Configurazione incompleta',
    'operationZones.warning.description':
        '{count, plural, one {{count} zona selezionata deve essere configurata per essere operativa.} other {{count} zone selezionate devono essere configurate per essere operative.}}',
    'operationZones.warning.hint':
        'Si prega di completare le informazioni legali e tecniche tramite il pulsante "Configura".',
    'operationZones.immutabilityNotice':
        'La zona operativa non può essere modificata dopo la creazione del ristorante. <supportLink>Contatta il supporto</supportLink> se necessario.',
    'operationZones.primaryZone': 'ZONA PRINCIPALE',
    'operationZones.setPrimary.disabled': 'Configura questa zona prima di impostarla come principale',
    'operationZones.cannotRemoveLastZone': 'Un ristorante deve avere almeno una zona operativa',
    'operationZones.primaryBadge': 'PRINCIPALE',
    'operationZones.secondaryZonesActive':
        '+ {count} {count, plural, one {ZONA SECONDARIA ATTIVA} other {ZONE SECONDARIE ATTIVE}}',
    'operationZones.configure': 'Configura',
    'operationZones.viewVatRates': 'Vedi le aliquote',
    'operationZones.toConfigure': 'Da configurare',
    'operationZones.entity': 'Entità',
    'operationZones.vat': 'IVA',
    'operationZones.posConfig': 'Configurazione POS',
    'operationZones.notFilled': 'Non compilato',
    'operationZones.pending': 'In attesa',
    'operationZones.initialized': 'Inizializzata',
    'operationZones.configured': 'Configurata',
    'operationZones.noPosDevice': 'Crea un POS prima di configurare questa zona',
    'operationZones.configModal.title': 'Configurazione: {zoneName}',
    'operationZones.configModal.subtitle': 'Parametri legali e fiscali ({code})',
    'operationZones.configModal.entitySection': "Informazioni sull'entità",
    'operationZones.configModal.socialReason': 'Ragione sociale',
    'operationZones.configModal.address': 'Indirizzo',
    'operationZones.configModal.postalCode': 'Codice postale',
    'operationZones.configModal.city': 'Città',
    'operationZones.configModal.vatNumber': 'Numero IVA',
    'operationZones.configModal.siret': 'SIRET',
    'operationZones.configModal.save': 'Salva',
    'operationZones.configModal.socialReason.placeholder': 'Es: Ristorante SRL',
    'operationZones.configModal.address.placeholder': 'Via Roma 123 ...',
    'operationZones.configModal.postalCode.placeholder': '00100',
    'operationZones.configModal.city.placeholder': 'Roma',
    'operationZones.configModal.vatNumber.placeholder': 'Es: IT 12345678901',
    'operationZones.configModal.siret.placeholder': 'Es: 522 296...',
    'operationZones.multiProvider': 'A scelta',
    'operationZones.configModal.nifCif': 'NIF / CIF',
    'operationZones.configModal.nifCif.placeholder': 'Es: B12345678',
    'operationZones.configModal.fiscalRepresentative': 'Rappresentante fiscale',
    'operationZones.configModal.fiscalRepresentative.placeholder': 'Nome del rappresentante fiscale',
    'operationZones.configModal.fiscalIdCode': 'Codice di identificazione fiscale',
    'operationZones.configModal.fiscalIdCode.placeholder': 'Es: RSSMRA85T10A562S',
    'operationZones.configModal.vatNumberBtw': 'Numero IVA (BTW)',
    'operationZones.configModal.vatNumberBtw.placeholder': 'Es: BE 0123.456.789',
    'operationZones.configModal.enterpriseNumber': "Numero d'impresa",
    'operationZones.configModal.enterpriseNumber.placeholder': 'Es: 0123.456.789',
    'operationZones.configModal.if': 'IF',
    'operationZones.configModal.if.placeholder': 'Es: 12345678',
    'operationZones.configModal.ice': 'ICE',
    'operationZones.configModal.ice.placeholder': 'Es: 001234567000045',
    'operationZones.configModal.selectProvider': 'Seleziona la modalità di conformità',
    'operationZones.configModal.fiskaltrust': 'Fiskaltrust',
    'operationZones.configModal.fiskaltrustDescription':
        'Middleware di conformità fiscale per il registratore di cassa',
    'operationZones.configModal.noIntegration': 'Nessuna integrazione',
    'operationZones.configModal.noIntegrationDescription': 'Nessun middleware fiscale verrà configurato',
    'operationZones.configModal.nf525': 'NF525',
    'operationZones.configModal.nf525Description': 'Certificazione di conformità fiscale francese',
    'operationZones.configModal.boiteNoire': 'Boîte Noire',
    'operationZones.configModal.boiteNoireDescription': 'Modulo di conformità fiscale belga',
    'operationZones.configModal.middlewareSection': 'Configurazione Middleware (Fiskaltrust)',
    'operationZones.configModal.cashboxId': 'Cashbox ID',
    'operationZones.configModal.cashboxId.placeholder': 'Es: a1b2c3d4-...',
    'operationZones.configModal.accessToken': 'Access Token',
    'operationZones.configModal.accessToken.placeholder': 'Es: AZE123...',
    'operationZones.configModal.back': 'Indietro',
    'operationZones.deactivate.title': 'Disattivare la zona operativa',
    'operationZones.deactivate.message':
        'Sei sicuro di voler disattivare questa zona operativa? Tutte le informazioni configurate (entità legale, fiscalità, configurazione POS) andranno perse.',

    // Admin tools
    'adminTools.confirmModal.description': 'Sei sicuro di voler eseguire questa azione?',
    'brand.adminTools.editCustomerLoyalties.title': 'Aggiungi/rimuovi fedeltà IO a un cliente di questo marchio',
    'brand.adminTools.editCustomerLoyalties.form.placeholder.emailsOrCards': 'nome@dominio.com o A1B2C3D4E5',
    'brand.adminTools.editCustomerLoyalties.form.placeholder.loyaltyAmountToAdd': '400 equivale a 4 euro',
    'brand.adminTools.editCustomerLoyalties.form.emailsOrCards': 'Email o numero della carta fedeltà del cliente',
    'brand.adminTools.editCustomerLoyalties.form.loyaltyAmountToAdd': 'Importo',
    'brand.adminTools.editCustomerLoyalties.form.error': "Si è verificato un errore durante l'esecuzione dello script.",
    'brand.adminTools.editCustomerLoyalties.form.success': 'Lo script è stato eseguito correttamente.',
    'brand.adminTools.unarchiveCustomer.title': 'Dearchivia un cliente',
    'brand.adminTools.unarchiveCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.unarchiveCustomer.form.customerId': 'CustomerId da dearchiviare',
    'brand.adminTools.unarchiveCustomer.form.error': "Si è verificato un errore durante l'esecuzione dello script.",
    'brand.adminTools.unarchiveCustomer.form.success': 'Lo script è stato eseguito correttamente.',
    'brand.adminTools.deleteTransaction.title': 'Elimina una transazione',
    'brand.adminTools.deleteTransaction.form.placeholder.transactionId': '1234567',
    'brand.adminTools.deleteTransaction.form.transactionId': 'Transazione da eliminare',
    'brand.adminTools.deleteTransaction.form.error': "Si è verificato un errore durante l'esecuzione dello script.",
    'brand.adminTools.deleteTransaction.form.success': 'Lo script è stato eseguito correttamente.',
    'brand.adminTools.addUserToRestaurant.title':
        'Assegna un account ristorante a un altro ristorante dello stesso marchio',
    'brand.adminTools.addUserToRestaurant.form.placeholder.email': 'esempio@ristorante.com',
    'brand.adminTools.addUserToRestaurant.form.email': "Email dell'account",
    'brand.adminTools.addUserToRestaurant.form.placeholder.restaurantId': '1111',
    'brand.adminTools.addUserToRestaurant.form.restaurantId': 'RestaurantId del ristorante da assegnare',
    'brand.adminTools.addUserToRestaurant.form.error': "Si è verificato un errore durante l'esecuzione dello script.",
    'brand.adminTools.addUserToRestaurant.form.success': 'Lo script è stato eseguito correttamente.',
    'brand.adminTools.deleteUnassignedImages.title': 'Elimina le immagini non utilizzate di questo marchio',
    'brand.adminTools.deleteUnassignedImages.description1':
        'Script per cancellare tutte le immagini non utilizzate (ad esempio da prodotti/menu che sono stati eliminati)',
    'brand.adminTools.deleteUnassignedImages.description2':
        'Si consiglia di eliminare tutti i menu inutili del marchio e dei suoi ristoranti prima di eseguire questo script, affinché la pulizia sia efficace.',
    'brand.adminTools.deleteUnassignedImages.form.error':
        "Si è verificato un errore durante l'esecuzione dello script.",
    'brand.adminTools.deleteUnassignedImages.form.success': 'Lo script è stato eseguito correttamente.',
    'brand.adminTools.importGeojsonPolygon.title': 'Importa un geoJson come zona di consegna',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.restaurantId': '1234',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.areaName': 'Milano',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.geoJsonPolygon':
        '[[4.8395748,50.0926849],[4.8393237,50.0926889],[4.8392677,50.0926748]]',
    'brand.adminTools.importGeojsonPolygon.form.restaurantId': 'RestaurantId',
    'brand.adminTools.importGeojsonPolygon.form.areaName': 'Nome della zona di consegna da creare',
    'brand.adminTools.importGeojsonPolygon.form.geoJsonPolygon': 'Inserisci le coordinate poligono del geoJson',
    'brand.adminTools.importGeojsonPolygon.form.error': "Si è verificato un errore durante l'esecuzione dello script.",
    'brand.adminTools.importGeojsonPolygon.form.success': 'Lo script è stato eseguito correttamente.',
    'brand.adminTools.deleteCustomer.title': 'Elimina un cliente',
    'brand.adminTools.deleteCustomer.description1':
        'Inserisci il customerId che vuoi eliminare (Puoi inserire più customerId separandoli con una virgola, senza spazio, ad esempio: 1234567,1234568,1234569)',
    'brand.adminTools.deleteCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.deleteCustomer.form.customerId': 'CustomerId da eliminare',
    'brand.adminTools.deleteCustomer.form.error': "Si è verificato un errore durante l'esecuzione dello script.",
    'brand.adminTools.deleteCustomer.form.success': 'Lo script è stato eseguito correttamente.',

    'brand.adminTools.razCustomer.title': 'Azzeramento di un cliente',
    'brand.adminTools.razCustomer.description1':
        'Inserisci il customerId di cui vuoi azzerare il saldo E-Wallet (Puoi inserire più customerId separandoli con una virgola, senza spazio, ad esempio: 1234567,1234568,1234569)',
    'brand.adminTools.razCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.razCustomer.form.customerId': 'CustomerId da azzerare (separati da virgola)',
    'brand.adminTools.razCustomer.form.placeholder.brandId': '414',
    'brand.adminTools.razCustomer.form.brandId':
        'BrandId da azzerare (se inserisci un brandId, tutti i clienti post-pagamento di questo marchio saranno azzerati, il campo customerId sopra sarà ignorato)',
    'brand.adminTools.razCustomer.form.placeholder.date': '01/02/2024',
    'brand.adminTools.razCustomer.form.date':
        "Data di applicazione dell'azzeramento (l'ora è alle 5 del mattino), lascia vuoto se l'azzeramento deve essere fatto ora",
    'brand.adminTools.razCustomer.form.error': "Si è verificato un errore durante l'esecuzione dello script.",
    'brand.adminTools.razCustomer.form.success': 'Lo script è stato eseguito correttamente.',

    'brand.adminTools.copySchedules.title': 'Copia degli orari di ritiro o CEL da un ristorante a un altro/i',
    'brand.adminTools.copySchedules.form.placeholder.scheduleType': 'pickup o cel',
    'brand.adminTools.copySchedules.form.placeholder.idSource': '900',
    'brand.adminTools.copySchedules.form.placeholder.idsDestination': '901',
    'brand.adminTools.copySchedules.form.scheduleType': 'Tipo di orario da copiare (inserisci pickup o cel)',
    'brand.adminTools.copySchedules.form.idSource': 'RestaurantId sorgente',
    'brand.adminTools.copySchedules.form.idsDestination':
        'RestaurantId di destinazione (Puoi inserire più restaurantId separandoli con una virgola, senza spazio, ad esempio: 901,902,903)',
    'brand.adminTools.copySchedules.form.error': "Si è verificato un errore durante l'esecuzione dello script.",
    'brand.adminTools.copySchedules.form.success': 'Lo script è stato eseguito correttamente.',

    'brand.adminTools.changeOrderDateInReport.title':
        'Modifica la data di un ordine nei report (Cambierà anche la data della transazione)',
    'brand.adminTools.changeOrderDateInReport.form.orderPosId':
        'Numero ordine (orderId), possibilità di separare con virgola',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.orderPosId': '1234567,1234568,1234569,...',
    'brand.adminTools.changeOrderDateInReport.form.day': 'Giorno',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.day': 'esempio: 14',
    'brand.adminTools.changeOrderDateInReport.form.month': 'Mese',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.month': 'esempio: 7',
    'brand.adminTools.changeOrderDateInReport.form.year': 'Anno',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.year': 'esempio: 2025',
    'brand.adminTools.changeOrderDateInReport.form.hour': 'Ora',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.hour': 'esempio: 10',
    'brand.adminTools.changeOrderDateInReport.form.minutes': 'Minuti',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.minutes': 'esempio: 35',
    'brand.adminTools.changeOrderDateInReport.form.error':
        "Si è verificato un errore durante l'esecuzione dello script.",
    'brand.adminTools.changeOrderDateInReport.form.success': 'Lo script è stato eseguito correttamente.',

    'brand.adminTools.editPasswordExpiresAt.title': 'Forza un marchio/un cliente a cambiare la password',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.shouldResetPassword': 'force o cancel',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.brandId': '900',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.customerId': ' ',
    'brand.adminTools.editPasswordExpiresAt.form.shouldResetPassword':
        'Forza il cambio password (force) o Annulla il cambio password (cancel)',
    'brand.adminTools.editPasswordExpiresAt.form.brandId': 'Marchio target',
    'brand.adminTools.editPasswordExpiresAt.form.customerId':
        'Cliente/i target (Puoi inserire più customerId separandoli con una virgola, senza spazio, ad esempio: 123456,234567,345678). Lascia vuoto per targetizzare tutto il marchio',
    'brand.adminTools.editPasswordExpiresAt.form.error': "Si è verificato un errore durante l'esecuzione dello script.",
    'brand.adminTools.editPasswordExpiresAt.form.success': 'Lo script è stato eseguito correttamente.',

    'brand.adminTools.editProductSkuFromProductId.title': 'Modifica lo SKU di più prodotti da un file Excel',
    'brand.adminTools.editProductSkuFromProductId.description': 'Scarica il {fileTemplate} sul tuo computer',
    'brand.adminTools.editProductSkuFromProductId.form.error':
        "Si è verificato un errore durante l'esecuzione dello script.",
    'brand.adminTools.editProductSkuFromProductId.form.success': 'Lo script è stato eseguito correttamente.',

    'brand.adminTools.importProductInMenu.title': 'Importa prodotti in un menu esistente',
    'brand.adminTools.importProductInMenu.description': 'Scarica il {fileTemplate} sul tuo computer',
    'brand.adminTools.importProductInMenu.form.error': "Si è verificato un errore durante l'esecuzione dello script.",
    'brand.adminTools.importProductInMenu.form.success': 'Lo script è stato eseguito correttamente.',

    'brand.adminTools.importProductFromSku.title': 'Modifica e importa prodotti basati sul loro SKU',
    'brand.adminTools.importProductFromSku.description1':
        'Usa questo {metabaseLink} per avere la lista dei prodotti del tuo menu, puoi modificare o aggiungere nuovi prodotti (SKU non obbligatorio sui nuovi prodotti).',
    'brand.adminTools.importProductFromSku.description1bis':
        "Non modificare lo SKU dei prodotti esistenti, è l'identificatore unico del prodotto. Non cambiare i nomi delle colonne",
    'brand.adminTools.importProductFromSku.description2': 'Scarica il {fileTemplate} sul tuo computer',
    'brand.adminTools.importProductFromSku.form.error': "Si è verificato un errore durante l'esecuzione dello script.",
    'brand.adminTools.importProductFromSku.form.success': 'Lo script è stato eseguito correttamente.',

    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.menuIdSource': 'menuId del menu sorgente',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.menuIdSource': 'MenuId del menu sorgente',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.menuIdDestination': 'menuId del menu destinazione',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.menuIdDestination': 'MenuId del menu destinazione',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.filterCategory': '(facoltativo)',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.filterCategory': 'Filtro Categoria',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.filterTag': '(facoltativo)',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.filterTag': 'Filtro Tag',
    'brand.adminTools.copyProductFromMenuIdToMenuId.title': 'Copia prodotti da un menu a un altro',
    'brand.adminTools.copyProductFromMenuIdToMenuId.description1':
        'Inserisci il menuId del menu sorgente e il menuId del menu destinazione. Puoi anche filtrare i prodotti per categoria e/o tag per copiare solo alcuni prodotti.',
    'brand.adminTools.copyProductFromMenuIdToMenuId.description2':
        'Nota che i riferimenti esterni e i passaggi non saranno copiati',
    'brand.adminTools.copyProductFromMenuIdToMenuId.description3':
        'E le immagini saranno copiate solo se il menu di Destinazione è sullo stesso Ristorante del menu Sorgente, o se il menu Sorgente è a livello Marchio e il menu di Destinazione a livello Ristorante nello stesso Marchio',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.error':
        "Si è verificato un errore durante l'esecuzione dello script.",
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.success': 'Lo script è stato eseguito correttamente.',

    'brand.adminTools.importBackofficeUsers.title': 'Importa utenti backoffice',
    'brand.adminTools.importBackofficeUsers.description': 'Scarica il {fileTemplate} sul tuo computer',
    'brand.adminTools.importBackofficeUsers.form.error': "Si è verificato un errore durante l'esecuzione dello script.",
    'brand.adminTools.importBackofficeUsers.form.success': 'Lo script è stato eseguito correttamente.',

    'brand.adminTools.editProductInfoFromProductId.title': 'Modifica prodotti da un file Excel',
    'brand.adminTools.editProductInfoFromProductId.description1':
        'Usa questo {metabaseLink} per avere la lista dei prodotti del tuo menu, compila le colonne dedicate alla modifica e carica il file. (Non cambiare i nomi delle colonne)',
    'brand.adminTools.editProductInfoFromProductId.description2': 'Scarica il {fileTemplate} sul tuo computer',
    'brand.adminTools.editProductInfoFromProductId.form.error':
        "Si è verificato un errore durante l'esecuzione dello script.",
    'brand.adminTools.editProductInfoFromProductId.form.success': 'Lo script è stato eseguito correttamente.',

    'brand.adminTools.editStepInfoFromStepId.title': 'Modifica passaggi da un file Excel',
    'brand.adminTools.editStepInfoFromStepId.description0':
        'Questo script permette di modificare i nomi, i riferimenti e le etichette dei passaggi in massa, non la lista dei prodotti.',
    'brand.adminTools.editStepInfoFromStepId.description1':
        'Usa questo {metabaseLink} per avere la lista dei passaggi del tuo menu, compila le colonne dedicate alla modifica e carica il file. (Non cambiare i nomi delle colonne)',
    'brand.adminTools.editStepInfoFromStepId.form.error':
        "Si è verificato un errore durante l'esecuzione dello script.",
    'brand.adminTools.editStepInfoFromStepId.form.success': 'Lo script è stato eseguito correttamente.',

    'brand.adminTools.editProductPriceInAdminTools.title':
        'Modifica il prezzo dei prodotti (fuori e nei passaggi) da un file Excel',
    'brand.adminTools.editProductPriceInAdminTools.description1':
        'Usa questo {metabaseLink} per avere la lista dei prodotti del tuo menu, compila la colonna Nuovo Prezzo e carica il file. (Non cambiare i nomi delle colonne)',
    'brand.adminTools.editProductPriceInAdminTools.description2': 'Scarica il {fileTemplate} sul tuo computer',
    'brand.adminTools.editProductPriceInAdminTools.form.error':
        "Si è verificato un errore durante l'esecuzione dello script.",
    'brand.adminTools.editProductPriceInAdminTools.form.success': 'Lo script è stato eseguito correttamente.',

    'brand.adminTools.editProductTagFromProductId.title': 'Aggiungi uno o più Tag a più prodotti da un file Excel',
    'brand.adminTools.editProductTagFromProductId.description': 'Scarica il {fileTemplate} sul tuo computer',
    'brand.adminTools.editProductTagFromProductId.form.error':
        "Si è verificato un errore durante l'esecuzione dello script.",
    'brand.adminTools.editProductTagFromProductId.form.success': 'Lo script è stato eseguito correttamente.',

    'brand.adminTools.makeEwalletTransaction.title': 'Effettua transazioni E-Wallet da un file Excel',
    'brand.adminTools.makeEwalletTransaction.description': 'Scarica il {fileTemplate} sul tuo computer',
    'brand.adminTools.makeEwalletTransaction.form.error':
        "Si è verificato un errore durante l'esecuzione dello script.",
    'brand.adminTools.makeEwalletTransaction.form.success': 'Lo script è stato eseguito correttamente.',
    'brand.adminTools.bulkUploadDualScreenImage.title':
        "Upload immagine doppio schermo su tutte le casse di un'insegna",
    'brand.adminTools.bulkUploadDualScreenImage.description':
        "Carica un'immagine (PNG o JPG) e inserisci il brandId. L'immagine verrà applicata a tutte le casse dell'insegna.",
    'brand.adminTools.bulkUploadDualScreenImage.brandIdLabel': 'Brand ID',
    'brand.adminTools.bulkUploadDualScreenImage.brandIdPlaceholder': 'Inserisci il Brand ID',
    'brand.adminTools.bulkUploadDualScreenImage.form.success': "L'immagine è stata caricata su tutte le casse.",
    'brand.adminTools.transformGuestFile.title':
        'Trasforma la tua base clienti recuperata dal nuovo sito in formato Innovorder',
    'brand.adminTools.transformGuestFile.fileFormat': 'Formato file originale',
    'brand.adminTools.transformGuestFile.form.success': 'Il file è stato trasformato correttamente',
    'brand.adminTools.transformGuestFile.form.url': 'clicca qui per scaricare il file',
    'brand.adminTools.transformGuestFile.fileFormat.JES': 'JES',
    'brand.adminTools.transformGuestFile.fileFormat.CSI': 'CSI',
    'brand.adminTools.transformGuestFile.fileFormat.X-GIL': 'x-gil',
    'brand.adminTools.transformGuestFile.fileFormat.PI-ELECTRONICS': 'Pi Electronique',
    'brand.adminTools.generateSalesReport.title': 'Invio vendite IO in SI Sodexo',
    'brand.adminTools.generateSalesReport.description':
        'Sincronizza le vendite IO in SI Sodexo per un ristorante specifico (se usi un periodo, le vendite saranno sincronizzate per il periodo selezionato)',
    'brand.adminTools.generateSalesReport.form.checkbox': 'Usa un periodo',
    'brand.adminTools.generateSalesReport.form.restaurant': 'Seleziona un ristorante',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.title':
        'Collega gli SKU dei prodotti ai mapping di ID esterni',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.description':
        'Crea mapping tra i productId interni e gli SKU dei prodotti per un menu specifico',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.restaurant': 'Ristorante',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.menu': 'Menu',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.success': 'Lo script è stato eseguito correttamente.',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.error':
        "Si è verificato un errore durante l'esecuzione dello script.",

    // Spotlight
    'spotlight.search.placeholder': 'Cosa vuoi fare?',
    'spotlight.section.suggestion': 'Suggerimento',
    'spotlight.section.history': 'Cronologia',
    'spotlight.context.brand': 'Marchio',
    'spotlight.context.restaurant': 'Ristorante',
    'spotlight.error.noHistory': 'Non hai ancora URL idonei nella tua cronologia',

    // Orders
    'orderList.title': 'Ordini',
    'orderList.subtitle': 'Trova gli ordini dei tuoi clienti e dei tuoi amici più stretti',
    'orderList.filters.allRestaurants': 'Tutti i ristoranti',
    'orderList.filters.restaurantHeader': 'I miei ristoranti',
    'orderList.filters.restaurantPlaceholder': 'Cerca un ristorante',
    'orderList.filters.dateRange.lastXdays': 'Ultimi {days} giorni',
    'orderList.filters.dateRange.custom': 'Personalizzato',
    'orderList.generation_history': 'Cronologia delle generazioni',
    'orderList.export': 'Esporta',
    'orderList.generate': 'Genera',
    'orderList.export.title': 'Esporta',
    'orderList.export.selectOneDay': 'Seleziona un giorno',
    'orderList.export.selectPeriod': 'Seleziona un periodo',
    'orderList.export.format': 'Scegli un formato di esportazione',
    'orderList.export.file.xlsx': 'Excel',
    'orderList.export.file.csv': 'CSV',
    'orderList.export.file.pdf': 'PDF',
    'orderList.export.dateRage.errorMessage': 'Non puoi selezionare più di 31 giorni',
    'orderList.export.presetDate.currentWeek': 'Settimana corrente',
    'orderList.export.presetDate.currentMonth': 'Mese corrente',
    'orderList.export.presetDate.lastMonth': 'Mese scorso',
    'orderList.export.presetDate.chooseDate': 'Seleziona un periodo',
    'orderList.export.includeOrderStates': 'Includi i diversi stati degli ordini',
    'order.field.ticketNumber': 'N° Ticket',
    'order.field.status': 'Stato',
    'order.field.restaurant': 'Ristorante',
    'order.field.channel': 'Canale',
    'order.field.customerName': 'Nome e cognome',
    'order.field.customerNameMassCatering': 'Nome e cognome cliente',
    'order.field.badgeNumber': 'N° Badge',
    'order.field.phone': 'Numero di telefono',
    'order.field.pricingRule': 'Regime tariffario',
    'order.field.pricingRuleInOrder': 'Regime tariffario applicato',
    'order.field.company': 'Azienda',
    'order.field.orderId': 'N° Ordine',
    'order.field.consumptionMode': 'Modalità di consumo',
    'order.field.orderDate': 'Data Ordine',
    'order.field.expectedDate': 'Data Consegna',
    'order.field.ticketDate': 'Data Ticket',
    'order.field.totalWithVat': 'Totale Lordo',
    'order.field.turnoverWithVat': 'Fatturato Lordo',
    'order.field.paymentMethod': 'Metodo di pagamento',
    'order.field.paymentStatus': 'Stato pagamento',
    'order.field.paymentAmount': 'Importo del pagamento',
    'order.status.PAID': 'Pagato',
    'order.status.CANCELLED': 'Annullato',
    'order.status.VALIDATED': 'Convalidato',
    'order.status.PAID_CANCELLED': 'Pagato (annullato)',
    'order.status.CONTRA_ENTRY': 'Contro-scrittura',
    'order.status.INCOHERENT': 'Ordine incoerente',
    'order.channel.': 'Sconosciuto',
    'order.channel.1': 'Totem',
    'order.channel.2': 'CEL',
    'order.channel.5': 'Cassa',
    'order.channel.8': 'DA',
    'order.channel.9': 'Uber Eats',
    'order.channel.10': 'Deliveroo',
    'order.channel.11': 'Just Eat',
    'order.consumptionMode.1': 'Consegna',
    'order.consumptionMode.2': 'Da asporto',
    'order.consumptionMode.3': 'Sul posto',
    'order.consumptionMode.4': 'Drive',
    'order.webPaymentStatus.PAYMENT_OK': 'Pagato',
    'order.webPaymentStatus.PAYMENT_PENDING': 'Non pagato',
    'order.webPaymentStatus.PAYMENT_REFUSED': 'Pagamento rifiutato',
    'order.webPaymentStatus.PAYMENT_REFUNDED': 'Rimborsato',
    'order.paymentMethod.AlloResto': 'AlloResto',
    'order.paymentMethod.AmericanExpress': 'American Express',
    'order.paymentMethod.Cash': 'Contanti',
    'order.paymentMethod.Change': 'Resto',
    'order.paymentMethod.Check': 'Assegno',
    'order.paymentMethod.CreditCard': 'CB',
    'order.paymentMethod.CreditNote': 'Credito',
    'order.paymentMethod.CreditNoteIssued': 'Credito emesso',
    'order.paymentMethod.Deliveroo': 'Deliveroo',
    'order.paymentMethod.ELuncheonVoucher': 'E-Buono Pasto',
    'order.paymentMethod.EWallet': 'E-Wallet',
    'order.paymentMethod.ExternalPayment': 'Pagamento Esterno',
    'order.paymentMethod.Foodora': 'Foodora',
    'order.paymentMethod.Ingenico': 'Ingenico',
    'order.paymentMethod.LuncheonVoucher': 'Buono Pasto',
    'order.paymentMethod.Lydia': 'Lydia',
    'order.paymentMethod.Nepting': 'Nepting',
    'order.paymentMethod.OnlineCreditCard': 'Carta di credito online',
    'order.paymentMethod.Paygreen': 'Paygreen',
    'order.paymentMethod.RestoFlash': 'Resto Flash',
    'order.paymentMethod.Stripe': 'Stripe',
    'order.paymentMethod.Transfer': 'Bonifico',
    'order.paymentMethod.UberEats': 'Uber Eats',
    'order.paymentMethod.Unknown': 'Altro',
    'order.paymentMethod.Unknown2': 'Altro 2',
    'order.paymentMethod.Edenred': 'Edenred',
    'orderDetail.error.incoherent': "Contattare il supporto per regolarizzare l'ordine",
    'orderDetail.title.1': 'Totem',
    'orderDetail.title.2': 'Ordine online',
    'orderDetail.title.5': 'Cassa',
    'orderDetail.title.8': 'Distribuzione Automatica',
    'orderDetail.title.9': 'Uber Eats',
    'orderDetail.title.10': 'Deliveroo',
    'orderDetail.title.11': 'Just Eat',
    'orderDetail.title.contraEntry': 'Ordine Contro-scrittura',
    'orderDetail.status.PAID': 'Incasso',
    'orderDetail.status.VALIDATED': 'Conto',
    'orderDetail.status.CANCELLED': 'Annullato',
    'orderDetail.tabStatus.PAID': 'Vendita pagata',
    'orderDetail.tabStatus.VALIDATED': 'Carrello convalidato',
    'orderDetail.tabStatus.CANCELLED': 'Annullamento',
    'orderDetail.paymentStatus.PAID': 'Pagato',
    'orderDetail.paymentStatus.CANCELLED': 'Annullato',
    'orderDetail.paymentStatus.REFUNDED': 'Rimborsato',
    'orderDetail.shift.default': 'Servizio predefinito',
    'orderDetail.header.guestNumber': 'Numero di coperti:',
    'orderDetail.header.currency': 'Valuta:',
    'orderDetail.header.orderedAt': 'Ordinato alle',
    'orderDetail.header.deliverAt': 'Consegna prevista alle',
    'orderDetail.header.deliverAtRange': 'Pianificato per la fascia oraria:',
    'orderDetail.header.status': 'Stato',
    'orderDetail.header.payment': 'Pagamento',
    'orderDetail.header.table': 'Tavolo',
    'orderDetail.kpi.date': 'Il {date, date}',
    'orderDetail.kpi.time': '{date, date, ::HHmm}',
    'orderDetail.kpi.timeRange': 'dalle {start, date, ::HHmm} alle {end, date, ::HHmm}',
    'orderDetail.ticketInfo': "Dettagli dell'ordine",
    'orderDetail.comment': 'Commento',
    'orderDetail.userName': 'Informazioni clienti',
    'orderDetail.taxInfo': 'Dettagli IVA',
    'orderDetail.paymentInfo': 'Metodi di pagamento',
    'orderDetail.customerInfo': 'Informazioni cliente',
    'orderDetail.deliveryInfo': 'Consegna',
    'orderDetail.loyaltyInfo': 'Fedeltà',
    'orderDetail.posInfo': 'Informazioni Cassa',
    'orderDetail.transactionInfo': 'Dettagli Transazione',
    'orderDetail.orderPhotos': "Foto associate all'ordine",
    'orderDetail.customer.name': 'Cognome e nome',
    'orderDetail.customer.email': 'Email',
    'orderDetail.customer.phone': 'Numero di telefono',
    'orderDetail.customer.badgeNumber': 'Numero di badge',
    'orderDetail.customer.pricingRule': 'Regime tariffario',
    'orderDetail.customer.pricingRuleAssigned': 'Regime tariffario assegnato',
    'orderDetail.customer.group': 'Gruppo',
    'orderDetail.customer.section': 'Sezione',
    'orderDetail.customer.subSection': 'Sottosezione',
    'orderDetail.customer.balanceInformation.ewalletBalanceBeforeOrder': 'Saldo E-Wallet precedente',
    'orderDetail.customer.balanceInformation.ewalletBalanceAfterOrder': 'Nuovo saldo E-Wallet',
    'orderDetail.Pos.restaurant': 'Ristorante',
    'orderDetail.Pos.seller': 'Operatore',
    'orderDetail.Pos.deviceName': 'Nome della cassa',
    'orderDetail.Pos.deviceId': 'ID POS',
    'orderDetail.action.text': 'Azioni ordine',
    'orderDetail.action.cancel': 'Annulla',
    'orderDetail.action.refund': 'Rimborsa',
    'orderDetail.action.cancelWithContraEntry': "Annulla l'ordine (contro-scrittura)",
    'orderDetail.cancel.title.reason': "Annulla l'ordine",
    'orderDetail.cancel.title.manualPaymentMethod': 'Metodo di pagamento del rimborso',
    'orderDetail.cancel.text1': "In caso di necessità, puoi annullare l'ordine di un cliente.",
    'orderDetail.cancel.text2': 'Devi scegliere un motivo di annullamento qui sotto.',
    'orderDetail.cancel.text3': 'Se il motivo non è nella lista, clicca su "Altro".',
    'orderDetail.cancel.text4': 'Il motivo che selezioni sarà inviato via email al cliente.',
    'orderDetail.cancel.text5': 'Le quantità di prodotti dedotte saranno rimesse in stock.',
    'orderDetail.cancel.text6': 'Puoi scegliere il metodo di pagamento da associare al rimborso.',
    'orderDetail.cancel.text7': '⚠️ È necessario rimborsare fisicamente il cliente per evitare discrepanze contabili.',
    'orderDetail.cancel.reason.description.label': 'Campo libero (opzionale)',
    'orderDetail.cancel.reason.placeholder': 'Scegli il motivo di annullamento',
    'orderDetail.cancel.reason.description.placeholder': '250 caratteri massimo',
    'orderDetail.cancel.manualPaymentMethod.placeholder': 'Scegli il metodo di pagamento',
    'orderDetail.cancel.reason.CANNOT_FULFILL_ORDER': "Non può completare l'ordine",
    'orderDetail.cancel.reason.ORDERING_MISTAKE': "Errore nell'ordine",
    'orderDetail.cancel.reason.UNSATISFIED_CUSTOMER':
        'Cliente insoddisfatto (le quantità non vengono rimesse in stock)',
    'orderDetail.cancel.reason.CUSTOMER_NO_SHOW': 'Il cliente non si è presentato',
    'orderDetail.cancel.reason.CUSTOMER_LEAVES': 'Il cliente è andato via',
    'orderDetail.cancel.reason.LEARNING_MODE': 'Formazione',
    'orderDetail.cancel.reason.TECHNICAL': 'Errore tecnico',
    'orderDetail.cancel.reason.OTHER': 'Altro...',
    'orderDetail.cancel.manualPaymentMethod.Cash': 'Contanti',
    'orderDetail.cancel.manualPaymentMethod.CreditCard': 'CB',
    'orderDetail.cancel.confirm': "Annulla l'ordine",
    'orderDetail.cancel.validate': "Conferma l'annullamento",
    'orderDetail.ticket.itemSum': 'Totale articoli',
    'orderDetail.ticket.grantSum': 'Totale sovvenzioni',
    'orderDetail.ticket.entranceFeeSum': 'Totale ammissioni',
    'orderDetail.ticket.pricingRule': 'Regime tariffario: ',
    'orderDetail.ticket.discountSum': 'Totale sconti',
    'orderDetail.ticket.tvaSum': 'Totale IVA',
    'orderDetail.ticket.finalPrice': 'TOTALE',
    'orderDetail.ticket.discount': 'Codice promo:',
    'orderDetail.tax.taxrate': 'Aliquota IVA',
    'orderDetail.tax.totalExclTax': 'Netto',
    'orderDetail.tax.totalTax': 'IVA',
    'orderDetail.tax.totalInclTax': 'Lordo',
    'orderDetail.transaction.transactionIds': 'Identificatore della transazione',
    'orderDetail.payment.quantity': 'Quantità',
    'orderDetail.payment.price': 'Prezzo',
    'orderDetail.delivery.address': 'Indirizzo',
    'orderDetail.delivery.apartmentNumber': 'Numero appartamento',
    'orderDetail.delivery.digicode': 'Codice citofono',
    'orderDetail.delivery.phoneNumber': 'Numero di telefono',
    'orderDetail.delivery.additionalInfo': 'Informazioni aggiuntive',
    'orderDetail.linkedOrder.title.origin': "Link con l'ordine contro-scrittura",
    'orderDetail.linkedOrder.title.contra_entry': "Link con l'ordine annullato",
    'orderDetail.linkedOrder.date.origin': "Data dell'ordine contro-scrittura",
    'orderDetail.linkedOrder.date.contra_entry': "Data dell'ordine annullato",
    'orderDetail.contraEntryInfo.title': 'Informazioni contro-scrittura',
    'orderDetail.contraEntryInfo.validator': 'Validatore',
    'orderDetail.contraEntryInfo.cancellationReasonDescription': 'Campo libero',

    // Payments
    'route.ioPayTransactions': 'Transazioni',
    'route.ioPayReports': 'Report',
    'route.ioPayTransfers': 'Versamenti',
    'route.ioPayConfiguration': 'Configurazione',
    'route.ioPayTransferDetail': 'Dettaglio del versamento',
    'route.ioPayTransactionDetail': 'Dettaglio della transazione',
    'ioPay.title': 'Adyen',

    'transactions.title': 'Transazioni',
    'transactions.detail.title': 'Scheda transazione',
    'transactions.subtitle': 'Trova le transazioni dei tuoi clienti',
    'transaction.field.id': 'Id',
    'transaction.field.type': 'Tipo',
    'transaction.field.brand': 'Marchio',
    'transaction.field.customerEmail': 'Email',
    'transaction.field.date': 'Data',
    'transaction.field.paymentMethod': 'Metodo di pagamento',
    'transaction.field.paymentStatus': 'Modalità di pagamento',
    'transaction.field.paymentAmount': 'Importo del pagamento',
    'transaction.field.paymentAmount.tooltip': 'Importo pagato dal cliente',
    'transaction.field.reversalAmount': 'Importo versato da Innovorder',
    'transaction.field.reversalAmount.tooltip':
        "Importo versato prelevando solo la commissione di pagamento (l'importo può essere negativo se i fondi non passano per Innovorder e sono versati direttamente sul tuo conto bancario)",
    'transaction.field.amount': 'Importo della transazione',
    'transaction.field.amount.tooltip': 'Somma degli importi versati da Innovorder meno i rimborsi',
    'transaction.field.fee': 'Commissione',
    'transaction.field.channel': 'Canale',
    'transaction.field.transfer': 'Versamento',
    'transaction.field.currency': 'Valuta',
    'transaction.field.status': 'Stato',
    'transaction.field.ip': 'IP',
    'transaction.field.referer': 'Referer',
    'transaction.field.userAgent': 'User Agent',
    'transaction.field.customerCompleteName': 'Nome e cognome',
    'transaction.field.email': 'Email',
    'transaction.field.customerId': 'ID Cliente',
    'transaction.field.badgeNumber': 'N° badge',
    'transaction.field.lastUpdate': 'Data di aggiornamento',
    'transaction.field.source': 'Fonte',
    'transaction.field.orderId': 'Numero ordine',
    'transaction.field.error': 'Errore',
    'transaction.field.restaurant': 'Ristorante',
    'transaction.field.paymentMethodType.WEB': 'CB online',
    'transaction.field.paymentMethodType.PROXIMITY': 'CB',
    'transaction.field.paymentMethod.MEAL_VOUCHER': 'BP',
    'transaction.field.paymentMethod.BANK_CARD': 'CB',
    'transaction.status.PENDING': 'In corso',
    'transaction.status.PENDING_3DS': '3DS in corso',
    'transaction.status.DONE': 'Successo',
    'transaction.status.FAILED': 'Rifiutato',
    'transaction.status.ERROR': 'Errore',
    'transaction.type.CAPTURE': 'Pagamento',
    'transaction.type.REFUND': 'Rimborso',
    'transaction.channel.WEB': 'Web',
    'transaction.channel.PROXIMITY': 'Prossimità',
    'transaction.source.WEBORDERING': 'Ordine online',
    'transaction.source.EWALLET': 'Ricarica Ewallet',
    'transaction.source.KIOSK': 'Totem',
    'transaction.source.NOTIFICATION': 'Notifica',

    'transaction.detail.card.main': 'Dettagli della transazione',
    'transaction.detail.card.finance': 'Dati finanziari',
    'transaction.detail.card.web': 'Informazioni sui dati web',
    'transaction.detail.card.customer': 'Informazioni cliente',
    'transaction.detail.card.order': 'Ordine associato',
    'transaction.detail.card.paymentMethod': 'Metodi di pagamento',

    'transfers.title': 'Versamenti',
    'transfers.subtitle': 'Versamenti sul tuo conto',

    'configuration.iopay.title': 'Configurazione Adyen',
    'configuration.iopay.subtitle':
        'Qui troverai tutte le entità legali che hai creato per la tua azienda. Abbiamo raccolto per te una panoramica chiara e concisa dei tuoi ristoranti ed e-wallet per facilitare le loro configurazioni.',
    'configuration.error.unaccessible': 'Non trovato o permessi insufficienti',

    'transfer.field.id': 'Id',
    'transfer.field.ref': 'Riferimento',
    'transfer.field.configurationName': 'Commerciante',
    'transfer.field.amount': 'Importo del versamento',
    'transfer.field.transactionCount': 'Numero di transazioni',
    'transfer.field.status': 'Stato',
    'transfer.field.executedAt': 'Data di esecuzione',
    'transfer.status.PENDING': 'In corso',
    'transfer.status.SUCCESS': 'Confermato',
    'transfer.status.SENT_OUT': 'Inviato',
    'transfer.status.FAILED': 'Fallito',
    'transfer.kpi.date': '{date, date} {date, time, ::HHmm}',
    'transfer.detail.title': 'Dettagli del versamento',
    'transfer.transactions.title': 'Transazioni del versamento',

    'legalEntity.field.entity': 'Entità legale',
    'legalEntity.field.siret': 'SIRET',
    'legalEntity.field.city': 'Città',
    'legalEntity.field.status': 'Stato',
    'legalEntity.field.associatedRestaurants': 'Ristoranti associati',
    'legalEntity.field.actions': 'Azioni',

    'legalEntity.create.title': "Crea un'entità legale",

    'legalEntity.status.1': 'Errore KYC',
    'legalEntity.status.2': 'Da completare',
    'legalEntity.status.3': 'Elaborazione in corso',
    'legalEntity.status.4': 'OK',

    'legalEntity.action.addRestaurant': 'Aggiungi un ristorante',
    'legalEntity.action.addEwallet': 'Aggiungi un e-wallet',
    'legalEntity.action.completeKyc': 'Completa il KYC',
    'legalEntity.action.updateKyc': 'Aggiorna il KYC',

    'legalEntity.wizard.step1.title': 'Creazione di una nuova entità legale',
    'legalEntity.wizard.step1.legalName': 'Nome legale della società',
    'legalEntity.wizard.step1.legalName.placeholder':
        'Inserisci il nome legale della società come indicato esattamente sul SIRET',
    'legalEntity.wizard.step1.legalName.tooltip': 'Nome legale della società come indicato esattamente sul SIRET',
    'legalEntity.wizard.step1.organizationType': 'Tipo di organizzazione',
    'legalEntity.wizard.step1.organizationType.placeholder': 'Seleziona il tipo di organizzazione',
    'legalEntity.wizard.step1.siret': 'SIRET',
    'legalEntity.wizard.step1.siret.placeholder': 'Inserisci il tuo SIRET',
    'legalEntity.wizard.step1.siret.tooltip': 'SIRET della società',
    'legalEntity.wizard.step1.addressStreet': "Indirizzo dell'entità legale",
    'legalEntity.wizard.step1.addressStreet.placeholder': "Inserisci l'indirizzo dell'entità legale",
    'legalEntity.wizard.step1.addressStreet2': 'Indirizzo aggiuntivo (opzionale)',
    'legalEntity.wizard.step1.addressStreet2.placeholder': "Inserisci l'indirizzo aggiuntivo se necessario",
    'legalEntity.wizard.step1.addressZipcode': 'CAP',
    'legalEntity.wizard.step1.addressZipcode.placeholder': 'Inserisci il tuo CAP',
    'legalEntity.wizard.step1.addressCity': 'Città',
    'legalEntity.wizard.step1.addressCity.placeholder': 'Inserisci la tua città',
    'legalEntity.wizard.step1.industryCode': 'Codice Industria',
    'legalEntity.wizard.step1.contactEmail': 'Email di contatto',
    'legalEntity.wizard.step1.contactEmail.placeholder': "Inserisci l'indirizzo email associato a questa entità legale",
    'legalEntity.wizard.step1.iban': 'IBAN',
    'legalEntity.wizard.step1.iban.placeholder': "Inserisci l'IBAN dell'entità legale",
    'legalEntity.wizard.step1.iban.tooltip': "IBAN dell'entità legale",

    'legalEntity.wizard.step2.title': 'Aggiunta di un nuovo ristorante',
    'legalEntity.wizard.step2.titleMassCatering': 'Aggiunta di un nuovo ristorante o e-wallet',
    'legalEntity.wizard.step2.chooseRestaurant': 'Seleziona un ristorante',
    'legalEntity.wizard.step2.chooseRestaurantMassCatering': 'Seleziona un ristorante o e-wallet',
    'legalEntity.wizard.step2.completeFieldsTitle': 'Campi da completare',
    'legalEntity.wizard.step2.conecsTitle': 'Identificativi CONECS',
    'legalEntity.wizard.step2.conecsTitleOptional': '(opzionale)',
    'legalEntity.wizard.step2.conecsTitleOptional.tooltip':
        'Inserisci gli identificativi CONECS (ID) per poter attivare il metodo di pagamento CONECS su questo ristorante per i pagamenti in prossimità',
    'legalEntity.wizard.step2.ewallet': 'E-wallet',
    'legalEntity.wizard.step2.selectRestaurant': 'Ristorante',
    'legalEntity.wizard.step2.selectRestaurantMassCatering': 'Ristorante o e-wallet',
    'legalEntity.wizard.step2.selectRestaurant.placeholder': 'Seleziona un ristorante',
    'legalEntity.wizard.step2.phoneNumber': 'Numero di telefono',
    'legalEntity.wizard.step2.phoneNumber.placeholder':
        'Inserisci il numero di telefono da associare a questo ristorante',
    'legalEntity.wizard.step2.shopperStatement': "Titolo sull'estratto conto",
    'legalEntity.wizard.step2.shopperStatement.placeholder': "Inserisci il titolo che apparirà sull'estratto conto",
    'legalEntity.wizard.step2.shopperStatement.tooltip': "Etichetta presente sull'estratto conto del cliente finale",
    'legalEntity.wizard.step2.restaurantAddressStreet': 'Indirizzo del ristorante',
    'legalEntity.wizard.step2.restaurantAddressStreet.placeholder': "Inserisci l'indirizzo del ristorante",
    'legalEntity.wizard.step2.restaurantAddressStreet2': 'Indirizzo aggiuntivo (opzionale)',
    'legalEntity.wizard.step2.restaurantAddressStreet2.placeholder': "Inserisci l'indirizzo aggiuntivo se necessario",
    'legalEntity.wizard.step2.restaurantAddressZipcode': 'CAP del ristorante',
    'legalEntity.wizard.step2.restaurantAddressZipcode.placeholder': 'Inserisci il CAP del ristorante',
    'legalEntity.wizard.step2.restaurantAddressCity': 'Città',
    'legalEntity.wizard.step2.restaurantAddressCity.placeholder': 'Inserisci la città del ristorante',
    'legalEntity.wizard.step2.restaurantIban': 'IBAN',
    'legalEntity.wizard.step2.restaurantIban.placeholder': "Inserisci l'IBAN per il trasferimento fondi",
    'legalEntity.wizard.step2.restaurantIban.tooltip':
        'Inserisci gli identificativi CONECS (ID) per poter attivare il metodo di pagamento CONECS su questo ristorante per i pagamenti in prossimità',
    'legalEntity.wizard.step2.conecsId': 'CONECS MID',
    'legalEntity.wizard.step2.conecsId.placeholder':
        'Inserisci il MID CONECS presente sulla tua carta di domiciliazione',
    'legalEntity.wizard.step2.conecsAssociatedSiret': 'SIRET associato al contratto CONECS',
    'legalEntity.wizard.step2.conecsAssociatedSiret.placeholder': 'Inserisci il SIRET associato al contratto CONECS',

    'legalEntity.organizationType.1': 'Società privata',
    'legalEntity.organizationType.2': 'Società pubblica',
    'legalEntity.organizationType.3': 'Partnership costituita',
    'legalEntity.organizationType.4': 'Organizzazione senza scopo di lucro o di beneficenza',
    'legalEntity.organizationType.5': 'Organizzazione governativa',
    'legalEntity.organizationType.6': 'Associazione costituita come persona giuridica',

    'legalEntity.industryCode.specialFoodServices': 'Servizi alimentari speciali',
    'legalEntity.industryCode.fullServiceRestaurants': 'Ristoranti a servizio completo',
    'legalEntity.industryCode.limitedServiceRestaurants': 'Ristoranti a servizio limitato (fast food)',
    'legalEntity.industryCode.cafeteriasGrillBuffets': 'Caffetterie, grill-buffet e buffet',
    'legalEntity.industryCode.snacksNonalcoholicBeverages': 'Snack bar e bar di bevande analcoliche',
    'legalEntity.industryCode.bakeries': 'Panetterie',

    // BILLING PAGE
    'billing.title': 'Il mio spazio fatturazione',
    'billing.subtitle': 'Benvenuto, questo spazio è stato creato per semplificare la gestione delle fatture.',
    'billing.description':
        'Qui troverai le fatture organizzate cronologicamente per servizio di pagamento, ora è facile consultare i pagamenti recenti, scaricare fatture e seguire la cronologia delle fatture con un clic.',
    'billing.information.edit': 'Modifica le informazioni di fatturazione',
    'billing.noIssuedInvoices': 'Nessuna fattura emessa',
    'billing.table.creationDate': 'Data di creazione',
    'billing.table.amount': 'Importo',
    'billing.table.status': 'Stato',
    'billing.table.service': 'Servizio',
    'billing.table.invoiceNumber': 'N° fattura',
    'billing.table.invoiceName': 'Nome della fattura',
    'billing.table.dueDate': 'Data di scadenza',
    'billing.table.downloadPDF': 'Scarica il PDF',

    'billing.editConfiguration.selectEntityStep.title': 'Entità legali',
    'billing.editConfiguration.selectEntityStep.subtitle':
        "Seleziona un'entità legale dove modificare le informazioni di fatturazione",
    'billing.editConfiguration.selectEntityStep.legalEntity': 'Entità legali',
    'billing.editConfiguration.selectEntityStep.legalEntity.placeHolder': 'Seleziona dalla lista',
    'billing.editConfiguration.selectEntityStep.noLabel': 'Entità legale senza nome',

    'billing.editConfiguration.configureBillingStep.title': 'Informazioni di fatturazione',
    'billing.editConfiguration.configureBillingStep.beneficiaryName': 'Nome del beneficiario',
    'billing.editConfiguration.configureBillingStep.beneficiaryEmail': 'Indirizzo email associato alla fattura',
    'billing.editConfiguration.configureBillingStep.beneficiaryAddress': 'Indirizzo del beneficiario',
    'billing.editConfiguration.configureBillingStep.beneficiaryAddress2': 'Informazioni aggiuntive',
    'billing.editConfiguration.configureBillingStep.beneficiaryZipCode': 'CAP',
    'billing.editConfiguration.configureBillingStep.beneficiaryCity': 'Città',
    'billing.editConfiguration.configureBillingStep.recipients': 'Destinatari della fattura',
    'billing.editConfiguration.configureBillingStep.recipients.placeholder': 'Indirizzi email dei destinatari',
    'billing.editConfiguration.configureBillingStep.recipients.createLabel':
        'Aggiungi l\'indirizzo email "{email}" ai destinatari',
    'billing.editConfiguration.configureBillingStep.genericErrorMessage':
        'Si è verificato un errore durante la creazione o modifica delle informazioni di configurazione',

    'billing.invoices.download': 'Scarica',

    'billing.invoices.status.1': 'Da pagare',
    'billing.invoices.status.2': 'Pagata',

    'billing.invoices.psp.4': 'Stripe',

    'billing.invoices.name.4': 'Fattura Stripe unificata',

    'reports.title': 'Report Adyen',
    'reports.subtitle':
        'Consulta le transazioni trasferite sul tuo conto bancario, con il dettaglio per transazione per ogni trasferimento. Questo report ti permette di garantire una contabilizzazione affidabile delle transazioni E-wallet con Adyen.',
    'reports.text': 'Genera uno/dei tipo/i di report',
    'reports.choosePeriod': 'Scegli un periodo',
    'reports.chooseReport': 'Seleziona uno o più tipi di report',
    'reports.outgoingTransfers': 'Versamenti',
    'reports.reportType': 'TIPO/I DI REPORT',
    'reports.error.missingDates': 'Scegli due date',
    'reports.error.missingReportType': 'Scegli un report',
    'reports.error.missingBrand': "Nessun marchio collegato all'utente corrente",

    // PRICING REVALUATION
    'pricingRevaluation.tableCard.title': 'Rivalutazione dei prezzi',
    'pricingRevaluation.tableCard.subtitle':
        'Indica il tasso di rivalutazione desiderato, se applicarlo alle opzioni, ai supplementi poi seleziona i menu da rivalutare e clicca sul pulsante conferma.',
    'pricingRevaluation.input.placeholder': 'Tasso di rivalutazione',

    // PAYMENT METHODS
    'consumptionMode.MODE_DELIVERY': 'Consegna',
    'consumptionMode.MODE_TAKE_AWAY': 'Da asporto',
    'consumptionMode.MODE_SIT_IN': 'Sul posto',
    'consumptionMode.MODE_DRIVE': 'Drive',
    'paymentMethods.tableCard.title': 'Gestisci e configura',
    'paymentMethods.tableCard.subtitle': 'i tuoi metodi di pagamento',
    'paymentMethods.tab.pos': 'Cassa/e',
    'paymentMethods.tab.web': 'Ordine online',
    'paymentMethods.tab.kiosk': 'Totem',
    'paymentMethods.tab.kiosk.integration.title': 'Pagamenti Immediati',
    'paymentMethods.tab.kiosk.integration.desc1':
        'Il pagamento con CB sui totem richiede che il ristorante abbia un account Ingenico.',
    'paymentMethods.tab.kiosk.integration.desc2':
        "Altri metodi di pagamento immediato sono disponibili se attivi l'autenticazione sui totem.",
    'paymentMethods.tab.kiosk.payment.title': 'Pagamenti al ritiro',
    'paymentMethods.tab.kiosk.payment.desc':
        'Indica agli utenti i metodi di pagamento accettati dal ristorante al bancone.',
    'paymentMethods.tab.kiosk.payment': 'Pagamenti',
    'paymentMethods.tab.kiosk.payment.accepted': 'accettati',
    'paymentMethods.tab.kiosk.payment.refused': 'rifiutati',
    'paymentMethods.consumptionMode': 'Seleziona le modalità di consumo',
    'paymentMethods.externalId': 'Codice esterno',
    'configure.ingenico': 'Configura Ingenico',
    'configure.nepting': 'Configura Nepting',
    'configure.stripe': 'Configura Stripe',
    'configure.edenred': 'Configura Edenred',
    'configure.iopay': 'Configura Adyen',
    'configure.paygreen': 'Configura Paygreen',
    'configure.ewallet': 'Configura E-Wallet',
    'configure.yavin': 'Configura IOPay',
    'configure.yavin.neptingConfigured': 'Impossibile configurare IOPay, Nepting è in uso.',
    'configure.nepting.yavinConfigured': 'Impossibile configurare Nepting, IOPay è in uso.',
    'configure.stripe.iopayConfigured': 'Impossibile configurare Stripe, Adyen è in uso.',
    'configure.iopay.stripeConfigured': 'Impossibile configurare Adyen, Stripe è in uso.',

    // CUSTOMER FORM
    'customer.form.modalDescription': 'Compila le informazioni obbligatorie *',
    'customer.form.firstName': 'Nome *',
    'customer.form.lastName': 'Cognome *',
    'customer.form.badgeNumber': 'N° BADGE {index} *',
    'customer.form.badgeType': 'Tipo di badge',
    'customer.form.badge.default': 'Imposta come principale',
    'customer.form.badgeType.placeholder': 'Inserisci il tipo di badge',
    'customer.form.addBadge': 'Aggiungi un badge',
    'customer.form.email': 'Indirizzo email *',
    'customer.form.phoneNumber': 'N° telefono (Facoltativo)',
    'customer.form.arrivalDate': 'Data di arrivo (Facoltativo)',
    'customer.form.departureDate': 'Data di partenza (Facoltativo)',
    'customer.form.password': 'Password *',
    'customer.form.confirmPassword': 'Conferma la password *',
    'customer.form.clientInfoSection': 'Informazioni generali del cliente',
    'customer.form.pricingRuleSection': 'Configurazione delle regole tariffarie',
    'customer.form.accountPaymentTypeLabel': 'Tipo di account cliente *',
    'customer.form.accountPaymentTypePlaceHolder': 'Seleziona un tipo di account cliente',
    'customer.form.guestGroupIdLabel': 'Gruppo *',
    'customer.form.guestGroupIdPlaceHolder': 'Seleziona un gruppo',
    'customer.form.pricingRuleCodeLabel': 'Codice Regime tariffario *',
    'customer.form.pricingRuleCodePlaceHolder': 'Seleziona un regime tariffario',
    'customer.form.tariffCode': 'CODICE TARIFFA (FACOLTATIVO)',
    'customer.form.studentNumber': 'N° CLIENTE (FACOLTATIVO)',
    'customer.form.pricingRuleInfo': 'Il tuo codice di regime tariffario non appare nella lista? Crealo ',
    'customer.form.groupInfo': 'Per definire i tuoi gruppi, vai alla pagina Marchio > Gerarchia ',
    'customer.form.sectionInfo': 'Per definire le tue sezioni, vai alla pagina Marchio > Gerarchia ',
    'customer.form.subSectionInfo': 'Per definire le tue sottosezioni, vai alla pagina Marchio > Gerarchia ',
    'customer.form.here': 'qui',
    'customer.form.section': 'SEZIONE (FACOLTATIVO)',
    'customer.form.subSection': 'SOTTOSEZIONE (FACOLTATIVO)',

    // Customer form selectOptions
    'customer.form.selectOptions.cash': 'Contanti',
    'customer.form.selectOptions.prepayment': 'Pre-pagamento',
    'customer.form.selectOptions.postpayment_bankdebit': 'Post-pagamento: trattenuta sullo stipendio',
    'customer.form.selectOptions.postpayment_guest': 'Post-pagamento: ospiti',

    // BRAND CUSTOMERS LIST
    'brand.customers.action.import': 'Importa',
    'brand.customers.action.export': 'Esporta',
    'brand.customers.page.title': 'Clienti',
    'brand.customers.page.description': "Qui troverai l'elenco completo dei clienti iscritti al tuo marchio.",

    // IMPORT CUSTOMERS
    'customer.modal.import.title': 'Importa clienti',
    'customer.modal.import.firstPart': 'Scarica il {fileTemplate} sul tuo computer',
    'customer.modal.import.secondPart': 'Compila il file con i dati dei tuoi clienti',
    'customer.modal.import.thirdPart': 'Carica il file per importare i tuoi clienti',
    'customer.modal.import.report.title': 'Rapporto di importazione',
    'customer.modal.import.report.result': 'Risultato',
    'customer.modal.import.report.success': 'Successo',
    'customer.modal.import.report.error': 'Errore',
    'customer.modal.import.report.message': '{created} creati, {updated} aggiornati, {unchanged} invariati',
    'customer.modal.import.warning':
        "Attenzione! Le colonne 'Codice tariffa', 'Codice sovvenzione', 'Codice ammissione' e 'Codice regime tariffario' sono deprecate e verranno ignorate durante l'importazione. Utilizzare la tabella dei regimi tariffari per configurare queste informazioni.",
    'customer.modal.import.addNew.title': 'Aggiungi nuovi clienti',
    'customer.modal.import.addNew.step1': 'Scarica il {link} sul tuo computer',
    'customer.modal.import.addNew.step1.link': 'file modello',
    'customer.modal.import.addNew.step2': 'Compila il file con i dati dei tuoi nuovi clienti',
    'customer.modal.import.addNew.step3': 'Carica il file compilato qui sotto',
    'customer.modal.import.update.title': 'Aggiorna clienti esistenti',
    'customer.modal.import.update.step1': 'Scarica {link} sul tuo computer',
    'customer.modal.import.update.step1.link': 'la base clienti attuale',
    'customer.modal.import.update.step1.loading': 'Caricamento...',
    'customer.modal.import.update.step2': 'Modifica i dati dei clienti che desideri aggiornare',
    'customer.modal.import.update.step3': 'Carica il file modificato qui sotto',
    'customer.modal.import.update.warning':
        "Nota: L'identificativo cliente deve corrispondere a un cliente esistente affinché l'aggiornamento venga effettuato.",
    'customer.modal.import.options.title': 'Opzioni di importazione',
    'customer.modal.import.options.multiBadge': 'Importazione multi-badge',
    'customer.modal.import.options.autoImportGuestHierarchy':
        'Importazione automatica della gerarchia (gruppi, sezioni, sottosezioni)',
    'customer.modal.import.error.noResponse': "L'importazione è fallita - nessuna risposta dal server",
    'customer.modal.import.error.invalidResponse': 'Risposta non valida dal server',
    'customer.modal.import.error.fileTooLarge': 'Il file è troppo grande (max 20 MB)',
    'customer.modal.import.loading.reading': 'Lettura del file in corso...',
    'customer.modal.import.loading.importing': 'Importazione in corso...',
    'customer.modal.import.result.lineError': 'Riga {lineNumber}{nameDisplay}: {error}',
    'customer.modal.import.result.fieldError': 'I campi ({fields}) non sono stati modificati (riga {line})',
    'customer.modal.import.result.genericError': 'Si è verificato un errore',
    'customer.modal.import.result.created': 'Clienti creati: {count}',
    'customer.modal.import.result.updated': 'Clienti aggiornati: {count}',
    'customer.modal.import.result.unchanged': 'Clienti non modificati/non creati: {count}',
    'customer.modal.import.result.errors': 'Errori',
    'customer.modal.import.result.warnings': 'Avvertimenti',
    'customer.modal.import.result.otherWarning.PRICING_RULE': 'Alcune regole tariffarie non esistono nel sistema: ',
    'customer.modal.import.result.otherWarning.ENTRANCE_FEE': 'Alcune ammissioni non esistono nel sistema: ',
    'customer.modal.import.result.otherWarning.EMPTY_GUEST_GROUP': 'Alcuni clienti hanno un gruppo vuoto (righe: ',
    'customer.modal.import.result.otherWarning.UNEXISTING_GUEST_GROUP':
        'Alcuni gruppi di clienti non esistono (righe: ',
    'customer.modal.import.result.otherWarning.UNAUTHORIZED_PRICING_RULE':
        'Alcune regole tariffarie non sono autorizzate per il gruppo (righe: ',
    'customer.modal.import.result.restrictedFieldsInfo':
        'I campi "Password", "Codice pin" e "Saldo" possono essere aggiornati solo se il cliente non ha ancora effettuato transazioni.',

    // CREATE CUSTOMER
    'customer.create.modalTitle': 'Crea un nuovo cliente',

    // UPDATE A CUSTOMER
    'customer.update.modalTitle': 'Modifica del cliente',

    // CUSTOMER INFO TABS
    'customer.tab.info': 'Informazioni',
    'customer.tab.ewallet': 'E-Wallet',
    'customer.tab.student': 'Ristorazione Collettiva',
    'customer.tab.orders': 'Cronologia ordini',

    // CUSTOMER ROUTES
    'route.customerPricingPolicy': 'Politica tariffaria',

    // CUSTOMER PRICING POLICY
    'customer.pricingPolicy.defaultTitle': 'Politica predefinita',
    'customer.pricingPolicy.defaultDescription':
        'La politica tariffaria predefinita sarà applicata a ogni cliente che crea il proprio account tramite il modulo di ordine web.',
    'customer.pricingPolicy.customTitle': 'Politica personalizzata',
    'customer.pricingPolicy.entranceFee': 'Spese di ammissione',
    'customer.pricingPolicy.pricingPolicy': 'Regime tariffario',
    'customer.pricingPolicy.group': 'Gruppo',
    'customer.pricingPolicy.groupPlaceholder': 'MIO GRUPPO',
    'customer.pricingPolicy.domainName': 'Nome dominio',
    'customer.pricingPolicy.delete': 'Elimina',
    'customer.pricingPolicy.noEntranceFee': 'Nessuna ammissione',
    'customer.pricingPolicy.noPricingRule': 'Nessuna regola tariffaria',
    'customer.pricingPolicy.noGroup': 'Nessun gruppo',
    'customer.pricingPolicy.enableWhitelisting': "Limita l'iscrizione ai domini dichiarati",
    'customer.pricingPolicy.enableWhitelistingInfo':
        "Attivando questa opzione, l'iscrizione online è autorizzata solo per i domini dichiarati",
    'customer.pricingPolicy.save': 'Salva',

    // CUSTOMER INFO STUDENT TAB
    'customer.student.info.title': 'Informazioni',
    'customer.student.info.desctiption': 'Le informazioni relative alla modalità Ristorazione Collettiva.',
    'customer.student.info.account.type': 'Tipo di badge',
    'customer.student.info.group': 'Gruppo',
    'customer.student.info.section': 'Sezione',
    'customer.student.info.sub.section': 'Sottosezione',
    'customer.student.info.badge.number': 'N° Badge',
    'customer.student.info.pricing.code': 'Codice tariffa',
    'customer.student.info.student.number': 'N° Cliente',
    'customer.student.pricing.rules.title': 'Regole tariffarie',
    'customer.student.pricing.rules.desctiption':
        'Puoi assegnare a ogni cliente regole tariffarie specifiche. Un cliente può avere un codice sovvenzione e/o ammissione OPPURE un codice regime tariffario (un insieme di spese di ammissione e/o sovvenzioni).',
    'customer.student.pricing.rules.deprecated':
        '⚠️ I campi codice ammissione e codice sovvenzione sono ora deprecati, a favore del campo Codice Regime tariffario (che raggruppa ammissioni e sovvenzioni). {moreInfo}',
    'customer.student.pricing.rules.more_info': 'Maggiori informazioni',
    'customer.student.pricing.rules.grant.code': 'Codice sovvenzione',
    'customer.student.pricing.rules.entrance.fee.code': 'Codice ammissione',
    'customer.student.pricing.rules.code': 'Codice regime tariffario',
    'customer.student.overdraft.title': 'Scoperto E-Wallet autorizzato',
    'customer.student.overdraft.desctiption':
        "Puoi personalizzare lo scoperto massimo autorizzato di un cliente per l'utilizzo del suo E-wallet.",
    'customer.student.overdraft.price.label': 'Scoperto E-Wallet autorizzato',
    'customer.student.overdraft.disabled': 'Lo scoperto E-wallet predefinito è assegnato a questo cliente.',
    'customer.student.badge.title': 'Blocco del badge principale del cliente',
    'customer.student.badge.description': 'Puoi bloccare temporaneamente il funzionamento del badge principale.',
    'customer.student.badge.table.default': 'Principale',
    'customer.student.badge.table.number': 'Numero di badge',
    'customer.student.badge.table.type': 'Tipo',
    'customer.student.badge.table.status': 'Stato',
    'customer.student.badge.table.action': 'Azione',
    'customer.student.badge.table.status.active': '✓ Attivato',
    'customer.student.badge.table.status.blocked': '✕ Bloccato',
    'customer.student.add.badge': '+ Aggiungi un badge',
    'customer.student.badge.form.add': 'Aggiungi un badge',
    'customer.student.badge.form.update': 'Modifica un badge',
    'customer.student.badge.form.default': 'Imposta come principale',
    'customer.ordersList.title': 'Ordini',
    'customer.ordersList.subtitle': 'Trova gli ordini del tuo cliente',
    'customer.ordersList.downloadTickets': 'Scarica i ticket',
    'customer.ordersList.exportStarted': 'Esportazione dei ticket avviata. Attendere...',
    'customer.ordersList.exportSuccess': 'Ticket esportati con successo!',
    'customer.ordersList.exportFailed': "L'esportazione dei ticket è fallita. Riprovare.",
    'customer.ordersList.exportNoTicketsForDates': 'Nessun ticket per le date selezionate.',
    'customer.ordersList.downloadChoice.all': 'Tutti i ticket',
    'customer.ordersList.downloadChoice.selectedRange': 'Solo le date selezionate',
    'order.field.downloadTicket': 'Scarica',

    'pricingRevaluation.options.exceeding': 'Applica ai supplementi',
    'pricingRevaluation.options.options': 'Applica alle opzioni',
    'pricingRevaluation.options.updateInPlace': 'Menu frigo connesso/scansione vassoio',
    'pricingRevaluation.options.updateInPlace.tooltip':
        'Se la casella è selezionata, la rivalutazione verrà applicata direttamente al menu originale, per conservare gli ID (verrà creata una copia del menu senza rivalutazione). \nSe la casella non è selezionata, la rivalutazione verrà applicata a una copia del menu (nuovi ID) e il menu originale non verrà modificato.',
    'pricingRevaluation.table.menu.name': 'Nome del menu',
    'pricingRevaluation.table.menu.isActive': 'Menu attivo',
    'pricingRevaluation.table.menu.channels': 'Canali',
    'pricingRevaluation.table.menu.selected': 'Selezionato',
    'pricingRevaluation.table.emptyMessage': 'Nessun menu trovato per questo ristorante',
    'pricingRevaluation.table.search': 'Cerca menu',

    // POS LAYOUT
    'pos_layout.name': 'Layout POS',
    'pos_layout.page.title': 'Layout POS',
    'pos_layout.page.description': 'Organizza il tuo layout poi distribuiscilo sui POS associati.',
    'pos_layout.sort': 'Riorganizza',
    'pos_layout.sort.random': 'Casuale',
    'pos_layout.sort.by_name': 'Per nome',
    'pos_layout.sort.by_price': 'Per prezzo',
    'pos_layout.tabletSize': 'Dimensione del tablet',
    'pos_layout.inches': 'Pollici',
    'pos_layout.publishDescription': 'Sei sicuro di voler salvare e pubblicare il menu e il layout sui POS associati?',
    'pos_layout.assignPos': 'Associa POS',
    'pos_layout.modal.warning': 'Attenzione',
    'pos_layout.modal.publish.description':
        'Le seguenti categorie del layout non hanno prodotti associati: \n• {categories} \nVuoi confermare la pubblicazione di questo layout?',
    'pos_layout.modal.save.description':
        'Le seguenti categorie del layout non hanno prodotti associati: \n• {categories} \nVuoi confermare il salvataggio di questo layout?',
    'pos_layout.customPrice': 'Prezzo libero',
    'pos_layout.functions.create.title': 'Aggiungi un tasto funzione',
    'pos_layout.functions.edit.title': 'Modifica il tasto funzione',
    'pos_layout.functions.type': 'Tipo di tasto',
    'pos_layout.functions.type.placeholder': 'Seleziona un tipo',
    'pos_layout.functions.type.webview': 'Link Web / URL',
    'pos_layout.functions.name': 'Nome del tasto',
    'pos_layout.functions.url': 'Link Web/URL di destinazione',
    'pos_layout.functions.submit': 'Salva',
    'pos_layout.functions.verifyLink': 'Verifica il link',
    'pos_layout.functions.widthPercent': 'Larghezza',
    'pos_layout.functions.heightPercent': 'Altezza',

    // POS DEVICE
    'pos_device.role.independent': 'Indipendente',
    'pos_device.role.master': 'Principale',
    'pos_device.role.slave': 'Dipendente',
    'pos_device.role.independent.plural': 'Indipendenti',
    'pos_device.role.master.plural': 'Principali',
    'pos_device.role.slave.plural': 'Dipendenti',

    // ACTIONS
    'action.action': 'Azione',
    'action.edit': 'Modifica',
    'action.duplicate': 'Duplica',
    'action.copy': 'Copia',
    'action.export': 'Esporta',
    'action.publish': 'Pubblica',
    'action.delete': 'Elimina',
    'action.hide': 'Nascondi',

    // CUSTOMERS
    'customers.page.title': 'Clienti',
    'customers.page.description': 'Consulta i tuoi clienti',
    'customers.id': 'ID',
    'customers.name': 'Cliente',
    'customers.email': 'Email',
    'customers.phone': 'Numero di telefono',
    'customers.totalSpentAmount': 'Totale speso',
    'customers.orderCount': 'Numero di ordini',
    'customers.averageCart': 'Carrello medio',
    'customers.lastOrder': 'Ultimo ordine',
    'customers.frequency': 'Frequenza',
    'customers.status': 'Stato',
    'customers.ewalletBalance': 'Saldo E-Wallet',
    'customers.archivedAt': 'Archiviato il',
    'customers.disabledAt': 'Disattivato il',
    'customers.showArchivedCustomers': 'Mostra clienti archiviati',
    'customers.showDisabledCustomers': 'Mostra clienti disattivati',
    'customers.options': 'Opzioni',
    'customers.domainNames': 'Nomi di dominio',
    'customers.selectDomainNames': 'Seleziona nomi di dominio',
    'customers.groups': 'Gruppi',
    'customers.selectGroups': 'Seleziona gruppi',

    // MENU
    'menu.name': 'Nome del menu',
    'menu.categories': 'Categorie',
    'menu.products': 'Prodotti',
    'menu.functions': 'Funzioni',
    'menu.page.title': 'Menu',
    'menu.page.description': 'Crea e gestisci i tuoi menu',
    'menu.table.associatedChannels': 'Canali associati',
    'menu.action.newMenu': '+ Nuovo menu',
    'menu.action.manualImportCrous': 'Forza Import Crous',
    'menu.action.seeOperations': 'Vedi operazioni',
    'menu.action.changeColor': 'Cambia colore',
    'menu.action.editProduct': 'Modifica prodotto',
    'menu.action.editCategory': 'Modifica categoria',
    'menu.action.editFunction': 'Modifica la funzione',
    'menu.action.import': 'Importa un menu',
    'menu.action.noImport': 'Non desidero importare un file',
    'menu.modal.manualImportCrous.title': 'Importazione manuale del catalogo CROUS',
    'menu.modal.manualImportCrous.description':
        "Sei sicuro di voler lanciare un'importazione manuale del catalogo del CROUS per questo ristorante?",
    'menu.action.aiMenuScan': 'IA Scan (beta)',
    'menu.modal.aiMenuScan.title': 'Digitalizza il tuo nuovo menu (beta)',
    'menu.modal.aiMenuScan.description.part1': 'Importa il tuo nuovo menu in formato PDF o immagine',
    'menu.modal.aiMenuScan.description.part2': 'Clicca su genera il menu Excel',
    'menu.modal.aiMenuScan.description.part3':
        'Scarica automaticamente il file Excel del nuovo menu con le informazioni disponibili',
    'menu.modal.aiMenuScan.action.cancel': 'Annulla',
    'menu.modal.aiMenuScan.action.generate': 'Genera il menu excel',
    'menu.modal.bannersDeactivated':
        '{count, plural, one {# banner promozionale è stato disattivato} other {# banner promozionali sono stati disattivati}}',
    'menu.modal.create.importMenu': 'Importa un menu',
    'menu.modal.create.createMenu': 'Crea un menu',
    'menu.modal.error.wrongName': 'Inserisci un nome valido',
    'menu.modal.create.import.excel.tab': 'Excel',
    'menu.modal.create.import.json.tab': 'JSON',
    'menu.modal.create.import.pos.tab': 'Cassa',
    'menu.modal.create.import.excel.title': 'Aggiungi un nuovo menu',
    'menu.modal.create.import.excel.description.firstPart': 'Scarica il {fileTemplate} sul tuo computer',
    'menu.modal.create.import.excel.description.secondPart':
        'Compila il file modello con le informazioni dei tuoi prodotti che compongono il nuovo menu',
    'menu.modal.create.import.excel.description.thirdPart':
        'Importa il tuo nuovo file cliccando sul pulsante qui sotto',
    'menu.modal.create.import.pos.title': 'Importa un menu esistente',
    'menu.modal.create.import.pos.description.firstPart': 'Scegli una cassa innovorder di cui vuoi importare il menu',
    'menu.modal.create.import.json.title': 'Importa un menu esistente',
    'menu.modal.create.import.json.description.firstPart': 'Verifica che il tuo file sia in formato JSON',
    'menu.modal.create.import.json.description.secondPart':
        'Importa il tuo nuovo file cliccando sul pulsante qui sotto',
    'menu.modal.duplicate.title': 'Duplica un menu',
    'menu.modal.delete.title': 'Elimina un menu',
    'menu.modal.delete.description': 'Sei sicuro di voler eliminare il menu: "{menuName}"?',
    'menu.modal.copy.title': 'Copia un menu',
    'menu.modal.publish.title': 'Pubblica il menu',
    'menu.modal.publish.autoPublish': 'Ricarica i totem dopo la convalida',
    'menu.modal.publish.devicePublish': 'Pubblica i menu sui seguenti POS:',
    'menu.modal.publish.deliverooPublish': 'Pubblica i menu sui seguenti marchi Deliveroo:',
    'menu.modal.publish.ubereatsPublish': 'Pubblica i menu sui seguenti marchi UberEats:',
    'menu.modal.publish.duplicateBarCode':
        '\n- Il codice a barre {barCode} è duplicato per i seguenti prodotti: {products}',
    'menu.modal.error.name': 'Inserisci un nome nel campo dedicato',
    'menu.modal.error.channels': "Devi disattivare l'opzione di sincronizzazione con le casse associate",
    'menu.modal.menu.name': 'Nome del menu',
    'menu.modal.message.defaultIncompatibleDisclaimer':
        'Puoi associare solo casse master o indipendenti con versione 7.0 minima',
    'menu.modal.message.versionIncompatibleDisclaimer': 'Puoi associare solo casse con versione {values} minima',
    'menu.modal.message.roleIncompatibleDisclaimer': 'Non puoi associare casse {values}',
    'menu.modal.channels.shouldSyncPos': 'Sincronizzazione con le casse',
    'menu.modal.channels.isSyncFromPosEnabled': 'Aggiorna il menu in caso di modifiche dalle casse associate',
    'menu.modal.channels.selectActive': 'Attiva il menu sui seguenti canali',
    'menu.modal.channels.associatedChannels': 'Canali associati',
    'menu.modal.channels.pos.selectActive': 'Seleziona le casse da associare al menu',
    'menu.modal.channels.deliveroo.selectActive': 'Seleziona i marchi Deliveroo da associare al menu',
    'menu.modal.channels.ubereats.selectActive': 'Seleziona i marchi UberEats da associare al menu',
    'menu.modal.channels.pos.notFound': 'Nessuna cassa trovata.',
    'menu.modal.channels.associatePos': 'Associa casse',
    'menu.modal.channels.associateDeliveroo': 'Associa marchi Deliveroo',
    'menu.modal.channels.associateUberEats': 'Associa marchi UberEats',
    'menu.modal.channels.editMenu': 'Modifica del menu',
    'menu.modal.channels.createMenu': 'Creazione del menu',
    'menu.modal.channels.selectPos': 'Selezione delle casse',
    'menu.modal.channels.selectDeliveroo': 'Selezione dei marchi Deliveroo',
    'menu.modal.channels.selectUberEats': 'Selezione dei marchi UberEats',
    'menu.modal.externalId': 'Codice esterno',
    'menu.modal.warn.shift.title': 'Operazione pericolosa',
    'menu.modal.warn.shift.text':
        "La modifica di un menu durante un servizio può disturbare l'esperienza del cliente sui totem associati.",
    'menu.modal.warn.shift.button': 'OK',

    'menu.importPOS.cancel': 'Non ora',
    'menu.importPOS.title': 'Importazione dei menu casse mancanti sul backoffice',
    'menu.importPOS.step1.title': 'Nuovo: Aggiungi i menu delle tue casse qui con un clic!',
    'menu.importPOS.step1.bullet.1': 'Una gestione più semplice e approfondita del layout e dei menu',
    'menu.importPOS.step1.bullet.2': 'La possibilità di preparare il layout in anticipo e attivarlo con un clic',
    'menu.importPOS.step1.bullet.3': 'La possibilità di usare lo stesso menu per cassa, totem e ordine online',
    'menu.importPOS.step1.info':
        'Solo le casse con versione superiore a 7 e di categoria indipendente o master possono avere il loro menu sul back-office',
    'menu.importPOS.step2.pos': 'Casse importate sul back-office',
    'menu.importPOS.step2.switch': 'Aggiorna il menu in caso di future modifiche dalla cassa associata',
    'menu.importPOS.step3.title': 'Tutto a posto!',
    'menu.importPOS.step3.subtitle': 'Ora puoi gestire le tue casse direttamente dal back-office!',
    'menu.importPOS.step3.link': 'Accedi alla documentazione',
    'menu.importPOS.step3.info1': 'Clicca sul menu di tua scelta per consultarlo e modificarlo',
    'menu.importPOS.step3.info2':
        'Puoi duplicare un menu per preparare la tua prossima carta o modificare per ogni menu le casse e altre modalità di consumo associate',
    'menu.importPOS.step3.info3':
        "Finché non pubblichi un menu, rimarrà invariato sulle casse associate.\n<strong>Devi quindi effettuare l'azione di pubblicare affinché le modifiche apportate al menu sul back-office siano aggiornate sulle casse.</strong>\nQuesto può essere fatto nelle opzioni di ogni menu sulla pagina dei menu o dalla pagina del layout.",

    'menuoperation.page.title': 'Operazioni sui menu',
    'menuoperation.page.description': 'Trova le operazioni sui menu per il tuo ristorante',
    'menuoperation.type': 'Tipo',
    'menuoperation.type.update': 'Aggiornamento',
    'menuoperation.type.publish': 'Pubblicazione',
    'menuoperation.type.propagation': 'Propagazione',
    'menuoperation.message.from': 'Da',
    'menuoperation.message.from.brandMenu': 'Da menu marchio:',
    'menuoperation.message.to': 'A',
    'menuoperation.errorModal.title': 'Report della pubblicazione',
    'menuoperation.errorModal.message': 'La pubblicazione non è riuscita.',
    'menuoperation.errorModal.checklist.intro': 'Verifica i seguenti punti prima di confermare nuovamente:',
    'menuoperation.errorModal.checklist.requiredFields': 'Tutti i campi obbligatori del prodotto sono completati',
    'menuoperation.errorModal.checklist.requiredMenuImage': "Il menu ha un'immagine",
    'menuoperation.errorModal.checklist.noSubCategories': 'Il menu non ha sottocategorie',
    'menuoperation.errorModal.checklist.imageFormats':
        'Le immagini rispettano i formati richiesti (tra 320x320px e 6000x6000px)',
    'menuoperation.errorModal.checklist.syncSettings':
        'Le impostazioni di sincronizzazione sono configurate correttamente',
    'menuoperation.errorModal.checklist.stepDepthLimit':
        'Il limite di profondità dei passaggi non è superato (2 livelli max per Deliveroo).',
    'menuoperation.actions': 'Azioni',
    'menuoperation.action.download': 'Menu precedente',
    'menuoperation.action.download.before': 'Menu iniziale',
    'menuoperation.action.download.after': 'Menu finale',
    'menuoperation.download.error.title': 'Download fallito',
    'menuoperation.download.error': 'Impossibile scaricare il menu archiviato. Riprova più tardi.',

    // Menu tags
    'menu.tags.title': 'Tag',
    'menu.tags.table.name': 'Nome',
    'menu.tags.create.link': 'Crea un nuovo tag',
    'menu.tags.create.error.alreadyTaken': 'Questo tag esiste già',
    'menu.tags.edit.title': 'Modifica un tag',
    'menu.tags.create.title': 'Crea un tag',
    'menu.tags.form.color.label': 'Colore',
    'menu.tags.delete.confirm': 'Sei sicuro di voler eliminare {count} tag?',

    // Menu functions
    'menu.functions.title': 'Funzioni',
    'menu.functions.subtitle': 'Aggiungi, modifica e assegna funzioni al tuo layout POS',
    'menu.functions.table.name': 'Nome',
    'menu.functions.table.type': 'Tipo',
    'menu.functions.table.status': 'Stato',
    'menu.functions.table.action': 'Azione',
    'menu.functions.status.active': 'Attiva',
    'menu.functions.status.inactive': 'Inattiva',
    'menu.functions.noData': 'Nessuna funzione creata',
    'menu.functions.delete.confirm': 'Sei sicuro di voler eliminare {count} funzione/i?',

    // Menu steps
    'menu.steps.title': 'Passaggi',
    'menu.steps.add.title': 'Nuovo Passaggio',
    'menu.steps.duplicate': 'Duplica',
    'menu.steps.convert': 'Converti',
    'menu.steps.delete.confirm': 'Sei sicuro di voler eliminare {count} passaggio/i?',
    'menu.steps.convert.toCustomization.confirm':
        'Dopo la conversione, sarà necessario configurare i dettagli e le opzioni del tuo passaggio di personalizzazione, vuoi continuare?',
    'menu.steps.convert.toCrossSelling.confirm':
        'Convertendo il passaggio, le informazioni sulle scelte minimo/massimo e le opzioni attivate non saranno conservate, vuoi continuare?',
    'menu.steps.bulkConvertError':
        'Per poter convertire in gruppo, tutti i passaggi devono essere dello stesso tipo (vendita aggiuntiva o personalizzazione)',
    'menu.steps.column.name': 'Nome',
    'menu.steps.column.choices': 'Scelte possibili',
    'menu.steps.column.min': 'Min',
    'menu.steps.column.max': 'Max',
    'menu.steps.column.stepRef': 'Riferimento',
    'menu.steps.column.parentsProducts': 'Numero di prodotti genitori',
    'menu.steps.edit.title': 'Modifica un passaggio',
    'menu.steps.editCustomization.title': 'Modifica un passaggio di personalizzazione',
    'menu.steps.editCrossSelling.title': 'Modifica un passaggio di vendita aggiuntiva',
    'menu.steps.createCustomization.title': 'Crea una personalizzazione',
    'menu.steps.createCrossSelling.title': 'Crea una vendita aggiuntiva',
    'menu.steps.convert.title': 'Attenzione',
    'menu.steps.column.type': 'Tipo',
    'menu.steps.typeName.1': 'Personalizzazione',
    'menu.steps.typeName.2': 'Vendita aggiuntiva',
    'menu.steps.form.ticketLabel': 'Etichetta del ticket',
    'menu.steps.form.minChoice': 'Scelta minima',
    'menu.steps.form.maxChoice': 'Scelta massima',
    'menu.steps.form.stepRef': 'Riferimento',
    'menu.steps.form.maxChoice.error.greaterThanMin': 'Deve essere superiore al minimo',
    'menu.steps.form.isDescriptionDisplayEnabled': 'Mostra le descrizioni',
    'menu.steps.form.options': 'Opzioni',
    'menu.steps.form.isExcessAllowed': 'Supplemento',
    'menu.steps.form.isGroupEnabled': 'Raggruppamento',
    'menu.steps.form.isImageDisplayEnabled': 'Mostra le immagini',
    'menu.steps.form.isQuantitySelectionEnabled': 'Quantità',
    'menu.steps.form.isWeightStrategyEnabled': 'Usa i pesi',
    'menu.steps.form.stepProduct': 'Lista delle scelte',
    'menu.steps.form.stepProduct.add': 'Aggiungi una scelta',
    'menu.steps.form.stepProduct.orderByName': 'Ordina per nome',
    'menu.steps.form.stepProduct.orderByPrice': 'Ordina per prezzo',
    'menu.steps.form.stepProduct.setForAllOption': 'Propaga i valori',
    'menu.steps.form.stepProduct.name': 'Nome',
    'menu.steps.form.stepProduct.price': 'Prezzo',
    'menu.steps.form.stepProduct.excessPrice': 'Prezzo in supplemento',
    'menu.steps.form.stepProduct.weight': 'Peso unitario',
    'menu.steps.form.stepProduct.group': 'Gruppo',
    'menu.steps.form.stepProduct.maxQuantity': 'Quantità massima',
    'menu.steps.form.stepProduct.posIsSelectedByDefault': 'Selezionato per default (POS)',
    'menu.steps.form.stepProduct.posMinProductQuantity': 'Quantità minima (POS)',
    'menu.steps.form.stepProduct.posDefaultProductQuantity': 'Quantità predefinita (POS)',
    'menu.steps.form.stepProduct.displayPOSFields': 'Mostra attributi POS',
    'menu.steps.form.stepProduct.import': 'Importa',
    'menu.steps.form.stepProduct.importWithPrice': 'Importa con prezzo',
    'menu.steps.form.stepProduct.importWithoutPrice': 'Importa senza prezzo',
    'menu.steps.propagate.title': 'Propaga passaggi',

    // Menu categories
    'menu.categories.title': 'Categorie',
    'menu.categories.subtitle': 'Modifica le categorie del tuo menu',
    'menu.categories.addCategory': 'Crea una categoria',
    'menu.categories.noData': 'Nessuna categoria nel menu.',
    'menu.categories.addProduct': 'Aggiungi un prodotto',
    'menu.categories.createProduct': 'Crea un prodotto',
    'menu.categories.deleteCategory': 'Elimina',
    'menu.categories.removeProduct': 'Rimuovi',
    'menu.categories.deleteCategory.confirm':
        'Sei sicuro di voler eliminare questa categoria?\nNon sarà più disponibile e i suoi figli (prodotti e sottocategorie) diventeranno orfani.',
    'menu.categories.create.title': 'Crea una categoria',
    'menu.categories.edit.title': 'Modifica una categoria',
    'menu.categories.products': '{productCount, plural, =0 {nessun prodotto} one {# prodotto} other {# prodotti}}',
    'menu.categories.create.error.alreadyTaken': 'Questa categoria esiste già',

    // Menu products
    'menu.products.title': 'Prodotti',
    'menu.products.table.image': 'Immagine',
    'menu.products.table.name': 'Nome',
    'menu.products.table.categories': 'Categorie',
    'menu.products.table.price': 'Prezzo',
    'menu.products.table.vat': 'IVA',
    'menu.products.table.sku': 'SKU',
    'menu.products.table.tags': 'Tag',
    'menu.products.reload.kiosk': 'Ricarica',
    'menu.products.create.link': 'Crea un prodotto',
    'menu.products.massEdit': 'Modifica di gruppo',
    'menu.products.duplicate': 'Duplica',
    'menu.products.copy': 'Propaga',
    'menu.products.copy.title': 'Propaga i prodotti',
    'menu.products.copy.form.restaurants.title': 'Seleziono i miei ristoranti target',
    'menu.products.copy.form.restaurants.label': 'Destinazioni',
    'menu.products.copy.form.restaurants.tooltip':
        'Scegli i ristoranti del marchio che riceveranno la propagazione del prodotto e/o dei suoi passaggi.',
    'menu.products.copy.form.restaurants.tooltip.title': 'Seleziono i miei ristoranti target',
    'menu.products.copy.form.restaurants.tooltip.example':
        'Dal menu del marchio, decidi di propagare il dessert Brownie solo verso i ristoranti A e B → solo questi ristoranti avranno questo nuovo prodotto.',
    'menu.products.copy.form.updateIgnoreAttributes.title':
        'Durante la propagazione, non desidero sovrascrivere le seguenti proprietà su:',
    'menu.products.copy.form.updateIgnoreAttributes.tooltip':
        'Durante la propagazione di un prodotto dal marchio verso un ristorante dove esiste già (singolarmente o tramite un passaggio), puoi scegliere di conservare alcune proprietà di questo prodotto singolo: tag, categoria genitore, immagine, prezzo, IVA, nome e descrizione.',
    'menu.products.copy.form.updateIgnoreAttributes.tooltip.title':
        'Conserva alcune proprietà durante la propagazione di un prodotto già esistente',
    'menu.products.copy.form.updateIgnoreAttributes.tooltip.example':
        'Il prodotto singolo Cookie esiste già nel ristorante con un\'immagine personalizzata e un prezzo specifico → se spunti "Immagine" e "Prezzo", questi valori saranno conservati, anche dopo la propagazione dal marchio.\n\n👉 Per i nuovi prodotti, tutte le proprietà del marchio sono propagate automaticamente.',
    'menu.products.copy.form.updateIgnoreAttributes.subtitle.products':
        'Prodotti già presenti nei menu ristoranti target',
    'menu.products.copy.form.updateIgnoreAttributes.subtitle.steps': 'Passaggi già presenti nei menu ristoranti target',
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.title':
        'Conserva alcune proprietà durante la propagazione di un passaggio già esistente',
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.description':
        "Durante la propagazione di un passaggio dal marchio verso un ristorante dove esiste già, puoi scegliere di conservare alcune proprietà di questo passaggio: prezzo del prodotto nel passaggio, quantità massima per prodotto (se l'opzione Quantità è attivata) e prezzo in supplemento.",
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.example':
        'Nel ristorante, il passaggio Scegli un dessert ha un Cookie a 2 € con quantità max di 3.\nIl marchio propaga nel passaggio un Cookie a 1 € con quantità max di 1.\n→ Se conservi "Prezzo prodotto" e "Quantità max", il ristorante mantiene Cookie a 2 € e quantità max di 3.\n\n👉 Per i nuovi passaggi, tutte le proprietà del marchio sono propagate automaticamente.',
    'menu.products.copy.form.updateIgnoreAttributes.placeholder':
        'Durante la propagazione, non desidero sovrascrivere le seguenti proprietà',
    'menu.products.copy.form.attribute.price': 'Prezzo',
    'menu.products.copy.form.attribute.vat': 'IVA',
    'menu.products.copy.form.attribute.name': 'Nome',
    'menu.products.copy.form.attribute.description': 'Descrizione',
    'menu.products.copy.form.attribute.categories': 'Categorie genitori',
    'menu.products.copy.form.attribute.tags': 'Tag',
    'menu.products.copy.form.attribute.imageId': 'Immagine',
    'menu.products.copy.form.attribute.exceedPrice': 'Prezzo in supplemento',
    'menu.products.copy.form.attribute.maxProductQuantity': 'Quantità massima',
    'menu.products.copy.form.publishAfterCopy.title': 'Durante la propagazione, desidero:',
    'menu.products.copy.form.publishAfterCopy.tooltip': 'Pubblicare automaticamente i menu sulle casse associate',
    'menu.products.copy.form.publishAfterCopy.tooltip.title': 'Pubblicazione automatica',
    'menu.products.copy.form.publishAfterCopy.tooltip.example':
        'Se attivato, i menu saranno pubblicati automaticamente su tutte le casse associate ai ristoranti target.',
    'menu.products.copy.form.publishAfterCopy': 'Pubblica automaticamente i menu sulle casse associate',
    'menu.products.copy.form.publishAfterCopy.disclaimer':
        '⚠️ Attenzione, è necessario aggiungere sul layout i nuovi prodotti propagati',
    'menu.products.copy.form.strategy.title': 'Strategia di propagazione per i passaggi già esistenti sui menu target',
    'menu.products.copy.form.strategy.tooltip':
        'I passaggi già presenti nel ristorante sono sostituiti da quelli configurati sul menu marchio (prodotti e prezzi inclusi).',
    'menu.products.copy.form.strategy.tooltip.title': 'Strategia: Aggiorna i passaggi esistenti',
    'menu.products.copy.form.strategy.tooltip.example':
        'Ristorante A ha il passaggio "Scegli un dessert" con Pane perso, Frutta, Cookie (2€).\nIl marchio lo propaga con Cookie (1€), Brownie (2€) → Ristorante A avrà ora Cookie (1€), Brownie (2€).\n\n👉 Il prodotto singolo Cookie è aggiornato, il prodotto singolo Brownie è creato e il prodotto Pane perso è rimosso dal passaggio.',
    'menu.products.copy.form.strategy.replace':
        'Aggiorna i passaggi esistenti del/i menu ristorante/i con quelli propagati dal menu marchio',
    'menu.products.copy.form.strategy.replace.tooltip.title': 'Strategia: Aggiorna i passaggi esistenti',
    'menu.products.copy.form.strategy.replace.tooltip.description':
        'I passaggi già presenti nel ristorante sono sostituiti da quelli configurati sul menu marchio (prodotti e prezzi inclusi).',
    'menu.products.copy.form.strategy.replace.tooltip.example':
        'Ristorante A ha il passaggio "Scegli un dessert" con Pane perso, Frutta, Cookie (2€).\nIl marchio lo propaga con Cookie (1€), Brownie (2€) → Ristorante A avrà ora Cookie (1€), Brownie (2€).\n\n👉 Il prodotto singolo Cookie è aggiornato, il prodotto singolo Brownie è creato e il prodotto Pane perso è rimosso dal passaggio.',
    'menu.products.copy.form.strategy.update_and_keep_existing':
        'Aggiorna i passaggi esistenti del/i menu ristorante/i e conserva i prodotti esistenti non presenti nel passaggio del menu marchio',
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.title':
        'Strategia: Aggiorna e conserva i prodotti esistenti',
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.description':
        'I passaggi del ristorante sono aggiornati con quelli del marchio, ma i prodotti già presenti e assenti dal menu marchio sono conservati.',
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.example':
        'Ristorante A ha il passaggio "Scegli un dessert" con Pane perso (1€), Frutta (2€), Cookie (2€).\nIl marchio lo propaga con Cookie (1€), Brownie (2€) → Ristorante A avrà Pane perso (1€), Frutta (2€), Cookie (1€), Brownie (2€).\n\n👉 Il prodotto singolo Cookie è aggiornato, il prodotto singolo Brownie è creato e il prodotto Pane perso è conservato nel passaggio.',
    'menu.products.copy.form.strategy.keep_existing': 'Non modificare i passaggi già esistenti nei menu target',
    'menu.products.copy.form.strategy.keep_existing.tooltip.title': 'Strategia: Non modificare i passaggi esistenti',
    'menu.products.copy.form.strategy.keep_existing.tooltip.description':
        'I passaggi già presenti nel ristorante non sono modificati durante la propagazione.',
    'menu.products.copy.form.strategy.keep_existing.tooltip.example':
        'Ristorante A ha il passaggio "Scegli un dessert" con Pane perso (1€), Frutta (2€), Cookie (2€).\nIl marchio lo propaga con Cookie (1€), Brownie (2€) → Ristorante A conserva Pane perso (1€), Frutta (2€), Cookie (2€).\n\n👉 Il prodotto singolo Cookie è aggiornato e il prodotto singolo Brownie è creato.',
    'menu.products.copy.form.channel.title': 'Seleziono i miei canali target',
    'menu.products.copy.form.channel.tooltip':
        'Scegli i canali (es: Cassa, Ordine Online (CEL), Totem) sui quali la propagazione del prodotto e/o dei suoi passaggi sarà applicata.',
    'menu.products.copy.form.channel.tooltip.title': 'Seleziono i miei canali target',
    'menu.products.copy.form.channel.tooltip.example':
        'Propaghi il dessert Brownie ma scegli solo Totem → il prodotto sarà visibile solo sui menu totem dei ristoranti selezionati.',
    'menu.products.copy.form.channel.web': 'Ordine online o al tavolo',
    'menu.products.copy.form.channel.kiosk': 'Totem',
    'menu.products.copy.form.channel.pos': 'Casse',
    'menu.products.copy.form.channel.marketplace': 'Marketplace (UberEats/Deliveroo)',
    'menu.products.copy.form.channel.null': 'Non associato',
    'menu.products.copy.form.other.strategies.title': 'Creazione dei nuovi prodotti',
    'menu.products.copy.form.other.strategies.tooltip':
        'Durante la propagazione di nuovi prodotti, il marchio propaga nel passaggio un Cookie a 2 € con quantità max di 3. Se conservi "Prezzo prodotto" e "Quantità max", il ristorante mantiene Cookie a 2 € e quantità max di 3. → Se conservi "Prezzo prodotto" e "Quantità max", il ristorante mantiene Cookie a 2 € e quantità max di 3.',
    'menu.products.copy.form.other.strategies.tooltip.title': 'Creazione dei nuovi prodotti',
    'menu.products.copy.form.other.strategies.tooltip.example':
        'Durante la propagazione di nuovi prodotti, il marchio propaga nel passaggio un Cookie a 2 € con quantità max di 3. Se conservi "Prezzo prodotto" e "Quantità max", il ristorante mantiene Cookie a 2 € e quantità max di 3.\n→ Se conservi "Prezzo prodotto" e "Quantità max", il ristorante mantiene Cookie a 2 € e quantità max di 3.',
    'menu.products.copy.form.other.strategies.tags': 'Crea al volo i tag mancanti dei prodotti',
    'menu.products.copy.form.other.strategies.categories': 'Crea al volo le categorie mancanti dei prodotti',
    'menu.products.copy.form.posMenus.title': 'Menu attivi della Cassa',
    'menu.products.copy.form.posMenus.description':
        'Questa tabella mostra solo i ristoranti dove sono attivi più menu cassa. Se un solo menu cassa è attivo, la propagazione avviene per default su quel menu.',
    'menu.products.copy.form.posMenus.tooltip':
        'Seleziona i menu Cassa sui quali vuoi propagare i prodotti per ogni ristorante.',
    'menu.products.copy.form.posMenus.tooltip.title': 'Selezione dei menu Cassa',
    'menu.products.copy.form.posMenus.tooltip.example':
        'Se un ristorante ha più menu Cassa, puoi scegliere di propagare su uno o più menu specifici.',
    'menu.products.copy.form.posMenus.column.restaurant': 'Nome del ristorante',
    'menu.products.copy.form.posMenus.column.menus': 'Menu attivo/i',
    'menu.products.copy.form.posMenus.empty': 'Nessun menu Cassa disponibile per i ristoranti selezionati',
    'menu.products.copy.form.posMenus.placeholder': 'Seleziona i menu...',
    'menu.products.copy.form.posMenus.warning':
        '⚠️ Attenzione, per default, tutti i menu attivi di un ristorante sono selezionati per la propagazione dei prodotti.',
    'menu.products.copy.form.marketplaceMenus.title': 'Menu attivi dei Marketplace',
    'menu.products.copy.form.marketplaceMenus.description':
        'Questa tabella mostra solo i ristoranti dove sono attivi più menu marketplace. Se un solo menu marketplace è attivo, la propagazione avviene per default su quel menu.',
    'menu.products.copy.form.marketplaceMenus.tooltip':
        'Seleziona i menu marketplace sui quali vuoi propagare i prodotti per ogni ristorante.',
    'menu.products.copy.form.marketplaceMenus.tooltip.title': 'Selezione dei menu Marketplace',
    'menu.products.copy.form.marketplaceMenus.tooltip.example':
        'Se un ristorante ha più menu marketplace, puoi scegliere di propagare su uno o più menu specifici.',
    'menu.products.copy.form.marketplaceMenus.column.restaurant': 'Nome del ristorante',
    'menu.products.copy.form.marketplaceMenus.column.menus': 'Menu attivo/i',
    'menu.products.copy.form.marketplaceMenus.empty':
        'Nessun menu marketplace disponibile per i ristoranti selezionati',
    'menu.products.copy.form.marketplaceMenus.placeholder': 'Seleziona i menu...',
    'menu.products.copy.form.marketplaceMenus.warning':
        '⚠️ Attenzione, per default, tutti i menu attivi di un ristorante sono selezionati per la propagazione dei prodotti.',
    'menu.products.copy.form.publishAfterCopy.marketplace.title': 'Durante la propagazione, desidero:',
    'menu.products.copy.form.publishAfterCopy.marketplace': 'Pubblica automaticamente i menu sui marketplace associati',
    'menu.products.copy.form.publishAfterCopy.marketplace.disclaimer':
        'I menu saranno pubblicati sui marketplace associati ai ristoranti.',
    'menu.products.copy.form.disclaimer':
        '⚠️ Attenzione, questi prodotti saranno copiati su tutti i ristoranti selezionati, in tutti i loro menu. Prima di salvare, verifica nome, descrizione, immagine, IVA, prezzo.',
    'menu.copy.validate.title': 'Verifica dei prodotti/passaggi da propagare',
    'menu.copy.validate.success':
        'Tutti i prodotti/passaggi da propagare hanno uno SKU/riferimento passaggio configurato',
    'menu.copy.validate.warning': 'SKU non inserito nella scheda prodotto del menu marchio',
    'menu.copy.validate.error': 'SKU duplicato o riferimento passaggio non inserito nel menu marchio',
    'menu.copy.validate.step.missing.identifier.detail': 'Riferimento passaggio non inserito sul passaggio',
    'menu.copy.validate.product.missing.identifier.detail': 'SKU non inserito sul prodotto',
    'menu.copy.validate.step.duplicate.identifier.detail':
        'Conflitto sul riferimento <b>{identifier}</b> tra i passaggi',
    'menu.copy.validate.product.duplicate.identifier.detail': 'Conflitto sullo SKU <b>{identifier}</b> tra i prodotti',
    'menu.products.overwrite': 'Spunta la casella a sinistra per modificare i campi',
    'menu.products.overwriteRelations':
        'Spunta la casella a sinistra per sostituire tutto invece di aggiungere elementi',
    'menu.products.error.alreadyTaken': 'Questo prodotto esiste già',
    'menu.products.error.billingCodeRequired': 'La fatturazione automatica richiede di compilare questo campo',
    'menu.products.add.title': 'Aggiungi un prodotto',
    'menu.products.edit.title': 'Modifica un prodotto',
    'menu.products.propagate.title': 'Propaga prodotti',
    'menu.products.create.title': 'Crea un prodotto',
    'menu.products.delete.confirm': 'Sei sicuro di voler eliminare {count} prodotto/i?',
    'menu.products.form.price': 'Prezzo Lordo',
    'menu.product.form.pricePerkg': 'Prezzo Lordo / kg',
    'menu.products.form.priceType': 'Tipo di prezzo',
    'menu.products.form.priceType.placeholder': 'Tipo di prezzo',
    'menu.products.form.priceType.fixed': 'Prezzo fisso',
    'menu.products.form.priceType.customizablePrice': 'Prodotto a prezzo libero',
    'menu.products.form.priceType.customizablePriceAndLabel': 'Prodotto a prezzo e etichetta liberi',
    'menu.products.form.measurementUnit': 'Misurato per',
    'menu.products.form.measurementUnit.placeholder': 'Misurato per',
    'menu.products.form.measurementUnit.unit': 'Unità',
    'menu.products.form.measurementUnit.kg': 'kg',
    'menu.products.form.kg.channelRestriction': 'I prodotti in kg non sono disponibili sul canale Totem.',
    'menu.products.form.availability': 'Disponibilità per canale',
    'menu.products.form.webAvailability': 'Web',
    'menu.products.form.kioskAvailability': 'Totem',
    'menu.products.form.servingCount': 'Numero di coperti',
    'menu.products.form.barCode': 'Codice a barre',
    'menu.products.form.ticketLabel': 'Etichetta di produzione',
    'menu.products.form.ticketLabel.checkbox': "Avere un'etichetta di produzione diversa dal nome del prodotto",
    'menu.products.form.noVat': 'Prodotto non soggetto a IVA',
    'menu.products.form.vat': 'IVA predefinita',
    'product.vatGroup': 'Gruppo IVA',
    'product.vatGroup.withHint': 'Gruppo IVA (sul posto / da asporto / consegna)',
    'product.selectVatGroup': 'Seleziona un gruppo IVA',
    'product.vatGroup.noOperationZone': 'Nessuna zona operativa configurata per questo ristorante',
    'product.vatGroup.eatIn': 'Sul posto',
    'product.vatGroup.takeAway': 'Da asporto',
    'product.vatGroup.delivery': 'Consegna',
    'product.vatGroup.hint':
        "Per modificare l'IVA per modalità di consumo, modifica ora il campo « Gruppo IVA (sul posto / da asporto / consegna) »",
    'menu.products.form.image.placeholder': 'Immagine',
    'menu.products.form.externalId': 'Codice esterno',
    'menu.products.form.sku': 'sku',
    'menu.products.form.sku.placeholder': 'Scegli uno SKU',
    'menu.products.form.sku.noOption': 'Un nuovo SKU può essere creato solo a livello di marchio',
    'menu.products.form.createSku': 'Crea lo SKU "{value}"',
    'menu.products.form.replaceSkuAll':
        'Sostituisci lo SKU "{currentSku}" con "{value}" (su tutti i prodotti con lo stesso SKU)',
    'menu.products.form.replaceSkuThisProduct':
        'Sostituisci lo SKU "{currentSku}" con "{value}" (solo su questo prodotto)',
    'menu.products.form.createTag': 'Crea il tag "{value}"',
    'menu.products.form.billingCode': 'Codice fattura',
    'menu.products.form.purchasePrice': 'Prezzo contratto',
    'menu.products.form.description': 'Descrizione',
    'menu.products.form.description.tooLong': 'La descrizione non deve superare 1500 caratteri',
    'menu.products.form.additionalInformation': 'Informazioni aggiuntive',
    'menu.products.form.section.options': 'Opzioni',
    'menu.products.form.section.quantity': 'Gestione scorte',
    'menu.products.form.section.externalData': 'Dati esterni',
    'menu.products.form.currentQuantitySwitch': 'Attiva la gestione scorte per il prodotto',
    'menu.products.form.defaultQuantitySwitch': 'Ripristino giornaliero delle scorte',
    'menu.products.form.currentQuantityInput': 'Quantità in magazzino',
    'menu.products.form.defaultQuantityInput': 'Quantità a inizio giornata',
    'menu.products.form.defaultQuantityHint':
        'Ogni giorno tra le 4 e le 5 del mattino, la quantità sarà ripristinata a quella predefinita',
    'menu.products.form.isEligibleLuncheon': 'Idoneo ai buoni pasto',
    'menu.products.form.isFinalProduct': 'Prodotto finale',
    'menu.products.form.subsidizable': 'Prodotto sovvenzionabile',
    'menu.products.form.admissible': 'Prodotto ammissionabile',
    'menu.products.form.shouldMultiplyEntranceFeesAndGrants':
        'Ammissione/Sovvenzione moltiplicata ad ogni aggiunta al carrello',
    'menu.products.form.shouldMultiplyEntranceFeesAndGrants.tooltip':
        "Attivando questa opzione, le ammissioni (e le sovvenzioni) saranno moltiplicate nell'ordine se il prodotto viene aggiunto più volte al carrello o se un altro prodotto con la stessa opzione viene aggiunto. La moltiplicazione avviene entro il limite giornaliero e il tetto definiti nel regime tariffario.",
    'menu.products.form.excludedFromUrssaf': 'Non contare nel minimo urssaf',
    'menu.products.form.section.pos': 'Attributi specifici delle casse',
    'menu.products.form.minQuantity': 'Quantità minima',
    'menu.products.form.alwaysAskForCustomization': 'Chiedi sempre i passaggi',
    'menu.products.form.discountable': 'Autorizza sconti sul prodotto',
    'menu.products.form.isDeposit': 'Prodotto di tipo deposito',
    'menu.products.form.posPrice': 'Importo del deposito',
    'menu.products.form.vatSitIn': 'IVA sul posto',
    'menu.products.form.vatDelivery': 'IVA consegna',
    'menu.products.form.vatTakeAway': 'IVA da asporto',
    'menu.products.form.section.kitchenOptions': 'Opzioni dello schermo cucina',
    'menu.products.form.isMenu': 'È un menu',
    'menu.products.form.is_customization': 'È una personalizzazione',
    'menu.products.form.isProducible': 'Mostra nel riepilogo',
    'menu.products.form.no_kitchen': 'Non mostrare nello schermo cucina',
    'menu.products.form.section.consumptionMode': 'Disponibilità del prodotto in base alla modalità di consumo',
    'menu.products.form.consumptionModeType.mode_sit_in': 'Sul posto',
    'menu.products.form.consumptionModeType.mode_delivery': 'In consegna',
    'menu.products.form.consumptionModeType.mode_take_away': 'Da asporto',
    'menu.products.form.consumptionModeType.mode_drive': 'Drive',
    'menu.products.form.tags': 'Tag',
    'menu.products.form.tags.placeholder': 'Cerca il/i tag da associare',
    'menu.products.form.steps': 'Passaggi',
    'menu.products.form.steps.page': 'Pagina {pageNumber}',
    'menu.products.form.steps.addToNewPage': 'Aggiungi a una nuova pagina',
    'menu.products.form.steps.addEachToNewPage': 'Aggiungi ogni passaggio a una nuova pagina',
    'menu.products.form.steps.addToPage': 'Pagina a cui aggiungere il passaggio',
    'menu.products.form.steps.addEmptyPage': 'Aggiungi una pagina',
    'menu.products.form.categories': 'Categorie genitori',
    'menu.products.form.productType': 'Tipo',
    'menu.products.form.productType.placeholder': 'Tipo di prodotto',
    'menu.products.form.productType.product': 'Prodotto',
    'menu.products.form.productType.deposit': 'Deposito',
    'menu.products.form.categories.placeholder': 'Cerca la/le categorie genitori',
    'menu.products.form.externalReference': 'Riferimento esterno',
    'menu.products.form.externalReference.placeholder': 'Nome del riferimento',
    'menu.products.form.externalReference.name': 'Nome',
    'menu.products.form.externalReference.value': 'Valore',

    'menu.products.form.machineCode': 'Codice macchina Nayax del prodotto',
    'menu.products.form.steps.add': 'Aggiungi un passaggio',
    'menu.products.form.steps.addPage': 'Trascina il passaggio qui per creare una nuova pagina',
    'menu.products.form.steps.column.name': 'Nome',
    'menu.products.form.steps.column.type': 'Tipo',
    'menu.products.form.steps.column.choices': 'Scelte possibili',
    'menu.products.form.steps.column.position': 'Pagina',
    'menu.products.form.steps.column.subPosition': 'Posizione',
    'menu.products.form.steps.column.min': 'Min',
    'menu.products.form.steps.column.max': 'Max',
    'menu.products.form.steps.column.parentsProducts': 'Numero di prodotti genitori',
    'menu.products.form.steps.cross-selling.add': 'Aggiungi una vendita aggiuntiva',
    'menu.products.form.steps.customization.add': 'Aggiungi una personalizzazione',
    'menu.products.form.steps.type.cross-selling': 'Vendita aggiuntiva',
    'menu.products.form.steps.type.customization': 'Personalizzazione',

    // Report Generations History
    'reportGenerationsHistory.title': 'Cronologia delle generazioni',
    'reportGenerationsHistory.subtitle': 'Qui troverai la cronologia delle tue generazioni di esportazioni.',
    'reportGenerationsHistory.tableCard.title': 'Esportazioni',
    'reportGenerationsHistory.tableCard.subtitle': 'Lista delle esportazioni',
    'reportGenerationsHistory.tableCard.actionLabel': 'Aggiorna la pagina',
    'reportGenerationsHistory.emptyMessage': 'La tua cronologia di generazione è vuota',
    'reportGenerationsHistory.tableHeader.createdAt': 'Data',
    'reportGenerationsHistory.tableHeader.fileName': 'Nome del file',
    'reportGenerationsHistory.tableHeader.reportType': 'Stato',
    'reportGenerationsHistory.tableHeader.status': 'Avanzamento',
    'reportGenerationsHistory.tableHeader.action': 'Scarica',
    'reportGenerationsHistory.tableRow.reportType.pre_invoicing': 'Pre-fatturazione',
    'reportGenerationsHistory.tableRow.reportType.orders': 'Ordini',
    'reportGenerationsHistory.tableRow.reportType.badge_balance': 'Movimenti dei badge',
    'reportGenerationsHistory.tableRow.reportType.sales_summary': 'Riepilogo finanziario',
    'reportGenerationsHistory.tableRow.reportType.collective_catering_sales_summary':
        'Riepilogo finanziario per modalità di gestione',
    'reportGenerationsHistory.tableRow.reportType.ewallet_stats_by_users': 'Saldo dei badge per cliente',
    'reportGenerationsHistory.tableRow.reportType.collective_catering_sales_summary_exclude_tax':
        'Riepilogo finanziario per modalità di gestione Netto',
    'reportGenerationsHistory.tableRow.reportType.ewallet': 'E-wallet',
    'reportGenerationsHistory.tableRow.reportType.accounting': 'Contabile',
    'reportGenerationsHistory.tableRow.reportType.monthly_sales_report': 'Report vendite mensili',
    'reportGenerationsHistory.tableRow.generationStatus.succeed': 'Completato',
    'reportGenerationsHistory.tableRow.generationStatus.in_progress': 'In corso',
    'reportGenerationsHistory.tableRow.generationStatus.failed': 'Fallito',
    'reportGenerationsHistory.tableRow.action.download': 'Scarica',

    // Reports
    'report.emptyMessage': 'Nessun risultato',
    'report.title.monthly_sales_report': 'Report vendite mensili',
    'report.selectDateRangeButton.text': 'Dal {startDate} al {endDate}',
    'report.calendarModal.dateRage.errorMessage': 'Non puoi selezionare più di {maxRangeInDays} giorni',
    'report.calendarModal.title': 'Scegli un periodo',
    'report.calendarModal.submit': 'Conferma',
    'report.filtersButton.text': 'Filtri',
    'report.filtersModal.title': 'Scegli i filtri',
    'report.filtersModal.submit': 'Filtra',
    'report.filtersModal.form.restaurantLabel': 'Ristoranti',
    'report.filtersModal.form.devicesLabel': 'Casse',
    'report.filtersModal.form.sourcesLabel': 'Canali di ordine',
    'report.filtersModal.form.tagsLabel': 'Tag',
    'report.filtersModal.form.consumptionModesLabel': 'Modalità di consumo',
    'report.filtersModal.form.sellersLabel': 'Venditori',
    'report.filtersModal.form.vatsLabel': 'IVA',
    'report.filtersModal.form.categoriesLabel': 'Categorie',
    'report.filtersModal.form.loyaltyLabel': 'Mostra solo gli ordini pagati con la fedeltà',
    'report.filtersModal.form.only_parentsLabel': 'Mostra le categorie genitori',
    'report.filtersModal.saveAs.placeholder': 'Salva con nome...',
    'report.filtersModal.saveAs.save': 'Salva e Applica',
    'report.exportButton.text': 'Esporta',
    'report.exportResultModal.title': 'Esportazione CSV',
    'report.exportResultModal.resultSuccess': "La generazione dell'esportazione è in corso",
    'report.exportResultModal.stayInPage': 'Resta su questa pagina',
    'report.exportResultModal.redirectToGenerationHistory': 'Vedi le esportazioni in corso',
    'report.exportResultModal.resultFail': 'Si è verificato un problema, riprova tra qualche istante',
    'report.savedFiltersDropdown.placeholder': 'Filtri salvati',
    'report.savedFiltersDropdown.deleteModal.title': 'Attenzione',
    'report.savedFiltersDropdown.deleteModal.description': 'Sei sicuro di voler eliminare?',

    // Sales Summary
    'salesSummary.tableCard.title': 'Genera una nuova esportazione',
    'salesSummary.tableCard.subtitle': 'Seleziona i tuoi criteri e i tuoi filtri, clicca su "Genera".',
    'salesSummary.form.choosePeriod': 'Scegli un periodo',
    'salesSummary.form.reportType': 'Formato del report',
    'salesSummary.form.reportType.collectiveCateringSalesSummary': 'Riepilogo finanziario per modalità di gestione',
    'salesSummary.form.reportType.collectiveCateringSalesSummaryExclTax':
        'Riepilogo finanziario per modalità di gestione Netto',
    'salesSummary.form.reportType.salesSummary': 'Riepilogo finanziario',
    'salesSummary.form.restaurants': 'Ristoranti',
    'salesSummary.form.groups': 'Gruppi',
    'salesSummary.form.pricingRules': 'Regime tariffario',
    'salesSummary.form.accountedOrders': 'Ordini contabilizzati',
    'salesSummary.form.accountedOrders.all': 'Ordini + Controscritture',
    'salesSummary.form.accountedOrders.ordersOnly': 'Ordini',
    'salesSummary.form.accountedOrders.contraEntriesOnly': 'Controscritture',
    'salesSummary.exportResultModal.title': "Generazione dell'Esportazione",

    // Shifts
    'shift.default': 'Predefinito',
    'shift.allDays': 'Tutti i giorni',
    'shift.period': 'Dal {start} al {end}',
    'shift.days.MON': 'Lunedì',
    'shift.days.TUE': 'Martedì',
    'shift.days.WED': 'Mercoledì',
    'shift.days.THU': 'Giovedì',
    'shift.days.FRI': 'Venerdì',
    'shift.days.SAT': 'Sabato',
    'shift.days.SUN': 'Domenica',
    'shift.amount.required': "L'importo è obbligatorio",
    'shift.amount.positive': "L'importo deve essere positivo",
    'shift.threshold.positive': 'La soglia deve essere positiva',
    'shift.ceiling.required': 'obbligatorio per una sovvenzione in percentuale',
    'shift.vat.required': "L'IVA è obbligatoria",
    'shift.vat.positive': "L'IVA deve essere positiva",

    // Brand's History
    'brandHistory.tableCard.title': 'Cronologia',
    'brandHistory.tableCard.subtitle': 'Cerca le azioni fatte sul marchio',
    'brandHistory.emptyMessage': 'Nessuna cronologia trovata',
    'brandHistory.searchPlaceholder': 'Cerca nella cronologia',

    'brandHistory.entityType': 'Tipo di entità',
    'brandHistory.entityType.GRANT': 'Sovvenzione',
    'brandHistory.entityType.ENTRANCE_FEE': 'Ammissione',
    'brandHistory.entityType.PRICING_RULE': 'Regime tariffario',
    'brandHistory.entityType.PRODUCT': 'Prodotto',
    'brandHistory.entityType.STEP': 'Passaggio',
    'brandHistory.entityType.CATEGORY': 'Categoria',
    'brandHistory.entityType.MENU': 'Menu',
    'brandHistory.entityType.MODULE': 'Modulo',
    'brandHistory.entityType.CUSTOMER': 'Cliente',
    'brandHistory.entityType.CUSTOMERS_IMPORT': 'Importazione clienti',
    'brandHistory.entityType.CUSTOMERS_UPDATE': 'Modifica clienti',
    'brandHistory.entityType.USER': 'Utente',
    'brandHistory.entityType.CHANNEL': 'Canale',
    'brandHistory.entityType.CONSUMPTION_MODE': 'Modalità di consumo',
    'brandHistory.entityType.ORDER': 'Ordine',
    'brandHistory.entityType.BRAND': 'Marchio',
    'brandHistory.entityType.RESTAURANT': 'Ristorante',

    'brandHistory.entityName': "Nome dell'entità",
    'brandHistory.restaurant': 'Ristorante',
    'brandHistory.user': 'Utente',
    'brandHistory.action': 'Azione',
    'brandHistory.eventDate': 'Data',

    'brandHistory.action.create': 'Creazione',
    'brandHistory.action.open': 'Apertura',
    'brandHistory.action.activate': 'Attivazione',
    'brandHistory.action.duplicate': 'Duplicazione',
    'brandHistory.action.delete': 'Eliminazione',
    'brandHistory.action.close': 'Chiusura',
    'brandHistory.action.deactivate': 'Disattivazione',
    'brandHistory.action.cancel': 'Annullamento',
    'brandHistory.action.update': 'Modifica',
    'brandHistory.action.import': 'Importazione',
    'brandHistory.action.unknown': 'Sconosciuto',

    'brandHistory.modal.title': 'Report delle azioni eseguite',
    'brandHistory.modal.actions': 'Report delle azioni',
    'brandHistory.modal.logs': 'Report dei log',
    'brandHistory.modal.informations': 'Informazioni associate',
    'brandHistory.modal.entityName': "Nome dell'entità",
    'brandHistory.modal.user': 'Utente: ',
    'brandHistory.modal.date': 'Data della modifica: ',
    'brandHistory.modal.close': 'Chiudi',
    'brandHistory.modal.empty': 'Non troviamo nulla qui',

    // Cross-selling
    'crossSelling.name': 'Nome della pagina di cross-selling',
    'crossSelling.page.title': 'Cross-selling',
    'crossSelling.page.description': 'Crea e gestisci le tue pagine di cross-selling',
    'crossSelling.action.newCrossSelling': '+ Nuova pagina di cross-selling',
    'crossSelling.modal.duplicate.title': 'Duplica una pagina di cross-selling',
    'crossSelling.modal.create.title': 'Crea la tua pagina di cross-selling',
    'crossSelling.modal.delete.title': 'Elimina una pagina di cross-selling',
    'crossSelling.modal.delete.description': 'Sei sicuro di voler eliminare la pagina: "{crossSellingName}"?',
    'crossSelling.modal.error.name': 'Inserisci un nome nel campo dedicato',
    'crossSelling.modal.menu.name': 'Nome della pagina di cross-selling',
    'crossSelling.page.create.title': 'Crea una pagina di Cross-selling',
    'crossSelling.page.update.title': 'Modifica la pagina di Cross-selling "{crossSellingName}"',
    'crossSelling.page.create.description': 'Configurazione della pagina di Cross-Selling',
    'crossSelling.page.update.description': 'Configurazione della pagina di Cross-Selling',
    'crossSelling.products.image': 'Immagine',
    'crossSelling.products.name': 'Nome',
    'crossSelling.products.price': 'Prezzo',
    'crossSelling.products.vat': 'IVA',
    'crossSelling.products.tags': 'Tag',
    'crossSelling.products.sku': 'SKU',
    'crossSelling.products.menuName': 'Menu',
    'crossSelling.products.menuState': 'Stato del menu',
    'crossSelling.products.restaurantName': 'Ristorante',
    'crossSelling.products.add': 'Aggiungi prodotti',
    'crossSelling.products.menuState.enabled': 'Attivato',
    'crossSelling.products.menuState.disabled': 'Disattivato',

    // Table Layout
    'tableLayout.name': 'Nome del piano tavoli',
    'tableLayout.page.title': 'Piani tavoli',
    'tableLayout.page.description': 'Crea e gestisci i tuoi piani tavoli',
    'tableLayout.table.associatedPos': 'Casse associate',
    'tableLayout.action.newTableLayout': '+ Nuovo piano tavoli',
    'tableLayout.modal.create.title': 'Crea un piano tavoli',
    'tableLayout.modal.edit.title': 'Modifica il piano tavoli "{tableLayoutName}"',
    'tableLayout.modal.delete.title': 'Elimina un piano tavoli',
    'tableLayout.modal.delete.description': 'Sei sicuro di voler eliminare il piano tavoli: "{tableLayoutName}"?',
    'tableLayout.modal.publish.title': 'Pubblica un piano tavoli',
    'tableLayout.modal.publish.description': 'Sei sicuro di voler pubblicare il piano tavoli: "{tableLayoutName}"?',
    'tableLayout.modal.error.name': 'Inserisci un nome nel campo dedicato',

    // Room
    'room.name': 'Nome della sala',
    'room.page.title': 'Sale',
    'room.page.description': 'Crea e gestisci le tue sale',
    'room.action.newRoom': '+ Nuova sala',
    'room.action.publish': 'Pubblica il piano tavoli',
    'room.modal.create.title': 'Crea una sala',
    'room.modal.edit.title': 'Modifica la sala "{roomName}"',
    'room.modal.view.title': 'Sala "{roomName}"',
    'room.modal.single': 'Aggiungi un tavolo',
    'room.modal.single.placeholder': 'Tavolo principale',
    'room.modal.multiple': 'Aggiungi più tavoli',
    'room.modal.multiple.placeholder1': '1',
    'room.modal.multiple.placeholder2': '10',
    'room.modal.layout': 'Organizza i tavoli',
    'room.modal.delete.title': 'Elimina una sala',
    'room.modal.delete.description': 'Sei sicuro di voler eliminare la sala: "{roomName}"?',
    'room.modal.error.name': 'Inserisci un nome nel campo dedicato',
    'room.modal.error.new_table_name': 'Inserisci un nome o numero di tavolo',
    'room.modal.error.fill_start_and_end': 'Inserisci un valore di inizio e uno di fine (superiore a quello di inizio)',
    'room.modal.error.max_count_table': 'Non puoi avere più di {maxCount} tavoli per sala.',

    // POS config
    'pos.configuration': 'Configurazione',
    'pos.devices': 'Casse',
    'pos.access': 'Ruoli e permessi',
    'pos.access.users': 'Utenti',
    'pos.access.roles': 'Ruoli',
    'pos.access.groups': 'Gruppi',
    'pos.users.page.title': 'Operatori di cassa',
    'pos.roles.page.title': 'Ruoli e permessi di cassa',
    'pos.groups.page.title': 'Gruppi di accesso cassa',
    'pos.users.page.description':
        'Gli operatori di cassa permettono di definire gli utenti che possono interagire con la cassa.',
    'pos.roles.page.description':
        'I ruoli di cassa permettono di definire gruppi di permessi per gli utenti della cassa.',
    'pos.groups.page.description':
        'I gruppi di accesso gestiscono gli utenti e la loro associazione alle casse del ristorante',
    'pos.users.action.newUser': 'Crea un nuovo operatore',
    'posUser.name.form.label': 'Nome operatore',
    'posUser.name.form.placeholder': 'Nome operatore cassa',
    'posUser.pinCode.form.label': 'Codice PIN operatore',
    'posUser.pinCode.form.placeholder': 'Codice PIN operatore cassa',
    'posUser.role.form.label': 'Ruolo operatore',
    'posGroup.name.form.label': 'Nome del gruppo',
    'posGroup.name.form.placeholder': 'Inserisci il nome del gruppo di accesso',
    'posGroup.users.form.label': 'Operatori',
    'posGroup.users.form.placeholder': 'Seleziona gli operatori associati',
    'posGroup.devices.form.label': 'Casse',
    'posGroup.devices.form.placeholder': 'Seleziona le casse associate',
    'posUser.create.form.title': 'Crea un nuovo operatore cassa',
    'posGroup.create.form.title': 'Crea un nuovo gruppo di accesso',
    'posGroup.edit.form.title': 'Modifica il gruppo di accesso',
    'posUser.edit.form.title': "Modifica l'operatore cassa: ",
    'posUser.form.description': 'Indica le informazioni del tuo operatore di cassa.',
    'posGroup.form.description': 'Indica le informazioni del tuo gruppo di accesso cassa.',
    'posUser.form.creation': 'Creazione di un operatore cassa',
    'posUser.form.edit': 'Modifica di un operatore cassa',
    'posUser.form.update': 'Modifica di un operatore cassa',

    'posRole.form.title': 'Ruolo di cassa',
    'posRole.form.description': 'Puoi aggiornare i permessi del tuo ruolo di cassa da questa pagina',
    'posRole.form.creation': 'Creazione di un ruolo di cassa',
    'posRole.form.update': 'Modifica di un ruolo di cassa',
    'posGroup.form.creation': 'Creazione di un gruppo di accesso',
    'posGroup.form.update': 'Modifica di un gruppo di accesso',
    'posRole.form.rolePermissions': 'Permessi per il ruolo',
    'posRole.form.name.title': 'Nome del ruolo',
    'posRole.form.name.placeholder': 'Ruolo',
    'pos.groups.action.create': 'Crea un nuovo gruppo',
    'permissions.permissions': 'Permessi',
    'assiciated.devices': 'Casse associate',
    'assiciated.operators': 'Operatori associati',

    // Default POS roles
    'posRole.Operator': 'Operatore',
    'posRole.Manager': 'Manager',
    'posRole.Owner': 'Proprietario',
    'posRole.Auditor': 'Revisore',
    'posRole.Treasurer': 'Tesoriere',
    'posRole.Support': 'Supporto',
    'posRole.Trainer': 'Formatore',
    'posRole.InCharge': 'Responsabile',
    'posRole.OperatorSupervisor': 'Supervisore operatore',
    'posRole.AssistantOperator': 'Assistente operatore',
    'posRole.AssistantToTheRegionalManager': 'Assistente manager',
    'posRole.CustomOperator1': 'Operatore custom 1',
    'posRole.CustomOperator2': 'Operatore custom 2',
    'posRole.CustomOperator3': 'Operatore custom 3',

    'channels.page.title': 'Lista dei canali',
    'channels.page.description':
        "I canali di ordine ti permettono di proporre funzionalità come l'ordine online, l'ordine tramite totem in punto vendita, o la gestione della fedeltà.",
    'channels.installed': 'Applicazione installata',
    'channels.button.configure': 'Configura',
    'channels.button.disable': 'Disattiva',
    'channels.button.enable': 'Attiva',

    'channels.kiosk.name': 'Totem',
    'channels.kiosk.description': "Reinventa l'esperienza in punto vendita nel modo migliore.",

    'channels.web.name': 'Ordine online',
    'channels.web.description': 'Un nuovo punto vendita dal tuo stesso sito.',

    'channels.reception.name': 'Reception',
    'channels.reception.description': "Un'interfaccia dedicata per i tuoi ordini web e totem.",

    'channels.pos.name': 'POS',
    'channels.pos.description': 'Il tuo sistema di incasso semplice e integrato nel tuo ambiente.',

    'channels.kds.name': 'Kitchen display',
    'channels.kds.description': "Dinamizza ancora di più la tua cucina con un'organizzazione perfetta.",

    'channels.loyalty.name': 'Fedeltà',
    'channels.loyalty.description': 'Fidelizza, fai tornare i tuoi clienti in punto vendita.',

    'channels.ewallet_kiosk.name': 'Totem di ricarica E-Wallet',
    'channels.ewallet_kiosk.description': 'Il nuovo canale per ricaricare il tuo E-wallet molto rapidamente.',

    'channels.vending_machine.name': 'Distributore automatico',
    'channels.vending_machine.description':
        'Proponi un pagamento e-wallet sulle tue macchine da caffè e distributori di bevande.',

    'accessFlags.CAN_ACCESS_BRAND_HISTORY': 'Può accedere alla pagina cronologia del marchio',
    'accessFlags.CAN_ACCESS_CUSTOMERS_SECTION': 'Può accedere alla pagina Clienti',
    'accessFlags.CAN_ACCESS_GRANTS_AND_ENTRANCE_FEES_SECTION': 'Può accedere alla scheda Sovvenzioni e ammissioni',
    'accessFlags.CAN_ACCESS_IO_PAY': 'Può accedere al modulo Pagamento',
    'accessFlags.CAN_ARCHIVE_CUSTOMERS': 'Può archiviare i clienti',
    'accessFlags.CAN_CREATE_ORDERS_WITH_NEGATIVE_AMOUNT': 'Può creare ordini con importo negativo',
    'accessFlags.CAN_CREATE_ORDERS_WITH_NEGATIVE_BALANCE':
        'Può creare ordini che faranno passare il saldo del cliente in negativo',
    'accessFlags.CAN_CREDIT_POST_PAYMENT_CUSTOMERS_EWALLET':
        "Può accreditare l'e-wallet di un cliente in post-pagamento",
    'accessFlags.CAN_EDIT_AREAS': 'Può modificare le zone di consegna',
    'accessFlags.CAN_EDIT_AUTO_BILLING_REFERENTIAL': 'Fatturazione automatica: può modificare il riferimento',
    'accessFlags.CAN_EDIT_CUSTOMERS_CREDENTIALS': 'Può modificare le credenziali dei clienti',
    'accessFlags.CAN_EXPORT_CUSTOMERS_CSV': 'Può esportare i dati clienti e accreditare/addebitare gli E-wallet',
    'accessFlags.CAN_FORCE_DEFAULT_CREDENTIALS_CHANGE':
        'Può forzare i nuovi clienti a modificare le loro credenziali predefinite',
    'accessFlags.CAN_MANAGE_BO_USERS': 'Può gestire gli utenti del backoffice',
    'accessFlags.CAN_MANAGE_BRAND_EWALLET_OVERDRAFT': 'Può gestire lo scoperto autorizzato a livello di marchio',
    'accessFlags.CAN_MANAGE_CUSTOMER_EWALLET_OVERDRAFT': 'Può gestire lo scoperto autorizzato a livello di cliente',
    'accessFlags.CAN_ONLY_EDIT_PRICE_AND_PRODUCT_NAME':
        'Può modificare solo il prezzo e il nome dei prodotti e passaggi associati',
    'accessFlags.CAN_SYNC_SALES': 'Può sincronizzare le vendite',
    'accessFlags.CAN_EDIT_TABLE_LAYOUT': 'Può modificare i piani tavoli',
    'accessFlags.CAN_CREATE_ORDER_WITH_CUSTOM_PRICE': 'Può creare ordini con un prezzo personalizzato',
    'accessFlags.CAN_CREATE_ORDER_WITH_CUSTOM_PRICE_FOR_ALL_PRODUCTS':
        'Può creare ordini con un prezzo personalizzato per tutti i prodotti',
    'accessFlags.MENU_CATEGORY_CREATE_OR_DELETE': 'Può creare o eliminare categorie',
    'accessFlags.MENU_CATEGORY_EDIT': 'Può modificare categorie',
    'accessFlags.MENU_CREATE_OR_DELETE': 'Può creare o eliminare menu',
    'accessFlags.MENU_EDIT': 'Può modificare menu',
    'accessFlags.MENU_PRODUCT_CREATE_OR_DELETE': 'Può creare o eliminare prodotti',
    'accessFlags.MENU_PRODUCT_EDIT': 'Può modificare prodotti',
    'accessFlags.MENU_PRODUCT_EDIT_PRICE_ONLY': 'Limita la modifica al prezzo del prodotto',
    'accessFlags.MENU_PRODUCT_EDIT_PRICE_BLOCKED_ONLY': 'Blocca solo la modifica del prezzo di un prodotto',
    'accessFlags.MENU_STEP_CREATE_OR_DELETE': 'Può creare o eliminare passaggi',
    'accessFlags.MENU_STEP_EDIT': 'Può modificare passaggi',
    'accessFlags.MENU_TAG_CREATE_OR_DELETE': 'Può creare o eliminare tag',
    'accessFlags.MENU_TAG_EDIT': 'Può modificare tag',
    'accessFlags.CAN_CHANGE_OWN_PASSWORD': 'Può modificare la propria password',
    'accessFlags.CAN_CANCEL_ORDER_WITH_CONTRA_ENTRY': 'Può annullare un ordine (contro-scrittura)',
    'accessFlags.CAN_CREATE_SKU': 'Può creare degli SKU',

    'accessFlagsGroups.customers': 'Gestione Clienti',
    'accessFlagsGroups.financial': 'Gestione Finanziaria / E-Wallet',
    'accessFlagsGroups.orders': 'Gestione Ordini',
    'accessFlagsGroups.catalog': 'Gestione Catalogo',
    'accessFlagsGroups.subsidies': 'Sovvenzioni & Ammissioni',
    'accessFlagsGroups.configuration': 'Configurazione Ristorante',
    'accessFlagsGroups.administration': 'Amministrazione & Account',
    'accessFlagsGroups.others': 'Altri Permessi',

    'accessFlagsSubsections.categories': 'Categorie',
    'accessFlagsSubsections.menus': 'Menu',
    'accessFlagsSubsections.products': 'Prodotti',
    'accessFlagsSubsections.steps': 'Passaggi',
    'accessFlagsSubsections.tags': 'Tag',

    'accessFlagsControl.expandAll': 'Espandi tutto',
    'accessFlagsControl.collapseAll': 'Comprimi tutto',
    'accessFlagsControl.permission': 'permesso',
    'accessFlagsControl.permissions': 'permessi',

    'userRestaurants.noRestaurants': 'Nessun ristorante disponibile',

    'brandUsers.email': 'Email',
    'brandUsers.lastConnection': 'Ultima connessione',
    'brandUsers.login': 'Connessione',
    'brandUsers.loginAs': 'Connettiti come',
    'brandUsers.loginAsBrandGroup': 'Account multi-marchio (non connettibile)',
    'brandUsers.newUser': '+ Nuovo utente',
    'brandRestaurants.newRestaurant': '+ Nuovo ristorante',
    'brandRestaurants.create.restaurantInfo': 'Informazioni sul ristorante',
    'brandRestaurants.create.restaurantName': 'Nome del ristorante',
    'brandRestaurants.create.phone': 'Numero di telefono',
    'brandRestaurants.create.address': 'Indirizzo',
    'brandRestaurants.create.locale': 'Lingua',
    'brandRestaurants.create.currency': 'Valuta',
    'brandRestaurants.create.operationZone': 'Zona operativa',
    'brandRestaurants.create.operationZone.skip': 'Salta - configura più tardi',
    'brandRestaurants.create.operationZoneConfigure': 'Configurazione zona operativa',
    'brandRestaurants.create.operationZone.selectProvider': 'Seleziona la modalità di conformità',
    'brandRestaurants.create.operationZone.currencyMismatch':
        "Questa zona utilizza una valuta diversa da quella dell'insegna. È necessaria una nuova insegna per operare in questa valuta.",
    'brandRestaurants.create.manager': 'Gestore',
    'brandRestaurants.create.selectExistingUser': 'Seleziona utente esistente',
    'brandRestaurants.create.createNewUser': 'Crea nuovo utente',
    'brandRestaurants.create.skipManager': 'Salta questo passaggio',
    'brandRestaurants.create.letUserChoosePassword': "Lascia che l'utente scelga la password",
    'brandRestaurants.create.done.title': 'Fatto!',
    'brandRestaurants.create.done.message': 'Sei pronto a configurare {name}',
    'brandRestaurants.create.done.configure': 'Configuralo',
    'user.create.title': 'Crea un nuovo utente',
    'user.create.firstName': 'Nome',
    'user.create.lastName': 'Cognome',
    'user.create.phone': 'Numero di telefono',
    'user.create.email': 'Email',
    'user.create.password': 'Password',
    'user.create.confirmPassword': 'Conferma la password',
    'user.create.letUserChoosePassword': "Lascia che l'utente scelga la sua password",
    'user.create.error.phone.length': 'Il numero di telefono deve contenere 10 cifre.',
    'user.create.error.phone.valid': 'Questo numero non è valido',
    'user.create.error.password.min': 'Password non valida (minimo 12 caratteri)',
    'user.create.error.passwordConfirm.sameAsPassword': 'Le due password devono essere identiche',

    'brands.restaurantscount': 'Numero di ristoranti',
    'brands.favorite': 'Preferito',
    'brands.create': '+ Nuovo marchio',
    'brands.form.title': 'Crea un nuovo marchio',
    'brands.form.brandInfo': 'Informazioni del marchio',
    'brands.form.brandInfo.title': 'Nome del marchio',
    'brands.form.selectUser': 'Seleziona un responsabile marchio',
    'brands.form.selectUser.title': 'Crea un responsabile marchio',
    'brands.form.canals': 'Seleziona i canali di ordine del marchio',
    'brands.form.canals.title': 'Gestisci i canali',
    'brands.form.brandName': 'Nome',
    'brands.form.region': 'Regione e lingua',
    'brands.form.currency': 'Valuta',
    'brands.form.firstName': 'Nome *',
    'brands.form.lastName': 'Cognome *',
    'brands.form.phoneNumber': 'Numero di telefono *',
    'brands.form.email': 'Email *',
    'brands.form.password': 'Password *',
    'brands.form.confirmPassword': 'Conferma la password *',
    'brands.form.error.phone.valid': 'Questo numero non è valido',
    'brands.form.error.password.min': 'Password non valida (minimo 12 caratteri)',
    'brands.form.error.passwordConfirm.sameAsPassword': 'Le due password devono essere identiche',

    // Pos permissions
    'posPermissions.accessPermissions': 'Permessi di accesso',
    'posPermissions.otherPermissions': 'Altri permessi',
    'posPermissions.ACCESS_CATALOG_SCREEN': 'Catalogo',
    'posPermissions.ACCESS_CUSTOMERS_SCREEN': 'Clienti',
    'posPermissions.ACCESS_CUSTOMISATION_SCREEN': 'Opzioni',
    'posPermissions.ACCESS_E_WALLET_SCREEN': 'E-Wallet',
    'posPermissions.ACCESS_MANAGE_CASH_FLOAT_SCREEN': 'Fondo cassa',
    'posPermissions.ACCESS_MANAGE_DISCOUNT_SCREEN': 'Promozioni',
    'posPermissions.ACCESS_MANAGE_RUNNER_SCREEN': 'Fattorini',
    'posPermissions.ACCESS_MANAGE_TABLES_SCREEN': 'Piano tavoli',
    'posPermissions.ACCESS_NEW_ORDER_SCREEN': 'Nuovo ordine',
    'posPermissions.ACCESS_ORDERS_FOLLOW_UP_SCREEN': 'Seguito ordini',
    'posPermissions.ACCESS_PARAMETER_SCREEN': 'Parametri',
    'posPermissions.ACCESS_PRINTER_SCREEN': 'Stampanti',
    'posPermissions.ACCESS_RAZ_SCREEN': 'Report',
    'posPermissions.ACCESS_TICKET_SCREEN': 'Ticket',
    'posPermissions.ACCESS_USER_SCREEN': 'Utenti',
    'posPermissions.APPLY_DISCOUNT': 'Applica una promozione',
    'posPermissions.CANCEL_ORDER': "Annulla l'ordine",
    'posPermissions.CANCEL_VALIDATED_ORDER_ITEM': 'Annulla un prodotto convalidato di un ordine',
    'posPermissions.CREATE_GROUP': 'Crea un gruppo',
    'posPermissions.CREATE_PRODUCT': 'Crea un prodotto',
    'posPermissions.DELETE_DEFAULT_PRINTER': 'Elimina la stampante predefinita',
    'posPermissions.DISCONNECT': 'Disconnetti una cassa',
    'posPermissions.ENTER_DISCOUNT_WHEN_PLACING_AN_ORDER': 'Inserisci uno sconto durante un ordine',
    'posPermissions.EXPORT_ARCHIVE': 'Esporta gli archivi',
    'posPermissions.FORCE_ORDER_SHIFT': 'Forza il servizio di un ordine',
    'posPermissions.GENERATE_ARCHIVE': 'Genera gli archivi fiscali',
    'posPermissions.JUSTIFY_ORDERS': 'Giustifica gli ordini',
    'posPermissions.LINK_A_BADGE': 'Associa un badge',
    'posPermissions.MODIFY_FEATURE_OPTIONS': 'Modifica le opzioni',
    'posPermissions.MODIFY_FUNCTION_FROM_GRID': 'Modifica una funzione con una pressione lunga',
    'posPermissions.MODIFY_GROUP_FROM_GRID': 'Modifica un gruppo con una pressione lunga',
    'posPermissions.MODIFY_ORDER_ITEM_PRICE': 'Modifica il prezzo di un prodotto nel carrello',
    'posPermissions.MODIFY_PASSWORD': 'Modifica la password',
    'posPermissions.MODIFY_PRODUCT_FROM_GRID': 'Mostra la scheda prodotto',
    'posPermissions.MODIFY_SKU_BILLING_CODE_PURCHASE_PRICE':
        'Modifica codice prodotto, fatturazione e prezzo di fatturazione',
    'posPermissions.MODIFY_PRODUCT_PRICE': 'Modifica il prezzo nella scheda prodotto',
    'posPermissions.MODIFY_PRODUCT_OTHER_INFO': 'Modifica le altre proprietà nella scheda prodotto',
    'posPermissions.MODIFY_TICKET': 'Modifica il ticket',
    'posPermissions.MODIFY_TICKET_GROUPS': 'Modifica i gruppi dei ticket',
    'posPermissions.MODIFY_TICKET_ORDER_PLACES': 'Modifica il tipo di ordine dei ticket',
    'posPermissions.MODIFY_TICKET_ORDER_STATUS': "Modifica lo stato dell'ordine dei ticket",
    'posPermissions.MODIFY_TICKET_QUANTITY': 'Modifica le quantità dei ticket',
    'posPermissions.MODIFY_VALIDATED_ORDER_ITEM': 'Modifica un prodotto convalidato di un ordine',
    'posPermissions.OFFER_PRODUCT_FOR_FREE': 'Offri un prodotto',
    'posPermissions.OPEN_CASH_DRAWER': 'Apri il cassetto cassa',
    'posPermissions.PRINT_VALID_TICKET': 'Stampa i ticket convalidati',
    'posPermissions.REFUND_CLIENT': 'Rimborsa un cliente',
    'posPermissions.REMOVE_PRODUCT_FROM_CATALOG': 'Rimuovi un prodotto dal catalogo',
    'posPermissions.REOPEN_ORDER': 'Riapri un ordine',
    'posPermissions.SEARCH_CLIENT': 'Cerca un cliente manualmente',
    'posPermissions.SHOW_APPLY_PRICING_RULE_BUTTON': 'Mostra il pulsante Pasto Forzato sulla schermata nuovo passaggio',
    'posPermissions.SYNC_ARCHIVE': 'Sincronizza gli archivi',
    'posPermissions.VIEW_AUDIT_TRAIL': 'Visualizza la traccia di audit',
    'posPermissions.VIEW_FEATURE_OPTIONS': 'Visualizza le opzioni',
    'posPermissions.VIEW_ORDER_AUDIT': 'Visualizza gli audit degli ordini',
    'posPermissions.VIEW_REVENUE_IN_FOLLOW_UP': 'Mostra il fatturato nei report',
    'posPermissions.VIEW_TICKET_AUDIT': 'Visualizza gli audit dei ticket',
    'posPermissions.VIEW_TICKET_TEMPLATE': 'Visualizza i template dei ticket',
    'posPermissions.MODIFY_TICKET_PRINTER': 'Modifica la stampante dei ticket',
    'posPermissions.VALIDATE_EPT_PAYMENT_OPERATIONS': 'Convalida le operazioni POS',

    'multiBrand.user': 'Utente',

    // badge reader
    'badgeReader.empty': 'Nessun lettore di badge configurato',
    'badgeReader.notConfigured': 'Sembra che tu non abbia un lettore di badge configurato. Vai alla nostra',
    'badgeReader.help': 'sezione di aiuto.',
    'badgeReader.create': 'Crea un lettore di badge',
    'badgeReader.table.title': 'Lettori di badge',
    'badgeReader.table.name': 'Nome del lettore',
    'badgeReader.table.deviceUuid': 'UUID del lettore',
    'badgeReader.table.driver': 'Tecnologia del lettore',
    'badgeReader.table.driverConfigs': 'Variabili della tecnologia',
    'badgeReader.table.readingConditions': 'Regole di lettura',
    'badgeReader.table.keyboardLayout': 'Layout tastiera',
    'badgeReader.driverConfigs':
        'Baudrate = <b>{baudRate}</b> {br}Bits = <b>{dataBits}</b> {br}Parity = <b>{parity}</b> {br}Stop Bits = <b>{stopBits}</b>',
    'badgeReader.readingCondition.number': 'Condizione #{index}:',
    'badgeReader.readingCondition.stringLength': '• Se lunghezza = {stringLength} carattere/i',
    'badgeReader.readingCondition.convertBefore.none': '• Non si fa conversione',
    'badgeReader.readingCondition.convertBefore.hex-dec': '• Si converte in decimali = {stringLength}',
    'badgeReader.readingCondition.convertBefore.hex-ascii': '• Si converte in ASCII = {stringLength}',
    'badgeReader.readingCondition.convertBefore.dec-hex': '• Si converte in esadecimale = {stringLength}',
    'badgeReader.readingCondition.convertBefore.remove-zero': '• Si eliminano gli zeri',
    'badgeReader.readingCondition.convertBefore.hex-inverter': '• Si invertono i caratteri',
    'badgeReader.readingCondition.convertBefore.prefix':
        '• Si prefissa con carattere {prefix} fino a {substrLength} caratteri',
    'badgeReader.readingCondition.substrPositionStart': '• Si legge a partire da {substrPositionStart} carattere/i',
    'badgeReader.readingCondition.substrLength': '• Si leggono {substrLength} carattere/i',
    'badgeReader.readingCondition.convertAfter.none': '• Non si convertono questi {substrLength} carattere/i',
    'badgeReader.readingCondition.convertAfter.hex-dec': '• Si convertono questi caratteri decimali in {convertAfter}',
    'badgeReader.readingCondition.convertAfter.dec-hex':
        '• Si convertono questi caratteri esadecimali in {convertAfter}',
    'badgeReader.readingCondition.convertAfter.hex-ascii': '• Si convertono questi caratteri ASCII in {convertAfter}',
    'badgeReader.readingCondition.convertAfter.remove-zero': '• Si eliminano gli zeri',
    'badgeReader.readingCondition.convertAfter.hex-inverter': '• Si invertono questi {substrLength} caratteri',
    'badgeReader.delete.confirmation': 'Sei sicuro di voler eliminare?',
    'badgeReader.delete.warning': 'Attenzione',
    'badgeReader.cancel.confirmation': 'Sei sicuro di voler annullare la configurazione?',
    'badgeReader.cancel.warning': 'Attenzione',
    // badge reader drivers
    'badgeReader.driver.keyboard': 'Uscita tastiera',
    'badgeReader.driver.serial': 'Protocollo seriale (RS232)',
    'badgeReader.driver.toqla': 'Toqla',
    // badge reader keyboard layouts
    'badgeReader.keyboardLayout.QWERTY': 'QWERTY',
    'badgeReader.keyboardLayout.AZERTY': 'AZERTY',
    // badge reader drivers
    'badgeReader.convertion.none': 'nessuna conversione',
    'badgeReader.convertion.hex-dec': 'esadecimale verso decimali',
    'badgeReader.convertion.hex-ascii': 'esadecimale verso ASCII',
    'badgeReader.convertion.dec-hex': 'decimali verso esadecimale',
    // badge reader steps
    'badgeReader.step.information': 'Creazione lettore',
    'badgeReader.step.driverConfigs': 'Variabili di tecnologia',
    'badgeReader.step.readingCondition': 'Regole di lettura',
    // badge reader Form
    'badgeReader.form.name': 'Nome del lettore',
    'badgeReader.form.deviceId': 'Identificativo USB del lettore',
    'badgeReader.form.deviceUuid': 'UUID del lettore',
    'badgeReader.form.driver': 'Tecnologia del lettore',
    'badgeReader.form.driverConfigBaudRate': 'Baudrate',
    'badgeReader.form.driverConfigDataBits': 'Bits',
    'badgeReader.form.driverConfigParity': 'Parity',
    'badgeReader.form.driverConfigStopBits': 'Stop Bits',
    'badgeReader.form.keyboardLayout': 'Disposizione della tastiera',
    'badgeReader.form.readingCondition.order': 'Condizione n°',
    'badgeReader.form.readingCondition.stringLength': 'Lunghezza',
    'badgeReader.form.readingCondition.convertBefore': 'Conversione prima?',
    'badgeReader.form.readingCondition.substrPositionStart': 'Partenza / Prefisso',
    'badgeReader.form.readingCondition.substrLength': 'Lunghezza',
    'badgeReader.form.readingCondition.convertAfter': 'Conversione dopo?',
    'badgeReader.step.readingCondition.add': 'Aggiungi +',
    // badge reader Form drivers
    'badgeReader.form.convertion.none': 'Disattivato',
    'badgeReader.form.convertion.hex-dec': 'Hex > Dec',
    'badgeReader.form.convertion.dec-hex': 'Dec > Hex',
    'badgeReader.form.convertion.remove-zero': 'Elimina gli zeri',
    'badgeReader.form.convertion.qwerty-azerty': 'Qwerty > Azerty',
    'badgeReader.form.convertion.hex-inverter': 'Esadecimale invertito bit a bit',
    'badgeReader.form.convertion.prefix': 'Prefisso',
    'badgeReader.form.convertion.hex-ascii': 'Hex > ASCII',

    // POS device
    'posDevice.catalogHistory.title': 'Cronologia dei cataloghi',
    'posDevice.catalogHistory.table.hash': 'Hash',
    'posDevice.catalogHistory.table.date': 'Data di creazione',
    'posDevice.catalogHistory.table.actions': 'Azioni',
    'posDevice.catalogHistory.button.download': 'Scarica',

    // Update password
    'passwordUpdate.title': 'Aggiornamento della password',
    'passwordUpdate.currentPassword': 'Vecchia password',
    'passwordUpdate.newPassword': 'Nuova password',
    'passwordUpdate.confirmPassword': 'Conferma la nuova password',
    'passwordUpdate.update': 'Salva',
    'passwordUpdate.passwordMismatch': 'La nuova password e la conferma non corrispondono.',
    'passwordUpdate.passwordMinLength': 'La password deve contenere almeno 12 caratteri.',
    'passwordUpdate.success': 'Password aggiornata con successo',

    // Notification
    'notification.guestHierarchy.title': 'Nuovo',
    'notification.guestHierarchy.content': 'La configurazione della gerarchia degli account si evolve.',
    'notification.guestHierarchy.link': 'Clicca per saperne di più',

    // Guest hierarchy Training
    'guestHierarchyTraining.page1.title': 'Benvenuto nella gestione dei percorsi clienti',
    'guestHierarchyTraining.page1.content':
        "La gestione dei percorsi clienti permette una configurazione rigorosa degli account cliente nel Back-Office (BO). Si basa su una gerarchia in <b>Gruppo → Sezione → Sottosezione</b> e l'assegnazione di <b>regimi tariffari</b> a questi elementi. Questa struttura garantisce una gestione ottimizzata e coerente.",
    'guestHierarchyTraining.page2.title': 'Accedi alla Gerarchia',
    'guestHierarchyTraining.page2.content':
        'Apri la nuova scheda <b>Gerarchia</b>. Questo spazio permette di <b>creare, modificare</b> gruppi, sezioni e sottosezioni.',
    'guestHierarchyTraining.page3.title': 'Crea o modifica un Gruppo',
    'guestHierarchyTraining.page3.content':
        '• Accedi a <b>Gerarchia > Gruppi.</b> {br}• Clicca su <b>"Crea un gruppo"</b> o modifica uno esistente. {br}• Un gruppo ha un <b>nome univoco</b> (1) {br}• Definisci i <b>regimi tariffari autorizzati</b> per i clienti collegati a questo gruppo (2)',
    'guestHierarchyTraining.page4.title': 'Crea o modifica una Sezione',
    'guestHierarchyTraining.page4.content':
        '• Accedi a <b>Gerarchia > Sezioni.</b> {br}• Clicca su <b>"Crea una sezione"</b> o modifica una esistente. {br}• Assegna una sezione a un <b>gruppo esistente</b>. (1) {br}• È richiesto un nome univoco. (2) {br} • Definisci i <b>regimi tariffari autorizzati</b> per i clienti collegati a questa sezione (3)',
    'guestHierarchyTraining.page5.title': 'Crea o modifica una Sottosezione',
    'guestHierarchyTraining.page5.content':
        '• Accedi a <b>Gerarchia > Sottosezioni.</b> {br}• Clicca su <b>"Crea una sottosezione"</b> o modifica una esistente. {br}• Assegna una sottosezione a una <b>sezione esistente</b>. (1 e 2) {br}• È richiesto un nome univoco. (3) {br} • Definisci i <b>regimi tariffari autorizzati</b> per i clienti collegati a questa sottosezione (4)',

    // Guest hierarchy info
    'guestHierarchyInfo.title': 'Creazione clienti',
    'guestHierarchyInfo.content':
        'Durante la creazione di un cliente, i regimi tariffari proposti sono automaticamente filtrati in base al gruppo, alla sezione o alla sottosezione selezionata.',

    // Loyalty
    'loyalty.features.title': 'Funzionalità attivate',
    'loyalty.features.MultiRewardSelection': 'Selezione multipla di premi',
    'loyalty.features.Promocode': 'Codici promozionali',
    'loyalty.features.Deals': 'Offerte',
    'loyalty.features.PointPayment': 'Pagamento con punti',

    // Splio
    'splio.title': 'Integrazione - Fedeltà Splio',
    'splio.integrationEnabled': 'Integrazione attivata dal {date}',
    'splio.description':
        'Inserisci la chiave API nel campo seguente per associare il tuo programma Splio con il tuo ristorante e i tuoi prodotti Innovorder.\nQuesta chiave API è da recuperare dalla tua interfaccia Splio.',
    'splio.apiKey.placeholder': 'Inserisci la tua chiave API Splio',
    'splio.apiKey': 'Chiave API Splio',
    'splio.programId': 'Programma fedeltà',
    'splio.allowCustomerRewardUsage': "Autorizza l'utilizzo dei premi da parte dei clienti",
    'splio.formLink': 'Link al modulo di iscrizione',
    'splio.optIn': 'OptIn associato alla newsletter di marketing',
    'splio.memberIdentifier': 'Identificatore per la creazione account',
    'splio.useCasualTone': 'Attiva il dare del tu',
    'splio.authenticationMethods': 'Metodi di autenticazione fedeltà autorizzati',
    'splio.registerMethods': 'Metodi di iscrizione fedeltà autorizzati',
    'splio.methods.email': 'E-mail',
    'splio.methods.phone': 'Telefono',
    'splio.methods.externalId': 'Identificatore fedeltà',
    'splio.update.success': 'Integrazione Splio aggiornata con successo',
    'splio.subscriptionToMarketingNewsletter': 'Iscrizione alla newsletter marketing',
    'splio.subscriptionToLoyaltyNewsletter': 'Iscrizione alla newsletter fedeltà',
    'splio.deleteModal.title': "Eliminazione dell'integrazione Splio",
    'splio.deleteModal.text': "Sei sicuro di voler eliminare l'integrazione Splio?",
    'splio.error.formLinkInvalid': 'Link del modulo non valido',
    'splio.error.changeProvider': "Un'integrazione fedeltà è già configurata per questo ristorante, eliminala prima",

    // Punti di ritiro
    'pickupPoint.page.title': 'Punti di ritiro',
    'pickupPoint.page.description': 'Crea e gestisci i tuoi punti di ritiro',
    'pickupPoint.action.create': 'Crea un punto di ritiro',
    'pickupPoint.modal.createPickupPoint': 'Creazione di un punto di ritiro',
    'pickupPoint.modal.editPickupPoint': 'Modifica di un punto di ritiro',
    'pickupPoint.modal.deletePickupPoint': 'Eliminazione di un punto di ritiro',
    'pickupPoint.modal.delete.title': 'Elimina un punto di ritiro',
    'pickupPoint.modal.delete.description': 'Sei sicuro di voler eliminare il punto di ritiro "{name}"?',
    'pickupPoint.modal.pickupPoint.name': 'Nome',
    'pickupPoint.modal.pickupPoint.address': 'Indirizzo',
    'pickupPoint.modal.pickupPoint.additionalAddressInfo': 'Indirizzo aggiuntivo',
    'pickupPoint.modal.pickupPoint.name.placeholder': 'Nome del punto di ritiro',
    'pickupPoint.modal.pickupPoint.address.placeholder': 'Indirizzo del punto di ritiro',
    'pickupPoint.modal.pickupPoint.additionalAddressInfo.placeholder': 'Indirizzo aggiuntivo del punto di ritiro',
    'pickupPoint.modal.warn.shift.title': 'Attenzione',
    'pickupPoint.modal.warn.shift.text':
        'Assicurati che nessun ordine sia in corso prima di eliminare questo punto di ritiro. Una volta eliminato, non sarà più visibile ai clienti e gli ordini in corso saranno persi.',
    'pickupPoint.modal.warn.shift.button': 'Capito',

    // Como
    'como.title': 'Integrazione - Fedeltà Como',
    'como.description':
        'Inserisci la chiave API nel campo seguente per associare il tuo programma Como con il tuo ristorante e i tuoi prodotti Innovorder.\nQuesta chiave API è da recuperare dalla tua interfaccia Como.',
    'como.apiKey': 'Chiave API Como',
    'como.integrationEnabled': 'Integrazione attivata dal {date}',
    'como.apiKey.placeholder': 'Inserisci la tua chiave API Como',
    'como.formLink': 'Link al modulo di iscrizione',
    'como.useCasualTone': 'Attiva il dare del tu',
    'como.authenticationMethods': 'Metodi di autenticazione fedeltà autorizzati',
    'como.registerMethods': 'Metodi di iscrizione fedeltà autorizzati',
    'como.methods.email': 'E-mail',
    'como.methods.phone': 'Telefono',
    'como.methods.externalId': 'Identificatore fedeltà',
    'como.error.formLinkInvalid': 'Link del modulo non valido',
    'como.update.success': 'Integrazione Como aggiornata con successo',
    'como.deleteModal.title': "Eliminazione dell'integrazione Como",
    'como.deleteModal.text': "Sei sicuro di voler eliminare l'integrazione Como?",
    'como.error.changeProvider': "Un'integrazione fedeltà è già configurata per questo ristorante, eliminala prima",
    'como.error.invalidApiKey': 'La chiave API inserita non è valida.',

    // Zerosix
    'zerosix.title': 'Integrazione - Fedeltà Zerosix',
    'zerosix.description':
        'Inserisci la chiave API nel campo seguente per associare il tuo programma Zerosix con il tuo ristorante e i tuoi prodotti Innovorder.\nQuesta chiave API è da recuperare dalla tua interfaccia Zerosix.',
    'zerosix.apiKey': 'Chiave API Zerosix',
    'zerosix.integrationEnabled': 'Integrazione attivata dal {date}',
    'zerosix.apiKey.placeholder': 'Inserisci la tua chiave API Zerosix',
    'zerosix.formLink': 'Link al modulo di iscrizione',
    'zerosix.useCasualTone': 'Attiva il dare del tu',
    'zerosix.authenticationMethods': 'Metodi di autenticazione fedeltà autorizzati',
    'zerosix.registerMethods': 'Metodi di iscrizione fedeltà autorizzati',
    'zerosix.methods.email': 'E-mail',
    'zerosix.methods.phone': 'Telefono',
    'zerosix.methods.externalId': 'Identificatore fedeltà',
    'zerosix.error.formLinkInvalid': 'Link del modulo non valido',
    'zerosix.update.success': 'Integrazione Zerosix aggiornata con successo',
    'zerosix.deleteModal.title': "Eliminazione dell'integrazione Zerosix",
    'zerosix.deleteModal.text': "Sei sicuro di voler eliminare l'integrazione Zerosix?",
    'zerosix.error.changeProvider': "Un'integrazione fedeltà è già configurata per questo ristorante, eliminala prima",
    'zerosix.error.invalidApiKey': 'La chiave API inserita non è valida.',

    // Restaurant Info
    'restaurantInfo.title': 'Informazioni del ristorante',
    'restaurantInfo.information.title': 'Informazioni sul ristorante',
    'restaurantInfo.name': 'Nome del ristorante',
    'restaurantInfo.address': 'Indirizzo del ristorante',
    'restaurantInfo.contactName': 'Nome del contatto',
    'restaurantInfo.contactEmail': 'Indirizzo email',
    'restaurantInfo.contactPhone': 'Numero di telefono',
    'restaurantInfo.externalId': 'Identificativo esterno',
    'restaurantInfo.tag': 'Tag del ristorante',
    'restaurantInfo.families': 'Famiglie del ristorante',
    'restaurantInfo.searchFamilies': 'Cerca una famiglia',
    'restaurantInfo.image': 'Immagine del ristorante',
    'restaurantInfo.legal.title': 'Informazioni legali',
    'restaurantInfo.legal.description':
        'Queste informazioni servono a generare le condizioni generali di vendita e le note legali dei canali di ordine',
    'restaurantInfo.legal.socialReason': 'Ragione sociale',
    'restaurantInfo.legal.organizationType': 'Tipo di organizzazione',
    'restaurantInfo.legal.capital': 'Capitale sociale',
    'restaurantInfo.legal.commerceRegistryCity': 'Città di registrazione al registro delle imprese',
    'restaurantInfo.legal.siren': 'Siren',
    'restaurantInfo.legal.taxNumber': 'Partita IVA',
    'restaurantInfo.legal.industryClassificationCode': 'Codice ATECO',
    'restaurantInfo.legal.publicationDirectorName': 'Nome del direttore della pubblicazione',
    'restaurantInfo.legal.publicationDirectorFunction': 'Funzione del direttore della pubblicazione',
    'restaurantInfo.legal.webmasterName': 'Nome del webmaster',
    'restaurantInfo.legal.webmasterEmail': 'Email del webmaster',
    'restaurantInfo.ewalletMinimum.title': 'Configurazione del saldo e-wallet minimo autorizzato sullo Scan Vassoio',
    'restaurantInfo.ewalletMinimum.inputTitle': 'IMPORTO MINIMO',
    'restaurantInfo.ewalletMinimum.caseZero': 'Per non impostare un minimo badge, indicare 0 nel campo e poi salvare.',
    'restaurantInfo.delete.title': 'Eliminazione ristorante',
    'restaurantInfo.delete.description': 'Questo ristorante esiste dal',
    'restaurantInfo.delete.button': 'Elimina questo ristorante',
    'restaurantInfo.save.error': 'Si è verificato un errore durante il salvataggio, riprova.',
    'restaurantInfo.delete.error': 'Si è verificato un errore, riprova la configurazione.',
    'restaurantInfo.delete.confirmTitle': 'Eliminazione ristorante',
    'restaurantInfo.delete.confirmDescription':
        'Sei sicuro di voler eliminare questo ristorante? Questa azione non può essere annullata.',
    'restaurantInfo.schedule.title': 'Orari di ritiro autorizzato',
    'restaurantInfo.schedule.manualEdit': 'Modifica manuale',
    'restaurantInfo.schedule.autoEdit': 'Modifica automatica',
    'restaurantInfo.schedule.autoEditDescription': 'Permette di creare fasce orarie rapidamente.',
    'restaurantInfo.schedule.description':
        'Puoi configurare diversi orari di ritiro autorizzato per il tuo ristorante. Queste fasce corrispondono agli orari di apertura del tuo ristorante, durante i quali i tuoi clienti potranno ritirare i loro ordini effettuati online.',
    'restaurantInfo.schedule.open': 'Aperto',
    'restaurantInfo.schedule.closed': 'Chiuso',
    'restaurantInfo.schedule.day.mon': 'Lun',
    'restaurantInfo.schedule.day.tue': 'Mar',
    'restaurantInfo.schedule.day.wed': 'Mer',
    'restaurantInfo.schedule.day.thu': 'Gio',
    'restaurantInfo.schedule.day.fri': 'Ven',
    'restaurantInfo.schedule.day.sat': 'Sab',
    'restaurantInfo.schedule.day.sun': 'Dom',
    'restaurantInfo.schedule.mass.startHour': 'Ora di inizio',
    'restaurantInfo.schedule.mass.endHour': 'Ora di fine',
    'restaurantInfo.schedule.mass.granularity': 'Intervallo',
    'restaurantInfo.schedule.mass.15min': '15 min',
    'restaurantInfo.schedule.mass.30min': '30 min',
    'restaurantInfo.schedule.mass.1h': '1 ora',
    'restaurantInfo.schedule.mass.overwrite': 'Sovrascrivi orari esistenti',
    'restaurantInfo.schedule.mass.apply': 'Applica',
    'restaurantInfo.schedule.mass.noDays': 'Seleziona almeno un giorno.',
    'restaurantInfo.schedule.mass.midnight': 'mezzanotte',

    // Order
    'order.customer.loyalty.anonymous': 'Anonimo {email}',

    // VAT Rates Matrix
    'route.vatRatesMatrix': 'Riferimento IVA',
    'vatRatesMatrix.title': 'Riferimento IVA Globale',
    'vatRatesMatrix.subtitle':
        'Fonte unica di verità per la fiscalità di tutti i prodotti Innovorder. Le modifiche vengono applicate automaticamente ai nuovi prodotti.',
    'vatRatesMatrix.vatGroup': 'Famiglia IVA',
    'vatRatesMatrix.codeLabel': 'Codice',
    'vatRatesMatrix.eatIn': 'Sul posto',
    'vatRatesMatrix.takeAway': 'Da asporto',
    'vatRatesMatrix.delivery': 'Consegna',
    'vatRatesMatrix.exportCsv': 'Esporta CSV',
    'vatRatesMatrix.exportError': "Si è verificato un errore durante l'esportazione del CSV. Riprova.",
    'vatRatesMatrix.filterByZone': 'Filtra per zona',
    'vatRatesMatrix.filterByGroup': 'Filtra per famiglia',
    'vatRatesMatrix.filterByMode': 'Filtra per modalità',
    'vatRatesMatrix.loading': 'Caricamento...',
    'vatRatesMatrix.error': 'Errore durante il caricamento dei dati.',
    'vatRatesMatrix.family.FOOD': 'Cibo',
    'vatRatesMatrix.family.NON_ALCOHOL': 'Senza alcol',
    'vatRatesMatrix.family.ALCOHOL': 'Alcol',
    'vatRatesMatrix.family.NORMAL': 'Normale',
    'vatRatesMatrix.family.NONE': 'Nessuno',

    // Promotional Banners
    'route.promotionalBanners': 'Banner promozionali',
    'promotionalBanner.page.title': 'Gestione dei banner',
    'promotionalBanner.page.subtitle': 'Crea e gestisci i tuoi banner promozionali da visualizzare sul tuo chiosco.',
    'promotionalBanner.page.emptyState':
        'Crea un banner promozionale per promuovere i tuoi prodotti e categorie sul tuo chiosco.',
    'promotionalBanner.page.emptyStateCta': 'Crea un banner',
    'promotionalBanner.page.noActiveMenu.title': 'Nessun menu chiosco attivo',
    'promotionalBanner.page.noActiveMenu.desc':
        '👉 Attiva un menu chiosco per accedere alla configurazione dei banner.',
    'promotionalBanner.page.noActiveMenu.cta': 'Gestisci i miei menu',
    'promotionalBanner.action.create': 'Crea un banner',
    'promotionalBanner.action.edit': 'Modifica',
    'promotionalBanner.action.view': 'Visualizza',
    'promotionalBanner.action.delete': 'Elimina',
    'promotionalBanner.action.activate': 'Attivare',
    'promotionalBanner.action.deactivate': 'Disattivare',
    'promotionalBanner.table.listTitle': 'Elenco dei banner promozionali',
    'promotionalBanner.modal.createTitle': 'Crea un banner',
    'promotionalBanner.modal.editTitle': 'Modifica banner',
    'promotionalBanner.modal.viewTitle': 'Visualizza banner',
    'promotionalBanner.modal.close': 'Chiudi',
    'promotionalBanner.modal.name': 'Nome',
    'promotionalBanner.modal.channel': 'Canale',
    'promotionalBanner.modal.image': 'Immagine',
    'promotionalBanner.modal.linkType': 'Tipo di link',
    'promotionalBanner.modal.linkTarget': 'Destinazione',
    'promotionalBanner.modal.activateAndSave': 'Attiva e salva',
    'promotionalBanner.modal.saveAsDraft': 'Salva come bozza',
    'promotionalBanner.modal.updateBanner': 'Aggiorna banner',
    'promotionalBanner.modal.deactivateBanner': 'Disattiva banner',
    'promotionalBanner.modal.imageSizeError': "L'immagine non deve superare i 5 MB",
    'promotionalBanner.modal.nameHelper': 'Questo nome è visibile solo nel back office.',
    'promotionalBanner.modal.nameLabel': 'Nome del banner',
    'promotionalBanner.modal.channelLabel': 'Canale di destinazione',
    'promotionalBanner.modal.channelKiosk': 'Chiosco',
    'promotionalBanner.modal.channelKioskDesc':
        "Visualizzazione del banner all'inizio del flusso di ordinazione sul chiosco.",
    'promotionalBanner.modal.channelWeb': 'Ordinazione online',
    'promotionalBanner.modal.channelWebDesc': 'Visualizzazione nel flusso di ordinazione online.',
    'promotionalBanner.modal.channelWebDisabled': 'Disponibile prossimamente.',
    'promotionalBanner.modal.imageLabel': 'Immagine del banner',
    'promotionalBanner.modal.imageSpecs': 'JPG, PNG, WebP · Max 5 MB · Formato 3:1',
    'promotionalBanner.modal.image.error.ratio': 'Il formato deve essere 3:1',
    'promotionalBanner.modal.imageFileDescription': '{name} · 1920×500px',
    'promotionalBanner.modal.linkTypeLabel': 'Tipo di link',
    'promotionalBanner.modal.linkNone': 'Nessun link',
    'promotionalBanner.modal.linkNoneDesc': 'Informativo e non cliccabile.',
    'promotionalBanner.modal.linkProduct': 'Prodotto',
    'promotionalBanner.modal.linkProductDesc': 'Reindirizza alla scheda prodotto quando viene cliccato.',
    'promotionalBanner.modal.linkCategory': 'Categoria',
    'promotionalBanner.modal.linkCategoryDesc': 'Reindirizza alla categoria quando viene cliccato.',
    'promotionalBanner.modal.activateBanner': 'Attiva banner',
    'promotionalBanner.modal.replace': 'Sostituire',
    'promotionalBanner.modal.searchCategory': 'Cerca una categoria...',
    'promotionalBanner.modal.searchProduct': 'Cerca un prodotto per nome o SKU...',
    'promotionalBanner.table.name': 'Nome',
    'promotionalBanner.table.status': 'Stato',
    'promotionalBanner.table.source': 'Fonte',
    'promotionalBanner.table.linkType': 'Tipo di link',
    'promotionalBanner.table.actions': 'Azioni',
    'promotionalBanner.table.sourceRestaurant': 'Ristorante',
    'promotionalBanner.table.sourceBrand': 'Marchio',
    'promotionalBanner.table.linkNone': 'Nessun link',
    'promotionalBanner.table.linkCategory': 'Categoria',
    'promotionalBanner.table.linkProduct': 'Prodotto',
    'promotionalBanner.table.statusActive': 'Attivo',
    'promotionalBanner.table.statusInactive': 'Inattivo',
    'promotionalBanner.table.linkDeleted': 'eliminato',
    'promotionalBanner.confirm.title': 'Un servizio è attualmente in corso',
    'promotionalBanner.confirm.message':
        'Questa azione ricaricherà tutti i chioschi e interromperà gli ordini in corso.',
    'promotionalBanner.confirm.confirm': 'Conferma',
    'promotionalBanner.confirm.cancel': 'Annulla',
    'promotionalBanner.delete.title': 'Elimina banner',
    'promotionalBanner.delete.description': 'Sei sicuro di voler eliminare questo banner?',

    // Bulk reload (Lot 3)
    'promotionalBanner.confirm.message.bulk':
        'Questa azione ricaricherà i chioschi di {count} ristoranti e interromperà gli ordini in corso.',

    // Duplicate (restaurant page, Lot 3)
    'promotionalBanner.action.duplicate': 'Duplica',
    'promotionalBanner.duplicate.fallback.title': 'Banner duplicato senza link',
    'promotionalBanner.duplicate.fallback.product':
        'La copia di "{sourceName}" è stata creata senza link: lo SKU non è stato trovato nel menu chiosco attivo.',
    'promotionalBanner.duplicate.fallback.category':
        'La copia di "{sourceName}" è stata creata senza link: la categoria non è stata trovata nel menu chiosco attivo.',
    'promotionalBanner.duplicate.fallback.dismiss': 'Ho capito',

    // Route label (Lot 3)
    'route.brand.promotionalBanners': 'Banner promozionali',

    // Brand promotional banners page (Lot 3)
    'brandPromotionalBanner.page.title': 'Banner promozionali del marchio',
    'brandPromotionalBanner.page.subtitle': 'Configura e propaga i banner nei ristoranti del marchio.',
    'brandPromotionalBanner.page.empty': 'Nessun banner per ora.',
    'brandPromotionalBanner.action.create': 'Crea un banner',

    // Brand table
    'brandPromotionalBanner.table.name': 'Nome',
    'brandPromotionalBanner.table.status': 'Stato',
    'brandPromotionalBanner.table.source': 'Fonte',
    'brandPromotionalBanner.table.link': 'SKU o categoria',
    'brandPromotionalBanner.table.activeRestaurants': '{count} ristoranti attivi',
    'brandPromotionalBanner.table.actions': 'Azioni',

    // Brand modal
    'brandPromotionalBanner.modal.createTitle': 'Crea un banner del marchio',
    'brandPromotionalBanner.modal.editTitle': 'Modifica banner',
    'brandPromotionalBanner.modal.name.label': 'Nome del banner',
    'brandPromotionalBanner.modal.image.label': 'Immagine',
    'brandPromotionalBanner.modal.image.hint': 'Formato 3:1, max 5 MB',
    'brandPromotionalBanner.modal.image.error.ratio': 'Il formato deve essere 3:1',
    'brandPromotionalBanner.modal.image.error.size': "L'immagine supera 5 MB",
    'brandPromotionalBanner.modal.channel.label': 'Canale',
    'brandPromotionalBanner.modal.channel.comingSoon': 'Disponibile prossimamente',
    'brandPromotionalBanner.modal.link.label': 'Tipo di link',
    'brandPromotionalBanner.modal.link.none': 'Nessun link',
    'brandPromotionalBanner.modal.link.product': 'Prodotto (SKU)',
    'brandPromotionalBanner.modal.link.category': 'Categoria',
    'brandPromotionalBanner.modal.link.product.hint':
        'Se lo SKU non viene trovato nel menu chiosco attivo di un ristorante, il banner verrà visualizzato senza link per quel ristorante.',
    'brandPromotionalBanner.modal.link.category.hint':
        'Se la categoria non viene trovata nel menu chiosco attivo di un ristorante, il banner verrà visualizzato senza link per quel ristorante.',
    'brandPromotionalBanner.modal.restaurants.label': 'Ristoranti target',
    'brandPromotionalBanner.modal.restaurants.empty': 'Seleziona almeno un ristorante',
    'brandPromotionalBanner.modal.button.cancel': 'Annulla',
    'brandPromotionalBanner.modal.button.saveDraft': 'Salva come bozza',
    'brandPromotionalBanner.modal.button.activate': 'Attiva banner',
    'brandPromotionalBanner.modal.button.deactivate': 'Disattiva banner',
    'brandPromotionalBanner.modal.button.update': 'Aggiorna banner',

    // Brand delete
    'brandPromotionalBanner.delete.title': 'Eliminare il banner?',
    'brandPromotionalBanner.delete.message': 'Il banner verrà rimosso da tutti i ristoranti associati.',

    // Carousel delay
    'brandPromotionalBanner.carousel.title': 'Ritardo di visualizzazione tra due banner',
    'brandPromotionalBanner.carousel.description': 'Imposta il tempo di visualizzazione tra due banner attivi.',
    'brandPromotionalBanner.carousel.helper': 'Tempo di attesa tra la visualizzazione di due banner attivi.',
    'brandPromotionalBanner.carousel.seconds': 'secondi',
    'brandPromotionalBanner.carousel.save': 'Salva',
    'brandPromotionalBanner.carousel.saved': 'Ritardo aggiornato',
    'brandPromotionalBanner.carousel.help':
        'Questo ritardo si applicherà a tutti i ristoranti del marchio al prossimo ricaricamento dei chioschi.',

    // Non-eligible restaurants
    'brandPromotionalBanner.modal.restaurants.ineligible.noChannel':
        'Questo ristorante non ha il canale chiosco abilitato.',
    'brandPromotionalBanner.modal.restaurants.ineligible.noMenu': 'Questo ristorante non ha un menu chiosco attivo.',

    // Shifts (servizi orari) — scheda brand
    'shift.tableCard.title': 'Servizi',
    'shift.tableCard.subtitle': 'Crea e gestisci i servizi (fasce orarie) dei tuoi ristoranti.',
    'shift.tableCard.action': '+ Aggiungi un servizio',
    'shift.emptyMessage': 'Nessun servizio configurato per questo ristorante.',
    'shift.selectRestaurantPrompt': 'Seleziona un ristorante per visualizzare i suoi servizi.',
    'shift.search': 'Cerca un servizio',
    'shift.adminOnly': 'Questa pagina è accessibile solo agli amministratori.',
    'shift.restaurantSelector': 'Ristorante',
    'shift.restaurantSelector.placeholder': 'Seleziona un ristorante',
    'shift.column.name': 'Nome',
    'shift.column.restaurant': 'Ristorante',
    'shift.column.daysOfWeek': 'Giorni',
    'shift.column.hours': 'Orari',
    'shift.column.isEnabled': 'Attivato',
    'shift.column.isDefault': 'Predefinito',
    'shift.column.action': 'Azione',
    'shift.badge.enabled': 'Attivato',
    'shift.badge.disabled': 'Disattivato',
    'shift.badge.default': 'Predefinito',
    'shift.day.MON': 'Lun',
    'shift.day.TUE': 'Mar',
    'shift.day.WED': 'Mer',
    'shift.day.THU': 'Gio',
    'shift.day.FRI': 'Ven',
    'shift.day.SAT': 'Sab',
    'shift.day.SUN': 'Dom',
    'shift.form.title.create': 'Nuovo servizio',
    'shift.form.title.edit': 'Modifica servizio',
    'shift.form.subtitle': 'Definisci i giorni, gli orari e le opzioni del servizio.',
    'shift.field.name': 'Nome',
    'shift.field.name.placeholder': 'Es. Servizio pranzo',
    'shift.field.restaurant': 'Ristorante',
    'shift.field.restaurant.placeholder': 'Seleziona un ristorante',
    'shift.field.restaurant.hint.edit': 'Il ristorante non può essere modificato dopo la creazione.',
    'shift.field.daysOfWeek': 'Giorni della settimana',
    'shift.field.daysOfWeek.placeholder': 'Seleziona i giorni',
    'shift.field.start': 'Inizio',
    'shift.field.end': 'Fine',
    'shift.field.endsTomorrow': 'Termina il giorno successivo',
    'shift.field.color': 'Colore',
    'shift.field.isEnabled': 'Servizio attivo',
    'shift.field.isDefault': 'Servizio predefinito',
    'shift.field.isDefault.hint': 'Il servizio predefinito non può essere modificato dopo la creazione.',
    'shift.error.daysOfWeek.required': 'Seleziona almeno un giorno.',
    'shift.error.hours.format': 'Formato non valido (HH:mm).',
    'shift.error.hours.inconsistency': "L'ora di fine deve essere dopo l'ora di inizio.",
    'shift.error.color.format': 'Colore non valido.',
    'shift.delete.modal.warning': 'Attenzione',
    'shift.delete.modal.confirmDelete': 'Sei sicuro di voler eliminare questo servizio?',
    'shift.delete.modal.title': 'Eliminazione non consentita',
    'shift.delete.modal.defaultBlocked': 'Il servizio predefinito non può essere eliminato.',
    'shift.api.error.shift_cannot_delete_default': 'Il servizio predefinito non può essere eliminato.',
    'shift.api.error.shift_overlap': 'Il servizio si sovrappone a un servizio esistente.',
    'shift.api.error.shift_default_already_exists': 'Esiste già un servizio predefinito per questo ristorante.',
    'shift.api.error.shift_wrong_days_of_week_format': 'Formato giorni non valido.',
    'shift.api.error.shift_wrong_hours_format': 'Formato orari non valido.',
    'shift.api.error.shift_hours_inconsistency': "L'ora di inizio deve essere inferiore all'ora di fine.",
    'shift.api.error.shift_cannot_edit_default': 'Il servizio predefinito non può essere modificato.',
};

export default translationIt;
